(function () {
  'use strict';

  if (window.__skywebS2bInit) return;
  window.__skywebS2bInit = true;

  function readWeakGpu() {
    var renderer = '';
    try {
      var probe = document.createElement('canvas');
      var gl = probe.getContext('webgl') || probe.getContext('experimental-webgl');
      if (!gl) return '';
      var info = gl.getExtension('WEBGL_debug_renderer_info');
      if (info) renderer = String(gl.getParameter(info.UNMASKED_RENDERER_WEBGL) || '');
      var lose = gl.getExtension('WEBGL_lose_context');
      if (lose) lose.loseContext();
    } catch (eGpu) {}
    return renderer;
  }

  function detectWeakMobile() {
    if ((window.innerWidth || 0) > 768) return false;
    var mem = navigator.deviceMemory;
    /* Prohlížeč zaokrouhlí 4–7 GB dolů na 4, takže „4“ ještě není slabý telefon. */
    if (typeof mem === 'number' && mem < 4) return true;
    var cores = navigator.hardwareConcurrency || 0;
    if (cores > 0 && cores <= 4) return true;
    var gpu = readWeakGpu();
    if (/Mali-G5|Mali-G71|Mali-T|Adreno(?:\s|\(TM\))?5\d{2}|Adreno(?:\s|\(TM\))?61\d|PowerVR|Apple A(9|10|11|12)\b/i.test(gpu)) return true;
    return false;
  }

  var IS_WEAK_MOBILE = detectWeakMobile();
  window.__mojeIsWeakMobile = IS_WEAK_MOBILE;
  if (IS_WEAK_MOBILE) document.documentElement.classList.add('moje-lite');
  var coresAtBoot = navigator.hardwareConcurrency || 0;
  var memAtBoot = navigator.deviceMemory;
  var IS_STRONG_MOBILE = !IS_WEAK_MOBILE && (window.innerWidth || 0) <= 768 && coresAtBoot >= 8 && (typeof memAtBoot !== 'number' || memAtBoot >= 6);
  window.__mojeIsStrongMobile = IS_STRONG_MOBILE;

  function initMojeS2bSection(configEl) {
    if (!configEl) return;

    function parseLastFrameUrl(url) {
      var clean = String(url || '').trim();
      if (!clean) return null;
      var queryIndex = clean.indexOf('?');
      var base = queryIndex >= 0 ? clean.slice(0, queryIndex) : clean;
      var query = queryIndex >= 0 ? clean.slice(queryIndex) : '';
      var match = base.match(/^(.*?)(\d+)(\.[a-zA-Z0-9]+)$/);
      if (!match) return null;
      return { prefix: match[1], count: parseInt(match[2], 10), pad: match[2].length, ext: match[3], query: query };
    }

    function buildFrameUrlList(parts) {
      var urls = [];
      var i;
      if (!parts || !parts.count) return urls;
      for (i = 1; i <= parts.count; i += 1) {
        urls.push(parts.prefix + String(i).padStart(parts.pad, '0') + parts.ext + parts.query);
      }
      return urls;
    }

    function frameUrlsFromRaw(raw, maxCount) {
      var parsed = parseLastFrameUrl(raw);
      if (!parsed) return [];
      var cap = parsed.count;
      if (maxCount > 0) cap = Math.min(cap, maxCount);
      if (cap < 1) return [];
      parsed.count = cap;
      return buildFrameUrlList(parsed);
    }

    function withRequestedWidth(url, width) {
      return withRequestedSize(url, { width: width });
    }

    function withRequestedSize(url, opts) {
      opts = opts || {};
      try {
        var u = new URL(url, window.location.href);
        if (opts.width) u.searchParams.set('width', String(opts.width));
        else u.searchParams.delete('width');
        if (opts.height) u.searchParams.set('height', String(opts.height));
        else u.searchParams.delete('height');
        if (opts.crop) u.searchParams.set('crop', String(opts.crop));
        else u.searchParams.delete('crop');
        if (opts.crop === 'region') {
          u.searchParams.set('crop_left', String(opts.cropLeft || 0));
          u.searchParams.set('crop_top', String(opts.cropTop || 0));
          u.searchParams.set('crop_width', String(opts.cropWidth || 0));
          u.searchParams.set('crop_height', String(opts.cropHeight || 0));
        } else {
          u.searchParams.delete('crop_left');
          u.searchParams.delete('crop_top');
          u.searchParams.delete('crop_width');
          u.searchParams.delete('crop_height');
        }
        return u.toString();
      } catch (e) {
        return url;
      }
    }

    var config = JSON.parse(configEl.textContent);
    var sectionId = config.sectionId;
    var root = document.getElementById('moje-s2b-' + sectionId);
    if (!root) return;

    var innerEl = root.querySelector('.moje-s2b__inner');
    var hazeBridgeEl = root.querySelector('.moje-s2b__haze-bridge');
    var introOverlayEl = root.querySelector('.moje-s2b__intro-overlay');
    var pinSpacer = root.querySelector('.moje-s2b__pin-spacer');
    var scrollHintEl = document.getElementById('moje-s2b-scroll-hint-' + sectionId);
    var scrollHintGone = false;
    var seqMouseEl = document.getElementById('moje-s2b-seq-mouse-' + sectionId);
    var canvas = document.getElementById('moje-s2b-canvas-' + sectionId);
    var loader = document.getElementById('moje-s2b-loader-' + sectionId);
    var loaderFill = document.getElementById('moje-s2b-loader-fill-' + sectionId);
    var loaderPct = document.getElementById('moje-s2b-loader-pct-' + sectionId);
    var pricingScene = document.getElementById('moje-s2b-pricing-' + sectionId);
    var pricingVideoLayer = document.getElementById('moje-s2b-pricing-video-layer-' + sectionId);
    var pricingVideo = document.getElementById('moje-s2b-pricing-video-' + sectionId);
    var pricingVideoMapEl = document.getElementById('moje-s2b-pricing-video-map-' + sectionId);
    var terraformDock = document.getElementById('moje-s2b-terraform-dock-' + sectionId);
    var pricingCarousel = document.getElementById('moje-s2b-pricing-cards-' + sectionId);
    var pricingCarouselWrap = document.getElementById('moje-s2b-pricing-carousel-wrap-' + sectionId);

    (function stylePricingSupportRows() {
      if (!pricingCarousel) return;
      var items = pricingCarousel.querySelectorAll('.moje-s2b__pricing-features li');
      var i;
      var text;
      for (i = 0; i < items.length; i += 1) {
        text = (items[i].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (!text) {
          items[i].hidden = true;
          continue;
        }
        items[i].classList.remove('moje-s2b__feature-support--none', 'moje-s2b__feature-support--ok');
        if (text.indexOf('žádná podpora') !== -1) {
          items[i].classList.add('moje-s2b__feature-support--none');
        } else if (text.indexOf('podpora') !== -1) {
          items[i].classList.add('moje-s2b__feature-support--ok');
        }
      }
    })();
    var pricingTouchOverlay = document.getElementById('moje-s2b-pricing-touch-' + sectionId);
    var bufferEl = document.getElementById('moje-s2b-buffer-' + sectionId);
    var bufferMistEl = document.getElementById('moje-s2b-buffer-mist-' + sectionId);

    var ctx = canvas ? canvas.getContext('2d', { alpha: true }) : null;
    var webmPlaybackSupported = (function () {
      try {
        var probe = document.createElement('video');
        if (!probe || typeof probe.canPlayType !== 'function') return false;
        return !!(
          probe.canPlayType('video/webm; codecs="vp9"') ||
          probe.canPlayType('video/webm; codecs="vp8"') ||
          probe.canPlayType('video/webm')
        );
      } catch (eWebmProbe) {
        return false;
      }
    })();

    function sanitizeVideoCatalogEntry(entry) {
      if (!entry) return entry;
      if (!webmPlaybackSupported && entry.webm) entry.webm = '';
      return entry;
    }

    var MOBILE_MAX = 989;
    var INTRO_FADE_LAST_FRAME_DEFAULT = 17;
    /* Mobil: černý rozpad odshora na snímcích 1–24, na 25. (index 24) už nic. */
    var MOBILE_TOP_DECAY_GONE_INDEX = 24;
    var MOBILE_TOP_DECAY_MAX_RATIO = 0.22;
    function isMobileViewport() {
      return window.innerWidth <= MOBILE_MAX;
    }

    /* Široká média (PC 16:9): desktop, nebo mobil otočený na šířku.
       Videa, sekvence i rozložení karet (bez karuselu). Těžké PC efekty karet ne.

       Detekce orientace je striktní: screen.orientation (fyzická orientace zařízení, klávesnice
       ji nemění) → fallback matchMedia('(orientation: landscape)'). Dřívější porovnání
       innerWidth > innerHeight přepnulo na PC pack (40+ MB) při otevření klávesnice na Androidu. */
    var landscapeMq = null;
    var coarseTouchMq = null;
    try {
      landscapeMq = window.matchMedia ? window.matchMedia('(orientation: landscape)') : null;
      coarseTouchMq = window.matchMedia ? window.matchMedia('(hover: none) and (pointer: coarse)') : null;
    } catch (eLandMq) {
      landscapeMq = null;
      coarseTouchMq = null;
    }
    function deviceIsLandscape() {
      /* Dotykové zařízení: fyzická orientace (Android klávesnice viewport zmenší, ale telefon neotočí). */
      if (coarseTouchMq && coarseTouchMq.matches) {
        try {
          var so = window.screen && window.screen.orientation;
          if (so && typeof so.type === 'string' && so.type) {
            return so.type.indexOf('landscape') === 0;
          }
        } catch (eSo) {}
      }
      /* PC s úzkým oknem / starší prohlížeče: orientace viewportu. */
      return !!(landscapeMq && landscapeMq.matches);
    }
    function detectWideMedia() {
      if (typeof window.mojeDetectWideMedia === 'function') return !!window.mojeDetectWideMedia();
      if ((window.innerWidth || 0) > MOBILE_MAX) return true;
      return deviceIsLandscape();
    }

    /* Stažení řídí až ustálený pack (data-moje-wide). Živá orientace se smí třepat 500 ms. */
    function useWideMediaAssets() {
      var flag = document.documentElement.getAttribute('data-moje-wide');
      if (flag === '1') return true;
      if (flag === '0') return false;
      return detectWideMedia();
    }

    function useDesktopSequenceAssets() {
      return useWideMediaAssets();
    }

    function useMobileMediaAssets() {
      return !useWideMediaAssets();
    }

    function syncWideMediaClass() {
      if (!root) return;
      var wide = useWideMediaAssets();
      root.classList.toggle('moje-s2b--wide-media', wide);
      if (wide && pricingCarousel) {
        try { pricingCarousel.scrollLeft = 0; } catch (eSl) {}
      }
    }

    var sequenceByStage = config.sequences || {};
    function sequencePack(stage) {
      var id = stage === 1 || stage === 3 ? String(stage) : '2';
      return sequenceByStage[id] || sequenceByStage[stage] || {};
    }
    function wantMobilePack(packHint) {
      if (packHint === 'd' || packHint === 'desktop') return false;
      if (packHint === 'm' || packHint === 'mobile') return true;
      return useMobileMediaAssets();
    }

    /*
     * Přesné délky WebP sad. URL může mít vyšší číslo v názvu — seznam se ořízne,
     * aby vlna ani scroll nežádaly snímek, který v sadě není.
     */
    var CARD_FRAME_PLAN = {
      1: { label: 'STARTUP (Karta 1)', wide: 185, portrait: 92 },
      2: { label: 'EXPANZE (Karta 2 - default)', wide: 185, portrait: 93 },
      3: { label: 'IMPÉRIUM (Karta 3)', wide: 185, portrait: 93 }
    };

    function cardFramePlan(stage) {
      var id = stage === 1 || stage === 3 ? stage : 2;
      return CARD_FRAME_PLAN[id];
    }

    function expectedFrameCount(stage, packHint) {
      var plan = cardFramePlan(stage);
      return wantMobilePack(packHint) ? plan.portrait : plan.wide;
    }

    function sequenceUrlsFor(stage, packHint) {
      var pack = sequencePack(stage);
      var desktopRaw = pack.lastFrameUrl || (stage === 2 || stage === '2' ? config.lastFrameUrl : '');
      var mobileRaw = pack.lastFrameUrlMobile || (stage === 2 || stage === '2' ? config.lastFrameUrlMobile : '');
      var desktop = frameUrlsFromRaw(desktopRaw, expectedFrameCount(stage, 'd'));
      var mobile = frameUrlsFromRaw(mobileRaw, expectedFrameCount(stage, 'm'));
      /* Na výšku nikdy nespadnout na PC snímky, i když mobilní sekvence chybí. */
      if (wantMobilePack(packHint)) {
        if (mobile.length) return mobile;
        if (String(stage) !== '2') return sequenceUrlsFor(2, packHint);
        return mobile;
      }
      if (desktop.length) return desktop;
      if (String(stage) !== '2') return sequenceUrlsFor(2, packHint);
      return desktop;
    }
    function resolveSequenceStage(stage) {
      var id = stage === 1 || stage === 3 ? stage : 2;
      if (sequenceUrlsFor(id).length) return id;
      return 2;
    }

    var sequenceStore = {};
    var activeSequenceStage = 2;
    /* Dokud stránka nedoběhne (window.onload) nebo uživatel neaktivuje kartu, smí se stáhnout jen první snímek aktivní sekvence. */
    var sequenceFramesUnlocked = false;
    var activeSequenceBackgroundArmed = false;
    var loadingWave1Only = false;
    var deferredDomMediaReleased = false;
    var sequenceLoadSilent = false;
    var sequenceSwitchReady = false;
    var sequenceLoadFromEnd = false;
    var sequenceLayoutFrozen = false;
    var seqLoadQueue = [];
    var seqLoadInFlight = 0;
    var seqLoadPumping = false;
    var seqLoadPumpTimer = 0;
    var seqLoadIdleQueued = false;
    var seqLoadFromIdle = false;
    var bgQueueStarted = false;
    var silentPhase = '';
    var orientEpoch = 0;
    var orientHydrateActiveOnly = false;
    var orientHandoffImg = null;
    var orientSwapActive = false;

    function activeFrameUrls() {
      return sequenceUrlsFor(activeSequenceStage);
    }

    var frameUrls = activeFrameUrls();
    var images = [];
    var totalFrames = frameUrls.length;
    var maxFrameIndex = Math.max(0, totalFrames - 1);
    var loadedCount = 0;
    var currentFrameIndex = 0;
    var paintTargetIndex = 0;
    var lastDrawnIndex = -1;
    var viewportW = 0;
    var viewportH = 0;
    var canvasCssW = 0;
    var canvasCssH = 0;
    var pinStartY = 0;
    var pinStartCached = false;
    var sequencePx = 0;
    var bufferPx = 0;
    var pricingPx = 0;
    var lastAppliedMinHeightPx = '';
    var lastAppliedTravelPx = 0;
    var lastAppliedHazePx = 0;
    var lastAppliedVhPx = '';
    var lastViewportWForMetrics = -1;
    var ignoreMetricsUntil = 0;
    var autoplayConsumed = false;
    var autoplayPlaying = false;
    var pendingAutoplayFromNav = false;
    var pendingAutoplayWatchRaf = 0;
    var pendingAutoplayScrollEnded = false;
    var pendingAutoplaySettledFrames = 0;
    var pendingContinueAfterAutoplayY = NaN;
    var chromeLockMode = '';
    var terraformLockY = 0;
    var programmaticNavUntil = 0;
    var programmaticNavTimer = 0;
    var programmaticTargetY = NaN;
    var journey = 'pre';
    var atPricing = false;
    var belowArmed = false;
    var lastScrollYForDir = 0;
    var pricingFlingVelInited = false;
    var pricingScrollVelPxMs = 0;
    var pricingFlingVelTs = 0;
    var pricingFlingArmed = true;
    var pricingFlingStopActive = false;
    var pricingFlingFrozen = false;
    var pricingFlingLockY = null;
    var pricingFlingHoldUntil = 0;
    var pricingFlingReleaseTimer = 0;
    var pricingFlingSafetyTimer = 0;
    var pricingFlingFreezeRaf = 0;
    var pricingFlingTouchActive = false;
    var pricingFlingPrevHtmlOverflow = '';
    var pricingFlingPrevBodyOverflow = '';
    var pricingFlingPrevHtmlOverscroll = '';
    var pricingFlingPrevBodyOverscroll = '';
    var PRICING_FLING_VEL_PX_MS = 1.25;
    var PRICING_FLING_JUMP_PX = 110;
    var PRICING_FLING_HOLD_MS = 100;
    var pricingSettleUntil = 0;
    var sequenceEnterUntil = 0;
    var autoplayRaf = 0;
    var autoplayLastTs = 0;
    var autoplayFrameAcc = 0;
    var autoplayLockY = 0;
    var pricingVisible = false;
    var pricingLocked = false;
    var pricingExiting = false;
    var pricingFadeGen = 0;
    var pricingCardsExitSceneTimer = 0;
    var pricingSeqRestoreTimer = 0;
    var pricingFadeCooldownUntil = 0;
    var pricingFadeRetryTimer = 0;
    var suppressPricingRelockUntil = 0;
    var pricingTouchY = null;
    var currentPricingStage = 2;
    var sessionResumeApi = window.mojeSessionResume;
    var sessionResumeS2b =
      sessionResumeApi && typeof sessionResumeApi.getS2b === 'function'
        ? sessionResumeApi.getS2b()
        : null;
    if (window.__mojeColdStart) sessionResumeS2b = null;
    if (window.__mojeContactPostedStay && isMobileViewport()) {
      sessionResumeS2b = null;
      autoplayConsumed = true;
    }
    if (
      sessionResumeS2b &&
      typeof sessionResumeS2b === 'object' &&
      sessionResumeApi &&
      (sessionResumeApi.active || sessionResumeApi.restoring)
    ) {
      if (
        sessionResumeS2b.autoplayConsumed ||
        sessionResumeS2b.autoplayPlaying ||
        sessionResumeS2b.pricingLocked ||
        sessionResumeS2b.journey === 'autoplay' ||
        sessionResumeS2b.journey === 'sequence' ||
        sessionResumeS2b.journey === 'buffer' ||
        sessionResumeS2b.journey === 'pricing' ||
        sessionResumeS2b.journey === 'below'
      ) {
        autoplayConsumed = true;
      }
      if (sessionResumeS2b.pricingStage >= 1 && sessionResumeS2b.pricingStage <= 3) {
        currentPricingStage = sessionResumeS2b.pricingStage;
        activeSequenceStage = resolveSequenceStage(currentPricingStage);
      }
      if (Number.isFinite(sessionResumeS2b.frameIndex)) {
        currentFrameIndex = Math.max(0, Math.min(maxFrameIndex, sessionResumeS2b.frameIndex | 0));
      }
    }
    var pricingCarouselScrollBound = false;
    var pricingFeaturesExpandBound = false;
    var pricingZoneTouchStartX = null;
    var pricingZoneTouchStartY = null;
    var pricingZoneTouchLastX = null;
    var pricingZoneTouchLastY = null;
    var pricingZoneTouchAxis = null;
    var pricingZoneTapCardStage = null;
    var pricingZoneTapExpandBtn = null;
    var pricingZoneTapHintDir = null;
    var pricingZoneDragStartStage = null;
    var PRICING_ZONE_TOUCH_THRESHOLD = 8;
    var PRICING_ZONE_TAP_SLOP = 14;
    var PRICING_CAROUSEL_SWIPE_ADVANCE_RATIO = 0.12;
    var PRICING_CAROUSEL_FLICK_RATIO = 0.05;
    var PRICING_CAROUSEL_FLICK_VEL = 0.42;
    var PRICING_CAROUSEL_DRAG_GAIN = 0.62;
    var pricingCarouselSnapSettleTimer = null;
    var pricingCarouselScrollAnimRaf = null;
    var pricingCarouselPreviewRaf = null;
    var pricingCarouselTouchVelocityPxMs = 0;
    var pricingCarouselTouchLastTs = 0;
    var pricingCarouselCentersCache = null;
    var pricingCarouselCentersCacheW = 0;
    var pricingCarouselDragPendingDx = 0;
    var pricingCarouselDragRaf = 0;
    var pricingCarouselProgrammaticScroll = false;
    var lastPricingCarouselPreviewStage = null;
    var pricingBgPanCurrent = 0;
    var pricingBgPanTarget = 0;
    var pricingBgPanAnimRaf = null;
    var pricingBgPanLocked = false;
    var pricingBgPanLockedValue = 0;
    var PRICING_BG_PAN_LERP = 0.07;
    var PRICING_BG_PAN_FRACTION = 0.52;
    var pricingMediaAspect = useWideMediaAssets() ? 16 / 9 : 9 / 16;
    var pricingTransitioning = false;
    var pricingTransitionFinishLock = false;
    var pricingTransitionFailTimer = 0;
    var pricingVideoEndWatchRaf = 0;
    var pricingDestCoverTimer = 0;
    var detachPricingVideoReadyListeners = function () {};
    var PRICING_VIDEO_FREEZE_TAIL_S = 0.05;
    var PRICING_CARDS_EXIT_MIN_MS = 280;
    var PRICING_CARDS_EXIT_FADE_MS = 2000;
    var PRICING_CARDS_RESTORE_MS = 450;
    var rafScheduled = false;
    var mobileFixedPin = false;
    /* Fixed pin jen z autoplay/sekvence. Zespodu nechat sticky, ať karty neposkočí. */
    var pricingUseFixedPin = false;

    function clampAutoplayFps(value, fallback) {
      var n = Number(value);
      if (!Number.isFinite(n)) n = fallback;
      if (!Number.isFinite(n)) n = 24;
      return Math.max(8, Math.min(60, n));
    }
    function clampSequenceScrollVh(value, fallback) {
      var n = Number(value);
      if (!Number.isFinite(n)) n = fallback;
      if (!Number.isFinite(n)) n = 4;
      return Math.max(1, Math.min(14, n));
    }
    var autoplayFpsDesktop = clampAutoplayFps(config.autoplayFps, 24);
    var autoplayFpsMobile = clampAutoplayFps(config.autoplayFpsMobile, autoplayFpsDesktop);
    var sequenceScrollVhDesktop = clampSequenceScrollVh(config.sequenceScrollVh, 4);
    var sequenceScrollVhMobile = clampSequenceScrollVh(config.sequenceScrollVhMobile, sequenceScrollVhDesktop);
    function activeAutoplayFps() {
      return isMobileViewport() ? autoplayFpsMobile : autoplayFpsDesktop;
    }
    function activeSequenceScrollVh() {
      return isMobileViewport() ? sequenceScrollVhMobile : sequenceScrollVhDesktop;
    }
    /*
     * Auto-play startuje až po načtení všech snímků karty. Když přehrávání
     * přesto narazí na chybějící snímek, drží se poslední hotový a pokračuje
     * po doplnění AUTOPLAY_REBUFFER_FRAMES.
     */
    var AUTOPLAY_REBUFFER_FRAMES = 6;
    var AUTOPLAY_REBUFFER_GIVEUP_MS = 6000;
    var autoplayRebufferUntil = -1;
    var autoplayRebufferSince = 0;
    var autoplayWaitingForRunway = false;
    /*
     * Dekódovací okno kolem aktuálního snímku – jen HINT přes img.decode():
     *   - asynchronní, mimo hlavní vlákno (Chromium: cc decode cache, WebKit: purgeable);
     *   - prohlížeč drží dekódovaná data v limitované, uvolnitelné cache → žádný jetsam na iOS,
     *     žádné vlastní ImageBitmapy (createImageBitmap(<img>) je v Chromiu synchronní na hlavním
     *     vlákně → sekání při scrubu; asynchronní je jen z Blobu).
     * Okno je směrové: víc snímků ve směru pohybu (autoplay / scroll), pár zpět.
     * Nikdy se nedekóduje celá sekvence najednou (185 × 8 MB RGBA).
     *
     * Chromium: img.decode() plní cache kompozitoru, ne cache 2D canvasu (drawImage dekóduje sám
     * a drží LRU cache ve sdíleném GPU kontextu) → hint tam nepomůže a jen zaměstnává raster
     * workery během scrollu. Hinty proto jen WebKit/Firefox, kde je dekódovaná bitmapa sdílená.
     */
    var DECODE_HINTS_ENABLED = (function () {
      if (IS_WEAK_MOBILE) return false;
      var ua = navigator.userAgent || '';
      if (/iP(hone|ad|od)/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) return false;
      if (typeof window.chrome === 'object' && window.chrome) return false;
      return !/Chrome|Chromium|Edg\/|OPR\//.test(ua);
    })();
    var DECODE_AHEAD = isMobileViewport() ? 12 : 24;
    var DECODE_BEHIND = 6;
    var DECODE_REPRIME_MS = 1500;
    var decodeWindowLo = -1;
    var decodeWindowHi = -1;
    var decodeWindowCenter = -1;
    var decodeWindowDir = 1;
    var decodeStoreRef = null;
    var bufferVh = Number(config.bufferVh);
    if (!Number.isFinite(bufferVh)) bufferVh = 50;
    bufferVh = Math.max(20, Math.min(80, bufferVh));
    var BUFFER_DEAD_PCT = 0.25;
    var dockAnchorTimer = 0;
    var dockAnchorDir = 0;
    var lastDockAnchorY = 0;
    var dockSnapLockUntil = 0;

    function sanitizeVideoMapGroup(group) {
      var out = {};
      if (!group || typeof group !== 'object') return out;
      Object.keys(group).forEach(function (key) {
        if (key === 'desktop' || key === 'mobile') return;
        out[key] = sanitizeVideoCatalogEntry(group[key] || {});
      });
      return out;
    }

    var pricingVideoMap = { desktop: {}, mobile: {} };
    try {
      var rawVideoMap = pricingVideoMapEl ? JSON.parse(pricingVideoMapEl.textContent) : {};
      if (rawVideoMap.desktop || rawVideoMap.mobile) {
        pricingVideoMap = {
          desktop: sanitizeVideoMapGroup(rawVideoMap.desktop),
          mobile: sanitizeVideoMapGroup(rawVideoMap.mobile)
        };
      } else {
        pricingVideoMap = {
          desktop: sanitizeVideoMapGroup(rawVideoMap),
          mobile: {}
        };
      }
    } catch (eMap) {
      pricingVideoMap = { desktop: {}, mobile: {} };
    }
    var TERRAFORM_KEYS = ['1-2', '1-3', '2-1', '2-3', '3-1', '3-2'];
    var terraformVideos = {};
    var terraformPreloadStarted = false;
    var terraformNudgeArmed = false;
    var pricingCardsInView = false;
    var mediaPackSyncTimer = 0;
    var lastMediaPackId = useWideMediaAssets() ? 'd' : 'm';
    var terraformWarmed = {};
    var terraformWarmQueued = {};
    /* Celé soubory 2 přechodů z aktuální karty. Klíč je pack:přechod, hodnota drží blob URL. */
    var terraformFileCache = {};
    var terraformFileDelayTimer = 0;
    var terraformFileInitialQueued = false;
    var terraformFileInitialPumped = false;

    function getViewportH() {
      if (typeof window.mojeGetStableViewportHeight === 'function') {
        var stable = window.mojeGetStableViewportHeight();
        if (stable > 120) return stable;
      }
      var cssPx = 0;
      try {
        var raw = getComputedStyle(document.documentElement).getPropertyValue('--moje-vh-px').trim();
        if (raw && raw.indexOf('px') !== -1) cssPx = parseFloat(raw);
      } catch (eVh) {}
      if (cssPx > 120) return cssPx;
      return window.innerHeight || 800;
    }

    function getScrollY() {
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    function setScrollY(y) {
      var target = Math.max(0, y);
      var html = document.documentElement;
      var prevHtml = html.style.scrollBehavior;
      var prevBody = document.body ? document.body.style.scrollBehavior : '';
      html.style.scrollBehavior = 'auto';
      if (document.body) document.body.style.scrollBehavior = 'auto';
      if (typeof window.scrollTo === 'function') {
        try {
          window.scrollTo({ top: target, left: 0, behavior: 'instant' });
        } catch (eInstant) {
          window.scrollTo(0, target);
        }
      }
      html.style.scrollBehavior = prevHtml;
      if (document.body) document.body.style.scrollBehavior = prevBody;
    }

    function sequenceEndY() {
      return pinStartY + Math.max(0, sequencePx);
    }

    function bufferStartY() {
      return sequenceEndY();
    }

    function pricingDockY() {
      return bufferStartY() + Math.max(0, bufferPx);
    }

    function pricingSnapY() {
      return pricingDockY();
    }

    function travelFor() {
      return sequencePx + bufferPx;
    }

    function journeyTravelPx() {
      return travelFor(journey);
    }

    function measureHazeHeight() {
      if (!hazeBridgeEl || !useDesktopSequenceAssets()) return 0;
      var h = hazeBridgeEl.getBoundingClientRect().height;
      if (!Number.isFinite(h) || h < 1) return 0;
      return Math.round(h);
    }

    function introImageEl() {
      var sel = '[data-s2b-crop-kind="intro"][data-s2b-seq-phase="' + activeSequenceStage + '"]';
      var fallback = '[data-s2b-crop-kind="intro"].is-active';
      if (introOverlayEl) {
        var overlayImg = introOverlayEl.querySelector(sel) || introOverlayEl.querySelector(fallback);
        if (overlayImg) return overlayImg;
      }
      if (hazeBridgeEl) {
        return hazeBridgeEl.querySelector(sel) || hazeBridgeEl.querySelector(fallback);
      }
      return null;
    }

    function sequenceCoverScale(seqW, seqH, cw, ch) {
      if (!(seqW > 0) || !(seqH > 0) || cw < 2 || ch < 2) return 0;
      return Math.max(cw / seqW, ch / seqH);
    }

    function sequenceRefImage() {
      if (images[0] && images[0].naturalWidth) return images[0];
      if (images[currentFrameIndex] && images[currentFrameIndex].naturalWidth) {
        return images[currentFrameIndex];
      }
      var i;
      for (i = images.length - 1; i >= 0; i -= 1) {
        if (images[i] && images[i].naturalWidth) return images[i];
      }
      return null;
    }

    function syncIntroLayout() {
      if (sequenceLayoutFrozen) return;
      var maskImg = introImageEl();
      var seqImg = sequenceRefImage();
      var extra = 0;
      var cw = canvasCssW || (innerEl && innerEl.clientWidth) || viewportW || 0;
      var ch = canvasCssH || viewportH || (innerEl && innerEl.clientHeight) || 0;

      function resetIntroBox() {
        root.style.setProperty('--moje-s2b-intro-extra-px', '0px');
        if (hazeBridgeEl) hazeBridgeEl.style.height = '0px';
      }

      if (!useDesktopSequenceAssets()) {
        resetIntroBox();
        return;
      }
      if (!maskImg || cw < 2 || ch < 2) {
        return;
      }

      var srcW = Number(maskImg.getAttribute('data-s2b-haze-w')) || maskImg.naturalWidth;
      var srcH = Number(maskImg.getAttribute('data-s2b-haze-h')) || maskImg.naturalHeight;
      if (!(srcW > 1) || !(srcH > 1)) {
        srcW = maskImg.naturalWidth;
        srcH = maskImg.naturalHeight;
      }
      if (!(srcW > 1) || !(srcH > 1)) {
        return;
      }

      var seqW = 0;
      var seqH = 0;
      if (seqImg && seqImg.naturalWidth && (seqImg.naturalWidth / seqImg.naturalHeight) > 1.2) {
        seqW = seqImg.naturalWidth;
        seqH = seqImg.naturalHeight;
      } else {
        seqW = srcW;
        seqH = srcW * 9 / 16;
      }
      var scale = sequenceCoverScale(seqW, seqH, cw, ch);
      if (!(scale > 0)) {
        resetIntroBox();
        return;
      }

      var pxPerMask = scale * (seqW / srcW);
      var displayW = srcW * pxPerMask;
      var displayH = srcH * pxPerMask;
      var seqDh = seqH * scale;
      extra = Math.max(0, Math.round(displayH - seqDh));
      var left = Math.round((cw - displayW) * 0.5);
      var srcAspect = srcW / srcH;
      var natW = maskImg.naturalWidth || srcW;
      var natH = maskImg.naturalHeight || srcH;
      var natAspect = natW / natH;
      var placeAsStrip = srcAspect > 0 && natAspect < srcAspect * 0.85;

      function place(wrap, topPx) {
        if (!wrap) return;
        var el = wrap.querySelector('[data-s2b-crop-kind="intro"][data-s2b-seq-phase="' + activeSequenceStage + '"]') ||
          wrap.querySelector('[data-s2b-crop-kind="intro"].is-active');
        if (!el) return;
        el.style.position = 'absolute';
        el.style.right = 'auto';
        el.style.bottom = 'auto';
        el.style.top = Math.round(topPx) + 'px';
        el.style.maxWidth = 'none';
        el.style.height = Math.round(displayH) + 'px';
        el.style.objectFit = 'fill';
        if (placeAsStrip) {
          el.style.left = '0px';
          el.style.width = Math.round(cw) + 'px';
        } else {
          el.style.left = left + 'px';
          el.style.width = Math.round(displayW) + 'px';
        }
      }

      root.style.setProperty('--moje-s2b-intro-extra-px', extra + 'px');
      if (hazeBridgeEl) {
        hazeBridgeEl.style.height = extra + 'px';
        place(hazeBridgeEl, 0);
      }
      if (introOverlayEl) place(introOverlayEl, -extra);
    }

    function introFadeLastFrame(stage) {
      var pack = sequencePack(stage == null ? activeSequenceStage : stage);
      var n = Number(pack && pack.introFadeFrame);
      if (!Number.isFinite(n)) n = INTRO_FADE_LAST_FRAME_DEFAULT;
      n = Math.max(2, Math.min(100, Math.round(n)));
      if (totalFrames > 1) n = Math.min(n, totalFrames);
      return n;
    }

    function syncIntroFade(frameIndex) {
      var lastFrame = introFadeLastFrame();
      var i = (frameIndex | 0) + 1;
      var op = 1;
      if (i >= lastFrame) op = 0;
      else if (i > 1 && lastFrame > 1) op = 1 - (i - 1) / (lastFrame - 1);
      var opShown = op <= 0.001 ? '0' : (op >= 0.999 ? '1' : op.toFixed(2));
      var vis = op > 0.001 ? 'visible' : 'hidden';
      if (introOverlayEl) {
        if (introOverlayEl.__mojeOp !== opShown) {
          introOverlayEl.__mojeOp = opShown;
          introOverlayEl.style.opacity = opShown;
        }
        if (introOverlayEl.__mojeVis !== vis) {
          introOverlayEl.__mojeVis = vis;
          introOverlayEl.style.visibility = vis;
        }
      }
      if (hazeBridgeEl && hazeBridgeEl.__mojeOp !== opShown) {
        hazeBridgeEl.__mojeOp = opShown;
        hazeBridgeEl.style.opacity = opShown;
      }
    }

    function measurePinStart() {
      if (!root) return 0;
      var rect = root.getBoundingClientRect();
      return getScrollY() + rect.top + measureHazeHeight();
    }

    function refreshPinStart(force) {
      if (!force && pinStartCached && pinStartY > 0) return;
      pinStartY = measurePinStart();
      pinStartCached = pinStartY > 0 || getScrollY() < 2;
    }

    function applySectionHeight(opts) {
      opts = opts || {};
      if (sequenceLayoutFrozen && !opts.force) return;
      var nextTravel = journeyTravelPx();
      var hazePx = measureHazeHeight();
      var minHeightPx = Math.max(1, Math.round(hazePx + viewportH + nextTravel)) + 'px';
      var prevTravel = lastAppliedTravelPx;
      var prevHaze = lastAppliedHazePx;
      var y = getScrollY();
      if (lastAppliedMinHeightPx !== minHeightPx) {
        lastAppliedMinHeightPx = minHeightPx;
        lastAppliedTravelPx = nextTravel;
        lastAppliedHazePx = hazePx;
        root.style.minHeight = minHeightPx;
        /*
         * Sekvence nahoře zvětšuje/zmenšuje dokument pod pinStartY.
         * Kompenzuj scrollY, ať karta/následující obsah vizuálně neskočí.
         */
        if (opts.compensate !== false && pinStartCached && y >= pinStartY - 2) {
          var delta = (nextTravel - prevTravel) + (hazePx - prevHaze);
          if (Math.abs(delta) > 1) setScrollY(y + delta);
        }
      } else {
        lastAppliedTravelPx = nextTravel;
        lastAppliedHazePx = hazePx;
      }
    }

    function syncInnerBoxToRoot(opts) {
      if (!innerEl || !root) return;
      opts = opts || {};
      if (mobileFixedPin) {
        innerEl.style.top = '0px';
        innerEl.style.left = '0px';
      } else {
        innerEl.style.top = '';
        innerEl.style.left = '';
      }
      var keepPinnedWidth = Date.now() < ignoreMetricsUntil ||
        ((journey === 'pricing' || journey === 'below') && !opts.force && innerEl.style.width);
      if (keepPinnedWidth) return;
      var rect = root.getBoundingClientRect();
      var w = Math.round(rect.width);
      if (w < 1) return;
      innerEl.style.width = w + 'px';
      innerEl.style.maxWidth = w + 'px';
    }

    function updateMetrics(options) {
      var opts = options || {};
      viewportW = window.innerWidth || 0;
      var nextH = getViewportH();
      var frozenPx = lastAppliedVhPx ? parseFloat(lastAppliedVhPx) : 0;
      var widthJump = lastViewportWForMetrics < 0 || Math.abs(viewportW - lastViewportWForMetrics) > 24;
      lastViewportWForMetrics = viewportW;
      var heightJump = frozenPx > 120 && Math.abs(nextH - frozenPx) > 48;
      var inPinToggle = Date.now() < ignoreMetricsUntil;
      var inPricingScene = journey === 'pricing' || journey === 'below';
      var inPinnedJourney = journey === 'sequence' || journey === 'autoplay' || journey === 'buffer' || inPricingScene;
      var freezeVh = inPinToggle || (inPinnedJourney && !opts.force && !widthJump && !heightJump);
      if (freezeVh && frozenPx > 120) nextH = frozenPx;
      viewportH = nextH;
      sequencePx = activeSequenceScrollVh() * viewportH;
      bufferPx = (bufferVh / 100) * viewportH;
      pricingPx = 0;
      var vhPx = Math.round(viewportH) + 'px';
      if (lastAppliedVhPx !== vhPx) {
        lastAppliedVhPx = vhPx;
        root.style.setProperty('--moje-s2b-vh-px', vhPx);
      }
      root.style.setProperty('--moje-s2b-buffer-px', Math.round(bufferPx) + 'px');
      syncIntroLayout();
      applySectionHeight();
      if (pinSpacer) {
        pinSpacer.style.display = 'none';
        pinSpacer.style.height = '0px';
      }
      syncInnerBoxToRoot({
        force: !!opts.force && Date.now() >= ignoreMetricsUntil
      });
      if (opts.refreshPinStart) refreshPinStart(true);
    }

    function isSlowNetwork() {
      try {
        var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (!conn) return false;
        if (conn.saveData) return true;
        var t = String(conn.effectiveType || '').toLowerCase();
        if (t === 'slow-2g' || t === '2g' || t === '3g') return true;
        if (typeof conn.downlink === 'number' && conn.downlink > 0 && conn.downlink < 1.5) return true;
      } catch (eSlow) {}
      return false;
    }

    function getOptimalFrameWidth() {
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      var cw = viewportW || window.innerWidth || 1920;
      var ch = viewportH || window.innerHeight || 1080;
      var slow = isSlowNetwork();
      if (useMobileMediaAssets()) {
        return Math.max(720, Math.min(slow ? 960 : 1440, Math.ceil(cw * dpr)));
      }
      return Math.max(720, Math.min(slow ? 1280 : 1920, Math.ceil(Math.max(cw, ch * 1.78) * dpr)));
    }

    function getSequenceImageUrl(url) {
      return withRequestedWidth(url, getOptimalFrameWidth());
    }

    function unloadImageSrc(img) {
      if (!img) return;
      img.removeAttribute('src');
      img.removeAttribute('srcset');
      try { img.removeAttribute('srcset'); } catch (eSrcset) {}
    }

    function assignLazyImageSrc(img) {
      if (!img) return;
      var ds = img.getAttribute('data-src');
      var dss = img.getAttribute('data-srcset');
      if (dss && img.getAttribute('srcset') !== dss) img.setAttribute('srcset', dss);
      if (ds && img.getAttribute('src') !== ds) img.src = ds;
    }

    function stageWrapHasMobileImage(wrap) {
      return !!(wrap && wrap.querySelector('.moje-s2b__pricing-stage-img--mobile[data-src], .moje-s2b__pricing-stage-img--mobile[src]'));
    }

    /*
     * Kdy držet "extra" DOM obrázky (pozadí ceníku, haze ostatních fází) mimo síť:
     *   - před rozjezdem autoplaye (runway snímků má přednost),
     *   - při čekání na autoplay z navigace.
     * Jakmile autoplay běží nebo doběhl, pásmo už není kritické – dřív se čekalo na 100 % snímků,
     * což by po zavedení streamovaného bufferingu nechalo ceník bez pozadí.
     */
    function sequenceHoldsExtraMedia() {
      if (pendingAutoplayFromNav) return true;
      /* Skrytá média (cizí karty, cizí úvody) až po tiché frontě, ať 3s SEO pauza zůstane tichá. */
      if (!deferredDomMediaReleased) {
        if (autoplayPlaying && !autoplayConsumed) return false;
        return true;
      }
      if (defaultSequenceFullyReady()) return false;
      return !autoplayPlaying && !autoplayConsumed;
    }

    /* Během autoplaye jen pozadí aktivní karty (bude potřeba na konci), ostatní až po něm. */
    function sequenceWantsActiveStageOnly() {
      return autoplayPlaying && !autoplayConsumed && !defaultSequenceFullyReady();
    }

    function hydrateStageImagesForViewport() {
      if (!root) return;
      var mobile = useMobileMediaAssets();
      var holdExtra = sequenceHoldsExtraMedia();
      var activeOnly = sequenceWantsActiveStageOnly();
      var imgs = root.querySelectorAll('.moje-s2b__pricing-stage-img');
      var i;
      for (i = 0; i < imgs.length; i += 1) {
        var img = imgs[i];
        var isMob = img.classList.contains('moje-s2b__pricing-stage-img--mobile');
        var isDesk = img.classList.contains('moje-s2b__pricing-stage-img--desktop');
        var wrap = img.closest('[data-s3-stage-bg]');
        var wanted = (mobile && isMob) || (!mobile && isDesk);
        if (mobile && isDesk && !stageWrapHasMobileImage(wrap)) wanted = true;
        if (!deferredDomMediaReleased && wrap && !wrap.classList.contains('moje-s2b__pricing-stage-bg--active')) continue;
        if (holdExtra) continue;
        if (activeOnly && wrap && !wrap.classList.contains('moje-s2b__pricing-stage-bg--active')) continue;
        if (!wanted) {
          unloadImageSrc(img);
          continue;
        }
        if (orientHydrateActiveOnly && wrap && !wrap.classList.contains('moje-s2b__pricing-stage-bg--active')) {
          unloadImageSrc(img);
          continue;
        }
        assignLazyImageSrc(img);
      }
    }

    function applyAdaptiveDomImages() {
      var nodes = root.querySelectorAll('[data-s2b-crop-src]');
      var i;
      var img;
      var master;
      var kind;
      var next;
      var phase;
      var bg;
      var desktopIntro = useDesktopSequenceAssets();
      var holdExtra = sequenceHoldsExtraMedia();
      var activePhase = String(activeSequenceStage);
      for (i = 0; i < nodes.length; i += 1) {
        img = nodes[i];
        master = img.getAttribute('data-s2b-crop-src');
        if (!master) continue;
        kind = img.getAttribute('data-s2b-crop-kind') || '';
        if (kind === 'intro' && !desktopIntro) {
          img.style.backgroundImage = '';
          continue;
        }
        phase = img.getAttribute('data-s2b-seq-phase');
        if (kind === 'intro' && phase && phase !== activePhase && !deferredDomMediaReleased) continue;
        next = withRequestedWidth(master, getOptimalFrameWidth());
        bg = 'url("' + next + '")';
        if ((img.style.backgroundImage || '').indexOf(next) !== -1) continue;
        img.style.backgroundImage = bg;
      }
      hydrateStageImagesForViewport();
    }

    /* Backing store max 2× (snímky se stahují taky max 2×): DPR 3 na iPhonu = 11,8 MB canvas
       a drawImage upscaloval 2× data na 3× plátno bez zisku. */
    function canvasDpr() {
      var dpr = window.devicePixelRatio || 1;
      if (IS_WEAK_MOBILE) return 1;
      if ((window.innerWidth || 0) <= 768 && !IS_STRONG_MOBILE) return Math.min(dpr, 1.25);
      return Math.min(2, dpr);
    }

    function resizeCanvas() {
      if (!canvas || !ctx) return;
      var dpr = canvasDpr();
      var w = innerEl ? innerEl.clientWidth : viewportW || window.innerWidth;
      var h = innerEl ? innerEl.clientHeight : viewportH || window.innerHeight;
      if (!(w > 2) || !(h > 2)) return;
      canvasCssW = w;
      canvasCssH = h;
      var bw = Math.max(1, Math.round(w * dpr));
      var bh = Math.max(1, Math.round(h * dpr));
      if (IS_WEAK_MOBILE) {
        var fit = Math.min(1, 360 / bw, 800 / bh);
        bw = Math.max(1, Math.round(bw * fit));
        bh = Math.max(1, Math.round(bh * fit));
      }
      if (canvas.width !== bw || canvas.height !== bh) {
        canvas.width = bw;
        canvas.height = bh;
        lastDrawnIndex = -1;
      }
      canvas.style.width = Math.round(w) + 'px';
      canvas.style.height = Math.round(h) + 'px';
      if (IS_WEAK_MOBILE) ctx.imageSmoothingEnabled = false;
    }

    /* PC: cover + top (ořezává se spodek). Mobil: vždy celá výška snímku, strany se ořezávají
       nebo zůstanou volné — stejné zarovnání jako pozadí cenových karet, ať poslední snímek naváže. */
    /* Kreslí se vždy přímo z <img>; dekódovaná data spravuje cache prohlížeče (viz decode okno). */
    function drawCover(img) {
      var source = (img && img.__s2bBmp) || img;
      if (!ctx || !source) return;
      var iw = source.naturalWidth || source.width || 0;
      var ih = source.naturalHeight || source.height || 0;
      if (!(iw > 0) || !(ih > 0)) return;
      if (!(canvasCssW > 2)) resizeCanvas();
      var sx = canvasCssW > 0 ? canvas.width / canvasCssW : 1;
      var sy = canvasCssH > 0 ? canvas.height / canvasCssH : 1;
      ctx.setTransform(sx, 0, 0, sy, 0, 0);
      if (IS_WEAK_MOBILE) ctx.imageSmoothingEnabled = false;
      var cw = canvasCssW;
      var ch = canvasCssH;
      /* Cover od horního okraje: vždy celá šířka i výška, přebytek se ořízne. Žádné černé pruhy. */
      var scale = Math.max(cw / iw, ch / ih);
      if (!(scale > 0)) return;
      var dw = iw * scale;
      var dh = ih * scale;
      var dx = (cw - dw) * 0.5;
      ctx.clearRect(0, 0, cw, ch);
      ctx.drawImage(source, 0, 0, iw, ih, dx, 0, dw, dh);
    }

    /* —— Směrové dekódovací okno (aktivní sekvence) —— */
    function resetDecodeWindow() {
      decodeWindowLo = -1;
      decodeWindowHi = -1;
      decodeWindowCenter = -1;
    }

    /* Asynchronní decode hint; opakuje se nejdřív po DECODE_REPRIME_MS (cache mohla snímek uvolnit). */
    function primeDecodedFrame(img, now) {
      if (!DECODE_HINTS_ENABLED) return;
      if (!img || typeof img.decode !== 'function' || !img.complete || !img.naturalWidth) return;
      var t = now || Date.now();
      if (img.__s2bPrimedAt && t - img.__s2bPrimedAt < DECODE_REPRIME_MS) return;
      img.__s2bPrimedAt = t;
      try {
        img.decode().catch(function () {});
      } catch (eDecode) {}
    }

    /* Snímek dorazil ze sítě: dekódovat jen když je v okně (ostatní až když se k nim scrub přiblíží). */
    function primeFrameIfInWindow(index) {
      if (index < decodeWindowLo || index > decodeWindowHi) return;
      primeDecodedFrame(images[index]);
    }

    function syncDecodeWindow(center, force) {
      if (!totalFrames) return;
      if (decodeStoreRef !== images) {
        resetDecodeWindow();
        decodeStoreRef = images;
      }
      var c = Math.max(0, Math.min(maxFrameIndex, center | 0));
      if (decodeWindowCenter >= 0 && c !== decodeWindowCenter) decodeWindowDir = c > decodeWindowCenter ? 1 : -1;
      if (!force && decodeWindowCenter >= 0 && Math.abs(c - decodeWindowCenter) < 2) return;
      decodeWindowCenter = c;
      var ahead = DECODE_AHEAD;
      var behind = DECODE_BEHIND;
      var lo = Math.max(0, c - (decodeWindowDir > 0 ? behind : ahead));
      var hi = Math.min(maxFrameIndex, c + (decodeWindowDir > 0 ? ahead : behind));
      decodeWindowLo = lo;
      decodeWindowHi = hi;
      var now = Date.now();
      var i;
      /* Nejdřív ve směru pohybu (od nejbližšího), pak zbytek. */
      if (decodeWindowDir > 0) {
        for (i = c + 1; i <= hi; i += 1) primeDecodedFrame(images[i], now);
        for (i = c - 1; i >= lo; i -= 1) primeDecodedFrame(images[i], now);
      } else {
        for (i = c - 1; i >= lo; i -= 1) primeDecodedFrame(images[i], now);
        for (i = c + 1; i <= hi; i += 1) primeDecodedFrame(images[i], now);
      }
    }

    /* Mobil: od horního okraje vymaže snímek do černé (pozadí sekce).
       Každým snímkem se pás zúží; na 25. snímku už není. Desktop beze změny. */
    function applyMobileTopDecay(frameIndex) {
      if (!ctx || useWideMediaAssets()) return;
      var i = frameIndex | 0;
      if (i < 0 || i >= MOBILE_TOP_DECAY_GONE_INDEX) return;
      var t = (MOBILE_TOP_DECAY_GONE_INDEX - i) / MOBILE_TOP_DECAY_GONE_INDEX;
      var cw = canvasCssW;
      var ch = canvasCssH;
      if (cw < 2 || ch < 2 || t <= 0) return;
      var fadeH = Math.max(2, ch * MOBILE_TOP_DECAY_MAX_RATIO * t);
      ctx.save();
      ctx.globalCompositeOperation = 'destination-out';
      var g = ctx.createLinearGradient(0, 0, 0, fadeH);
      g.addColorStop(0, 'rgba(0,0,0,1)');
      g.addColorStop(0.28, 'rgba(0,0,0,0.62)');
      g.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, cw, fadeH);
      ctx.restore();
    }

    /* Nejbližší už stažený snímek, když požadovaný ještě není v paměti. */
    function nearestLoadedFrame(index) {
      var best = -1;
      var bestDist = 1e9;
      var dir = decodeWindowDir >= 0 ? 1 : -1;
      var k;
      for (k = 0; k < images.length; k += 1) {
        var im = images[k];
        if (!im || !frameReady(im)) continue;
        var dist = Math.abs(k - index);
        if (dist < bestDist) {
          bestDist = dist;
          best = k;
          continue;
        }
        if (dist !== bestDist || best < 0) continue;
        var ahead = dir > 0 ? k > index : k < index;
        var bestAhead = dir > 0 ? best > index : best < index;
        if (ahead && !bestAhead) best = k;
      }
      return best;
    }

    function frameIndexForProgress(t) {
      var n = totalFrames | 0;
      if (n <= 1) return 0;
      var clamped = t;
      if (clamped < 0) clamped = 0;
      else if (clamped > 1) clamped = 1;
      return Math.max(0, Math.min(n - 1, Math.round(clamped * (n - 1))));
    }

    function frameReady(im) {
      if (!im) return false;
      if (im.__s2bReady && ((im.__s2bBmp && im.__s2bBmp.width) || im.naturalWidth || im.width)) return true;
      return !!(im.complete && im.naturalWidth);
    }

    var weakShrinkQueue = [];
    var weakShrinkBusy = false;

    function pumpWeakShrink() {}

    function enqueueWeakShrink() {}

    function paintFrame(index) {
      if (!totalFrames) return;
      var requested = Math.max(0, Math.min(maxFrameIndex, index | 0));
      paintTargetIndex = requested;
      var i = requested;
      var img = images[i];
      var exact = frameReady(img);
      if (!exact) {
        if (!autoplayPlaying && (!img || !img.complete)) boostFramesNearScrub(requested);
        var near = nearestLoadedFrame(requested);
        if (near < 0) return;
        i = near;
        img = images[near];
      }
      if (!frameReady(img)) return;
      currentFrameIndex = requested;
      if (i === lastDrawnIndex) return;
      /* Další snímky nekreslit, dokud Hero ještě zakrývá plátno. První snímek se nakreslí hned, i mimo obraz. */
      if (lastDrawnIndex >= 0 && s2bCanvasInView() && heroSectionRatio() >= 0.15) return;
      window.__mojePerf = window.__mojePerf || {};
      window.__mojePerf.canvas = true;
      drawCover(img);
      clearTimeout(window.__mojePerf._canvasOff);
      window.__mojePerf._canvasOff = setTimeout(function () { window.__mojePerf.canvas = false; }, 150);
      applyMobileTopDecay(i);
      syncIntroFade(i);
      lastDrawnIndex = i;
      syncDecodeWindow(requested, false);
      if (canvas && canvas.__mojeFrameShown !== 1) {
        canvas.__mojeFrameShown = 1;
        canvas.classList.remove('moje-s2b__canvas--awaiting-first');
        canvas.classList.add('moje-s2b__canvas--visible');
      }
      if (requested === 0) hideLoader();
    }

    function setLoaderProgress(pct) {
      var p = Math.max(0, Math.min(100, pct));
      if (loaderFill) loaderFill.style.width = p + '%';
      if (loaderPct) loaderPct.textContent = Math.round(p) + '%';
    }

    function hideLoader() {
      if (loader) {
        loader.classList.add('moje-s2b__loader--hide');
        loader.setAttribute('aria-hidden', 'true');
      }
    }

    function isProgrammaticNav() {
      return Date.now() < programmaticNavUntil;
    }

    function clearProgrammaticTarget() {
      programmaticTargetY = NaN;
    }

    function clearProgrammaticNav() {
      programmaticNavUntil = 0;
      if (programmaticNavTimer) {
        clearTimeout(programmaticNavTimer);
        programmaticNavTimer = 0;
      }
      clearProgrammaticTarget();
      document.documentElement.classList.remove('moje-s2b-external-scroll-nav');
      if (document.body) document.body.classList.remove('moje-s2b-external-scroll-nav');
    }

    function markProgrammaticNav(ms) {
      var dur = Math.max(400, Number(ms) || 1800);
      var until = Date.now() + dur;
      if (until > programmaticNavUntil) programmaticNavUntil = until;
      document.documentElement.classList.add('moje-s2b-external-scroll-nav');
      if (document.body) document.body.classList.add('moje-s2b-external-scroll-nav');
      if (programmaticNavTimer) clearTimeout(programmaticNavTimer);
      var remain = Math.max(50, programmaticNavUntil - Date.now());
      programmaticNavTimer = setTimeout(function () {
        programmaticNavTimer = 0;
        if (Date.now() < programmaticNavUntil) return;
        clearProgrammaticTarget();
        document.documentElement.classList.remove('moje-s2b-external-scroll-nav');
        if (document.body) document.body.classList.remove('moje-s2b-external-scroll-nav');
        if (pendingAutoplayFromNav) tryStartPendingAutoplay();
        requestTick();
      }, remain + 50);
    }

    function isJumpToSequenceStart(y) {
      var start = pinStartY;
      if (!(start > 8) || !Number.isFinite(y)) return false;
      return y >= start - 48 && y <= start + 64;
    }

    function isS2bIntroNavTarget(y) {
      if (autoplayConsumed || autoplayPlaying) return false;
      var start = pinStartY;
      if (!(start > 8) || !Number.isFinite(y)) return false;
      var dock = 0;
      try {
        dock = pricingDockY();
      } catch (errDock) {
        dock = 0;
      }
      if (!Number.isFinite(dock) || dock < start) {
        dock = start + Math.max(0, sequencePx);
      }
      return y >= start - 48 && y <= dock + 64;
    }

    function closeSiteMenuDrawer() {
      var drawer = document.querySelector('header-drawer');
      var details = document.getElementById('Details-menu-drawer-container');
      var summary;
      var headerEl;
      if (!details) return;
      summary = details.querySelector('summary');
      if (details.hasAttribute('open') && drawer && typeof drawer.closeMenuDrawer === 'function' && summary) {
        try {
          drawer.closeMenuDrawer({ type: 'click' }, summary);
        } catch (errClose) {}
      }
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      headerEl = document.querySelector('.header.menu-open') || document.querySelector('.header');
      if (headerEl) headerEl.classList.remove('menu-open');
      document.documentElement.classList.remove('moje-header-menu-open');
      if (document.body) {
        document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-desktop');
      }
    }

    function applyS2bScrollFreezePadding() {
      var html = document.documentElement;
      var gap = Math.max(0, window.innerWidth - html.clientWidth);
      if (gap > 0) html.style.setProperty('--moje-s2b-autoplay-sb', gap + 'px');
      else html.style.removeProperty('--moje-s2b-autoplay-sb');
    }

    function clearS2bScrollFreezePadding() {
      var html = document.documentElement;
      if (html.classList.contains('moje-s2b-autoplay-lock') || html.classList.contains('moje-s2b-terraform-lock')) {
        return;
      }
      html.style.removeProperty('--moje-s2b-autoplay-sb');
    }

    function lockS2bChrome(mode) {
      var html = document.documentElement;
      chromeLockMode = mode || '';
      html.classList.toggle('moje-s2b-chrome-lock', !!mode);
      html.classList.toggle('moje-s2b-chrome-lock--hide-spy', mode === 'terraform');
      html.classList.toggle('moje-s2b-chrome-lock--spy-inert', mode === 'autoplay');
      if (mode === 'terraform') {
        if (!html.classList.contains('moje-s2b-terraform-lock')) {
          applyS2bScrollFreezePadding();
          html.classList.add('moje-s2b-terraform-lock');
        }
        setScrollY(terraformLockY);
      } else if (mode === 'autoplay') {
        html.classList.remove('moje-s2b-terraform-lock');
      } else {
        html.classList.remove('moje-s2b-terraform-lock');
        clearS2bScrollFreezePadding();
      }
      closeSiteMenuDrawer();
    }

    function unlockS2bChrome(fromMode) {
      var html;
      if (fromMode && chromeLockMode && chromeLockMode !== fromMode) return;
      html = document.documentElement;
      html.classList.remove(
        'moje-s2b-chrome-lock',
        'moje-s2b-chrome-lock--hide-spy',
        'moje-s2b-chrome-lock--spy-inert',
        'moje-s2b-terraform-lock'
      );
      chromeLockMode = '';
      clearS2bScrollFreezePadding();
    }

    function pinPricingForTerraform() {
      /*
       * overflow:hidden na html/body ruší position:sticky. Když nejsme přesně
       * na kotvě ceníku, inner odskočí mimo viewport a video hraje „naslepo“
       * na černém pozadí. Nejdřív fixed pin přes celou obrazovku, až potom lock.
       */
      if (journey === 'below' || journey === 'buffer') {
        journey = 'pricing';
        atPricing = true;
        pricingLocked = true;
        belowArmed = false;
      }
      pricingUseFixedPin = true;
      if (!pricingVisible) showPricingVisual();
      else if (root) root.classList.add('moje-s2b--pricing-active');
      setFixedPin(true);
      if (innerEl) void innerEl.offsetHeight;
      var dock = Math.max(0, Math.round(pricingDockY()));
      terraformLockY = dock;
      setScrollY(dock);
      lastScrollYForDir = dock;
    }

    function pinTerraformScroll() {
      if (!pricingTransitioning) return false;
      if (!mobileFixedPin) setFixedPin(true);
      setScrollY(terraformLockY);
      lastScrollYForDir = terraformLockY;
      return true;
    }

    function stopPendingAutoplayWatch() {
      if (pendingAutoplayWatchRaf) {
        cancelAnimationFrame(pendingAutoplayWatchRaf);
        pendingAutoplayWatchRaf = 0;
      }
    }

    function armPendingAutoplayWatch() {
      if (pendingAutoplayWatchRaf) return;
      function tick() {
        pendingAutoplayWatchRaf = 0;
        if (!pendingAutoplayFromNav || autoplayPlaying || autoplayConsumed) return;
        if (tryStartPendingAutoplay()) return;
        pendingAutoplayWatchRaf = requestAnimationFrame(tick);
      }
      pendingAutoplayWatchRaf = requestAnimationFrame(tick);
    }

    function pendingAutoplayHasArrived() {
      var y;
      if (!(pinStartY > 8)) return false;
      y = getScrollY();
      if (Math.abs(y - pinStartY) <= 2) {
        pendingAutoplaySettledFrames += 1;
        return pendingAutoplayScrollEnded || pendingAutoplaySettledFrames >= 3;
      }
      pendingAutoplaySettledFrames = 0;
      if (pendingAutoplayScrollEnded && Math.abs(y - pinStartY) <= 48) {
        pinStartY = y;
        pinStartCached = true;
        return true;
      }
      return false;
    }

    function tryStartPendingAutoplay() {
      if (window.__mojeForceScrollTopUntil && Date.now() < window.__mojeForceScrollTopUntil) return false;
      if (!pendingAutoplayFromNav) return false;
      beginDefaultSequenceLoad();
      holdPipelineForDefaultSequence();
      if (autoplayConsumed || autoplayPlaying) {
        pendingAutoplayFromNav = false;
        stopPendingAutoplayWatch();
        return false;
      }
      if (!pendingAutoplayHasArrived()) return false;
      if (!framesReadyForAutoplay()) {
        paintFrame(0);
        return false;
      }
      pendingAutoplayFromNav = false;
      pendingAutoplayScrollEnded = false;
      pendingAutoplaySettledFrames = 0;
      stopPendingAutoplayWatch();
      clearProgrammaticNav();
      startAutoplay({ fromNav: true });
      if (autoplayPlaying || autoplayConsumed) return true;
      pendingAutoplayFromNav = true;
      paintFrame(0);
      armPendingAutoplayWatch();
      return false;
    }

    function isYInSequence(y) {
      var start = pinStartY;
      var end = pinStartY + Math.max(0, sequencePx);
      if (!(start > 8) || !Number.isFinite(y)) return false;
      return y >= start - 2 && y < end - 0.5;
    }

    function visualScrollY() {
      var live = getScrollY();
      if (!Number.isFinite(programmaticTargetY)) return live;
      if (Math.abs(live - programmaticTargetY) <= 8) {
        clearProgrammaticTarget();
        return live;
      }
      if (isYInSequence(programmaticTargetY)) return programmaticTargetY;
      clearProgrammaticTarget();
      return live;
    }

    function revealSequenceAtY(y) {
      refreshPinStart(true);
      if (!isYInSequence(y)) return false;
      var local = y - pinStartY;
      var seqEnd = Math.max(0, sequencePx);
      if (journey !== 'sequence') enterSequence();
      else pinForJourney();
      setFixedPin(true);
      if (innerEl) void innerEl.offsetHeight;
      var t = seqEnd <= 0 ? 1 : Math.max(0, Math.min(1, local / seqEnd));
      lastDrawnIndex = -1;
      paintFrame(frameIndexForProgress(t));
      applyMistProgress(mistProgressFromLocal(local));
      hidePricingVisual();
      return true;
    }

    function scheduleContinueAfterAutoplay() {
      var y = pendingContinueAfterAutoplayY;
      pendingContinueAfterAutoplayY = NaN;
      if (!Number.isFinite(y) || y <= 8) return;
      suppressPricingRelockUntil = Date.now() + 1400;
      window.setTimeout(function () {
        var dist;
        var ms;
        if (!Number.isFinite(y) || y <= 8) return;
        dist = Math.abs(y - getScrollY());
        ms = Math.max(700, Math.min(1600, dist * 0.85 + 400));
        markProgrammaticNav(ms);
        if (typeof window.__mojeScrollSpyGoToY === 'function') {
          window.__mojeScrollSpyGoToY(y, true, { source: 's2b-after-autoplay' });
        } else {
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 360);
    }

    function consumeAutoplayWithoutPlay(opts) {
      opts = opts || {};
      pendingAutoplayFromNav = false;
      stopPendingAutoplayWatch();
      autoplayPlaying = false;
      autoplayConsumed = true;
      if (autoplayRaf) {
        cancelAnimationFrame(autoplayRaf);
        autoplayRaf = 0;
      }
      if (journey === 'autoplay') journey = 'pre';
      unlockAutoplayScroll();
      unlockS2bChrome('autoplay');
      hideLoader();
      dismissScrollHint();
      if (opts.skipContinue) pendingContinueAfterAutoplayY = NaN;
      else scheduleContinueAfterAutoplay();
      resumeBackgroundQueue();
    }

    function skipAutoplayForProgrammaticScroll(targetY, opts) {
      opts = opts || {};
      refreshPinStart(false);
      var startY = pinStartY;
      if (!Number.isFinite(startY) || startY <= 0) {
        refreshPinStart(true);
        startY = pinStartY;
      }
      var y = Number(targetY);
      if (!Number.isFinite(y)) y = getScrollY();
      var currentY = getScrollY();
      var landsInOrPast = startY > 8 && y >= startY - 12;
      var currentlyInOrPast = startY > 8 && currentY >= startY - 12;
      var jumpToSequence = isYInSequence(y);
      var jumpToStart = isJumpToSequenceStart(y) || !!opts.playAutoplay || isS2bIntroNavTarget(y);
      var wantSmooth = opts.smooth !== false;
      var dist = Math.abs((Number.isFinite(y) ? y : 0) - getScrollY());
      var navMs = Number(opts.duration);
      if (!Number.isFinite(navMs) || navMs <= 0) {
        navMs = wantSmooth ? Math.max(700, Math.min(1600, dist * 0.85 + 400)) : 400;
      }
      navMs = Math.max(400, navMs);

      programmaticTargetY = (!wantSmooth && jumpToSequence) ? y : NaN;

      function finishSequenceJump() {
        if (!jumpToSequence) return;
        consumeAutoplayWithoutPlay();
        if (wantSmooth) return;
        if (
          journey === 'pricing' ||
          journey === 'below' ||
          journey === 'buffer' ||
          pricingVisible
        ) {
          revealSequenceAtY(y);
        }
      }

      if (
        !autoplayConsumed &&
        !autoplayPlaying &&
        journey !== 'autoplay' &&
        jumpToStart
      ) {
        if (Number.isFinite(Number(opts.continueAfterAutoplayY)) && Number(opts.continueAfterAutoplayY) > 8) {
          pendingContinueAfterAutoplayY = Number(opts.continueAfterAutoplayY);
        }
        pendingAutoplayFromNav = true;
        pendingAutoplayScrollEnded = false;
        pendingAutoplaySettledFrames = 0;
        holdPipelineForDefaultSequence();
        lockS2bChrome('autoplay');
        markProgrammaticNav(navMs);
        armPendingAutoplayWatch();
        requestTick();
        return;
      }

      pendingAutoplayFromNav = false;

      if (!(startY > 8) && y > currentY + getViewportH() * 0.45) {
        markProgrammaticNav(navMs);
        consumeAutoplayWithoutPlay();
        finishSequenceJump();
        requestTick();
        return;
      }

      if (autoplayPlaying || journey === 'autoplay') {
        markProgrammaticNav(navMs);
        consumeAutoplayWithoutPlay();
        finishSequenceJump();
        requestTick();
        return;
      }
      if (!autoplayConsumed && landsInOrPast) {
        markProgrammaticNav(navMs);
        consumeAutoplayWithoutPlay();
        finishSequenceJump();
        requestTick();
        return;
      }
      if (autoplayConsumed && (landsInOrPast || currentlyInOrPast || jumpToSequence)) {
        markProgrammaticNav(navMs);
        finishSequenceJump();
        requestTick();
      }
    }

    function sequenceAssetKey(stage, packHint) {
      return resolveSequenceStage(stage) + ':' + (wantMobilePack(packHint) ? 'm' : 'd');
    }

    function packFrameWidth(packHint) {
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      var slow = isSlowNetwork();
      if (wantMobilePack(packHint)) {
        var shortSide = Math.min(window.innerWidth || 0, window.innerHeight || 0) || 390;
        return Math.max(720, Math.min(slow ? 960 : 1440, Math.ceil(shortSide * dpr)));
      }
      var longSide = Math.max(window.innerWidth || 0, window.innerHeight || 0) || 1920;
      return Math.max(720, Math.min(slow ? 1280 : 1920, Math.ceil(longSide * dpr)));
    }

    function getSequenceStore(stage, packHint) {
      var id = resolveSequenceStage(stage);
      var key = sequenceAssetKey(id, packHint);
      var urls = sequenceUrlsFor(id, packHint);
      var width = packHint ? packFrameWidth(packHint) : getOptimalFrameWidth();
      var store = sequenceStore[key];
      if (store && store.frameUrls && store.frameUrls.join('|') === urls.join('|')) {
        return store;
      }
      store = sequenceStore[key] = {
        images: [],
        loadedCount: 0,
        frameUrls: urls,
        width: width,
        key: key,
        stage: id,
        packHint: packHint || (wantMobilePack() ? 'm' : 'd')
      };
      return store;
    }

    /*
     * Fáze 1 (zbytek výchozí sekvence po window.onload): max 4 paralelně.
     * Tichá fronta obrázků: max 3. Save-Data / málo RAM / pomalá síť jedou níž.
     */
    function getSeqLoadConcurrency() {
      var cap = defaultSequenceFullyReady() ? 3 : 4;
      if (isSaveDataEnabled()) cap = Math.min(cap, 2);
      else if (isLowMemoryDevice() || isSlowNetwork()) cap = Math.min(cap, 3);
      return cap;
    }

    /* Stažené snímky karet zůstávají v paměti po celou návštěvu. Mazání je jen při změně portrait/landscape. */
    function retainSequenceStores() {}

    function isIosWebKit() {
      var ua = navigator.userAgent || '';
      return /iP(hone|ad|od)/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    }

    function mobileKeepsOneCard() {
      return (window.innerWidth || 0) <= 768;
    }

    function mobileCacheOnlyStage(store) {
      if (!mobileKeepsOneCard() || !store) return false;
      if (store.images === images) return false;
      if (store.stage === activeSequenceStage) return false;
      return true;
    }

    function releaseMobileCardsExcept(stage) {
      if (!mobileKeepsOneCard()) return;
      var keys = Object.keys(sequenceStore);
      var k;
      for (k = 0; k < keys.length; k += 1) {
        var st = sequenceStore[keys[k]];
        if (!st || st.stage === stage) continue;
        dropSequenceStore(st);
      }
    }

    function enqueueFrameLoad(store, index, priority) {
      if (!sequenceFramesUnlocked) {
        if (!store || store.images !== images) return;
        if (index !== 0 && index !== currentFrameIndex) return;
      }
      if (!store || !store.frameUrls[index] || store.images[index]) return;
      if (mobileCacheOnlyStage(store)) {
        store.warmed = store.warmed || [];
        if (store.warmed[index]) return;
        store.warmed[index] = 1;
      }
      var q;
      for (q = 0; q < seqLoadQueue.length; q += 1) {
        if (seqLoadQueue[q].store === store && seqLoadQueue[q].index === index) {
          if (priority > seqLoadQueue[q].priority) seqLoadQueue[q].priority = priority;
          return;
        }
      }
      seqLoadQueue.push({ store: store, index: index, priority: priority || 0 });
    }

    var cacheWarmLive = [];

    function startFrameLoad(store, index, priority) {
      if (!store || !store.frameUrls[index] || store.images[index]) {
        seqLoadInFlight = Math.max(0, seqLoadInFlight - 1);
        scheduleSeqLoadPump();
        return;
      }
      var silentAtLoad = sequenceLoadSilent || store.images !== images;
      if (mobileCacheOnlyStage(store)) {
        var warmUrl = store.frameUrls[index];
        var warmImg = new Image();
        warmImg.decoding = 'async';
        cacheWarmLive.push(warmImg);
        function warmDone(ok) {
          var slot = cacheWarmLive.indexOf(warmImg);
          if (slot >= 0) cacheWarmLive.splice(slot, 1);
          warmImg.onload = null;
          warmImg.onerror = null;
          warmImg = null;
          store.cacheTried = (store.cacheTried || 0) + 1;
          if (ok) store.cacheCount = (store.cacheCount || 0) + 1;
          seqLoadInFlight = Math.max(0, seqLoadInFlight - 1);
          try { noteSilentImageProgress(); } catch (eNote) {}
          try { syncDebugHud(); } catch (eHudWarm) {}
          scheduleSeqLoadPump();
        }
        warmImg.onload = function () { warmDone(true); };
        warmImg.onerror = function () { warmDone(false); };
        if (warmUrl) warmImg.src = warmUrl;
        else warmDone(false);
        return;
      }
      var fromEndAtLoad = sequenceLoadFromEnd;
      var settled = false;
      var img = new Image();
      img.decoding = 'async';
      try {
        /* Vysoká priorita jen pro rozjezd; dočítání na pozadí nesmí předbíhat ostatní média. */
        img.fetchPriority = (store.images === images && !defaultSequenceFullyReady() && index === 0) ? 'high' : 'low';
      } catch (ePri) {}
      img.__s2bEpoch = orientEpoch;
      function finish(ok) {
        if (settled) return;
        if (img.__s2bEpoch !== orientEpoch) {
          settled = true;
          return;
        }
        settled = true;
        img.__s2bFinish = null;
        seqLoadInFlight = Math.max(0, seqLoadInFlight - 1);
        store.loadedCount += 1;
        store.lastUsed = Date.now();
        if (store.images === images) {
          loadedCount = store.loadedCount;
          if (!silentAtLoad) setLoaderProgress(loaderProgressPct());
          if (ok) primeFrameIfInWindow(index);
          /* Poslední snímek dorazil až po hand-off do ceníku (rebuffer give-up) → dokreslit. */
          var lateLastFrame = ok && index === maxFrameIndex && autoplayConsumed && pricingVisible && paintTargetIndex < maxFrameIndex;
          var wantPaint = ok && (index === paintTargetIndex || index === currentFrameIndex || (!fromEndAtLoad && index === 0 && paintTargetIndex === 0));
          if (lateLastFrame) {
            paintFrame(maxFrameIndex);
          } else if (wantPaint) {
            paintFrame(paintTargetIndex);
            if (!silentAtLoad && !sequenceLayoutFrozen && !pendingAutoplayFromNav && index === 0) {
              pinStartCached = false;
              syncIntroLayout();
              applySectionHeight();
              refreshPinStart(true);
            }
            if (index === 0) applyAdaptiveDomImages();
          }
          if (pendingAutoplayFromNav) tryStartPendingAutoplay();
          else if (!autoplayConsumed && !autoplayPlaying && autoplayWaitingForRunway) requestTick();
          if (autoplayPlaying && autoplayRebufferUntil >= 0) requestTick();
          markDefaultSequenceReady();
          maybeStartDeferredS2bMedia();
          if (loadedCount >= totalFrames && !silentAtLoad) hideLoader();
        } else if (store.stage === phase1Stage) {
          markDefaultSequenceReady();
        }
        noteSilentImageProgress();
        scheduleSeqLoadPump();
        try { publishWave1Progress(); } catch (eWave) {}
        try { syncDebugHud(); } catch (eHud) {}
      }
      img.__s2bFinish = finish;
      img.onload = function () {
        function done() {
          finish(true);
        }
        var skipDecode = IS_WEAK_MOBILE || mobileKeepsOneCard() || isIosWebKit();
        if (!skipDecode && typeof img.decode === 'function') {
          window.__mojePerf = window.__mojePerf || {};
          window.__mojePerf.decoding = true;
          img.decode().then(done).catch(done).then(function () {
            clearTimeout(window.__mojePerf._decOff);
            window.__mojePerf._decOff = setTimeout(function () { window.__mojePerf.decoding = false; }, 40);
          });
          return;
        }
        done();
      };
      img.onerror = function () { finish(false); };
      store.images[index] = img;
      img.src = store.frameUrls[index];
      if (img.complete) finish(!!img.naturalWidth);
    }

    /* Loader ukazuje postup rozjezdu (runway), ne celé sekvence – po startu autoplay mizí. */
    function loaderProgressPct() {
      var target = totalFrames;
      if (!target) return 100;
      return (Math.min(target, countReadyRunway(0)) / target) * 100;
    }

    var paceGapMs = 0;

    function queueIsMobile() {
      return (window.innerWidth || 0) <= 768;
    }

    /* Karta 2 jede naplno. Tichá fronta: PC bez pauzy, mobil 25 ms mezi dávkami. */
    function heroVideoIsPlaying() {
      var ratio = window.__mojeHeroVisibleRatio;
      if (typeof ratio === 'number' && ratio < 0.15) return false;
      var hero = document.querySelector('.laser-section-wrapper .laser-video-layer > video.synced-video');
      return !!(hero && !hero.paused && hero.readyState >= 2);
    }

    var heroQueueBlockedAt = 0;
    function heroQueueMode() {
      if (!IS_WEAK_MOBILE || !heroVideoIsPlaying()) {
        heroQueueBlockedAt = 0;
        return 'run';
      }
      if (!heroQueueBlockedAt) heroQueueBlockedAt = Date.now();
      if (Date.now() - heroQueueBlockedAt >= 12000) return 'slow';
      return 'pause';
    }

    function queueGapMs() {
      if (!defaultSequenceFullyReady()) return 0;
      if (heroQueueMode() === 'slow') return 500;
      return queueIsMobile() ? 25 : 0;
    }

    function queueCap() {
      if (heroQueueMode() === 'slow') return 1;
      if (!defaultSequenceFullyReady()) return queueIsMobile() ? 4 : 6;
      return queueIsMobile() ? 2 : 4;
    }

    function mobileVideoGapMs() {
      return heroQueueMode() === 'slow' ? 800 : 0;
    }

    function scheduleSeqLoadPump() {
      if (seqLoadPumpTimer) return;
      if (IS_WEAK_MOBILE && defaultSequenceFullyReady() && Date.now() < weakTouchUntil) {
        seqLoadPumpTimer = setTimeout(function () {
          seqLoadPumpTimer = 0;
          scheduleSeqLoadPump();
        }, Math.max(40, weakTouchUntil - Date.now()));
        return;
      }
      if (typeof backgroundImagesPaused === 'function' && backgroundImagesPaused()) {
        seqLoadPumpTimer = setTimeout(function () {
          seqLoadPumpTimer = 0;
          scheduleSeqLoadPump();
        }, 200);
        return;
      }
      var gap = queueGapMs();
      var run = function () {
        seqLoadPumpTimer = 0;
        pumpSeqLoadQueueNow();
      };
      if (gap > 0) seqLoadPumpTimer = setTimeout(run, gap);
      else if (typeof queueMicrotask === 'function') {
        seqLoadPumpTimer = 1;
        queueMicrotask(run);
      } else {
        seqLoadPumpTimer = setTimeout(run, 0);
      }
    }

    function pumpSeqLoadQueue() {
      if (defaultSequenceFullyReady()) {
        if (seqLoadFromIdle) {
          pumpSeqLoadQueueNow();
          return;
        }
        scheduleSeqLoadPump();
        return;
      }
      pumpSeqLoadQueueNow();
    }

    function pumpSeqLoadQueueNow() {
      if (seqLoadPumping) {
        scheduleSeqLoadPump();
        return;
      }
      if (backgroundImagesPaused()) return;
      seqLoadPumping = true;
      try {
        var cap = queueCap();
        if (cap < 1) cap = 1;
        var defaultOnly = !defaultSequenceFullyReady();
        var videosFirst = bgQueueStarted && silentPhase !== 'images' && silentPhase !== 'done';
        while (seqLoadInFlight < cap && seqLoadQueue.length) {
          seqLoadQueue.sort(function (a, b) { return b.priority - a.priority; });
          var pick = -1;
          var qi;
          for (qi = 0; qi < seqLoadQueue.length; qi += 1) {
            var cand = seqLoadQueue[qi];
            if (!cand || !cand.store || cand.store.images[cand.index]) {
              seqLoadQueue.splice(qi, 1);
              qi -= 1;
              continue;
            }
            if (defaultOnly && cand.store.images !== images) continue;
            if (videosFirst && cand.store.images !== images) continue;
            if (pricingTransitioning && pendingPriorityStage && cand.store.stage !== pendingPriorityStage) continue;
            pick = qi;
            break;
          }
          if (pick < 0) break;
          var job = seqLoadQueue.splice(pick, 1)[0];
          seqLoadInFlight += 1;
          startFrameLoad(job.store, job.index, job.priority);
        }
      } finally {
        seqLoadPumping = false;
      }
    }

    function enqueueStoreFrames(store, opts) {
      opts = opts || {};
      if (!store || !store.frameUrls.length) return;
      var n = store.frameUrls.length;
      var fromEnd = !!opts.fromEnd;
      var boost = Number(opts.boost) || 0;
      var isActive = store.images === images;
      var runway = Math.min(n, 32);
      var order = [];
      var i;
      if (fromEnd) {
        for (i = n - 1; i >= 0; i -= 1) order.push(i);
      } else {
        for (i = 0; i < n; i += 1) order.push(i);
      }
      for (i = 0; i < order.length; i += 1) {
        var idx = order[i];
        var pri = boost;
        if (isActive && !fromEnd) {
          pri += idx < runway ? (140 - idx) : 80;
        } else if (isActive && fromEnd) {
          pri += idx >= n - runway ? 90 : 28;
        } else {
          pri += idx >= n - 8 ? 36 : 10;
        }
        pri -= i * 0.01;
        enqueueFrameLoad(store, idx, pri);
      }
    }

    function loadAllFrames(opts) {
      opts = opts || {};
      sequenceLoadFromEnd = !!opts.fromEnd;
      if (!totalFrames) {
        if (!sequenceLoadSilent) hideLoader();
        if (deferredDomMediaReleased) maybeStartDeferredS2bMedia(true);
        return;
      }
      if (!sequenceFramesUnlocked) {
        if (document.readyState === 'complete') enqueueActiveSequenceRemainder();
        return;
      }
      var activeId = resolveSequenceStage(activeSequenceStage);
      var live = getSequenceStore(activeId);
      if (live && phase1StoreKey && live.key === phase1StoreKey) {
        if (!defaultSequenceFullyReady() && document.readyState === 'complete') enqueueActiveSequenceRemainder();
        return;
      }
      sequenceFramesUnlocked = true;
      if (activeId === 1 || activeId === 3) pendingPriorityStage = activeId;
      enqueueCardSequential(activeId, 200);
      if (!backgroundImagesPaused()) pumpSeqLoadQueueNow();
    }

    /* Klik na jinou kartu: skryté snímky té karty jdou na začátek tiché fronty, videa se zastaví. */
    function preloadSequenceStage(stage, opts) {
      opts = opts || {};
      var store = getSequenceStore(stage);
      store.lastUsed = Date.now();
      retainSequenceStores([getSequenceStore(phase1Stage || 2), getSequenceStore(activeSequenceStage), store]);
      requestSilentCardPriority(stage);
      return store;
    }

    function runWhenIdle(fn, timeoutMs) {
      var budget = timeoutMs || 1000;
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(function () { fn(); }, { timeout: budget });
      } else {
        setTimeout(fn, 48);
      }
    }

    var phase1Stage = 2;
    var phase1StoreKey = '';
    var defaultSequenceLoadStarted = false;

    function phase1Store() {
      if (phase1StoreKey && sequenceStore[phase1StoreKey]) return sequenceStore[phase1StoreKey];
      return getSequenceStore(phase1Stage || 2);
    }

    function holdPipelineForDefaultSequence() {
      if (defaultSequenceFullyReady()) {
        window.__mojeS2bHoldPipeline = false;
        return;
      }
      window.__mojeS2bHoldPipeline = true;
    }

    function markDefaultSequenceReady() {
      if (window.__mojeS2bDefaultReady) return;
      if (!defaultSequenceFullyReady()) return;
      window.__mojeS2bDefaultReady = true;
      window.__mojeS2bHoldPipeline = false;
      try {
        document.dispatchEvent(new CustomEvent('moje:s2b-default-ready', { detail: { sectionId: sectionId } }));
      } catch (eReady) {}
      maybeStartDeferredS2bMedia();
      armSeoQuietTimer();
    }

    /*
     * Skryté pozadí ceníku až po dokončení tiché fronty.
     * Aktivní karta se smí dočíst dřív (hydrate drží ostatní zpátky).
     */
    function maybeStartDeferredS2bMedia(force) {
      if (!force && !defaultSequenceFullyReady()) return;
      applyAdaptiveDomImages();
      warmPricingStageImages({ all: !!deferredDomMediaReleased });
    }

    function publishWave1Progress() {
      var store = phase1Store();
      var urls = store && store.frameUrls ? store.frameUrls : [];
      var n = urls.length;
      var loaded = 0;
      var i;
      for (i = 0; i < n; i += 1) {
        var im = store.images[i];
        if (frameReady(im)) loaded += 1;
      }
      var info = { loaded: loaded, total: n, ready: n > 0 && loaded >= n };
      window.__mojeCard2Progress = info;
      window.__mojeWave1Progress = info;
    }

    function enqueueCardSequential(stage, basePriority) {
      var store = getSequenceStore(stage);
      if (!store || !store.frameUrls || !store.frameUrls.length) return;
      sequenceFramesUnlocked = true;
      var n = store.frameUrls.length;
      var i;
      for (i = 0; i < n; i += 1) enqueueFrameLoad(store, i, basePriority - i * 0.001);
    }

    function startActiveRemainder() {
      if (activeSequenceBackgroundArmed) return;
      activeSequenceBackgroundArmed = true;
      loadingWave1Only = false;
      sequenceFramesUnlocked = true;
      var store = phase1Store();
      if (store && store.key) phase1StoreKey = store.key;
      var n = store && store.frameUrls ? store.frameUrls.length : 0;
      if (!n) {
        publishWave1Progress();
        markDefaultSequenceReady();
        return;
      }
      enqueueCardSequential(store.stage || phase1Stage || 2, 10000);
      pumpSeqLoadQueueNow();
      publishWave1Progress();
      if (defaultSequenceFullyReady()) markDefaultSequenceReady();
    }

    function enqueueActiveSequenceRemainder() {
      startActiveRemainder();
    }

    function loadActiveSequenceFirstFrame() {
      var store = phase1Store();
      if (store && store.key) phase1StoreKey = store.key;
      enqueueFrameLoad(store, 0, 240);
      if (currentFrameIndex > 0) {
        enqueueFrameLoad(store, Math.min(currentFrameIndex, Math.max(0, store.frameUrls.length - 1)), 230);
      }
      pumpSeqLoadQueue();
    }

    function isSaveDataEnabled() {
      try {
        var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        return !!(conn && conn.saveData);
      } catch (eSave) {
        return false;
      }
    }

    function isLowMemoryDevice() {
      try {
        return !!(navigator.deviceMemory && navigator.deviceMemory <= 2);
      } catch (eMem) {
        return false;
      }
    }

    function beginDefaultSequenceLoad() {
      if (defaultSequenceLoadStarted) return;
      defaultSequenceLoadStarted = true;
      phase1Stage = resolveSequenceStage(activeSequenceStage);
      loadActiveSequenceFirstFrame();
      if (!activeSequenceBackgroundArmed) startActiveRemainder();
      else if (loadingWave1Only) pumpSeqLoadQueueNow();
      if (!activeFrameUrls().length) {
        publishWave1Progress();
        markDefaultSequenceReady();
      }
    }

    function releaseBackgroundQueue() {
      if (loadingWave1Only || !activeSequenceBackgroundArmed) startActiveRemainder();
      if (!bgQueueStarted) {
        bgQueueStarted = true;
        if (seoQuietTimer) {
          clearTimeout(seoQuietTimer);
          seoQuietTimer = 0;
        }
        ensureHiddenTerraformVideos();
        markTerraformQueueWaiting();
        silentPhase = 'A';
        videoPlanIndex = 0;
      }
      pumpSeqLoadQueue();
      pumpSilentVideos();
      window.__mojeS2bAutoplayAllowed = true;
      requestTick();
    }

    /*
     * Tichá fronta skrytých dat (Background Asset Queue).
     * Spouští se až po výchozí sekvenci a 3 s klidu v síti, nebo hned při scrollu do sekce.
     * Videa po jednom (loadeddata, nejvýš 1,5 s). Obrázky max 3, přes requestIdleCallback.
     * Scroll a přehrávané přechodové video pozastaví další položku; po scrollu se pokračuje za 200 ms.
     */
    var SEO_QUIET_MS = 3000;
    var SCROLL_RESUME_MS = 200;
    var userEnteredS2b = false;
    var s2bEntryBaselineSet = false;
    var s2bStartedOutside = true;
    var seoQuietTimer = 0;
    var scrollActive = false;
    var scrollIdleTimer = 0;
    var lastBgScrollY = 0;
    var pendingPriorityStage = 0;
    var bgVideoToken = 0;
    var bgVideoCurrent = null;
    var silentVideoBusy = false;
    var videoPlan = ['2-1', '2-3', '1-2', '1-3', '3-1', '3-2'];
    var videoPlanIndex = 0;

    function backgroundImagesPaused() {
      if (!defaultSequenceFullyReady()) return false;
      if (heroQueueMode() === 'pause') return true;
      if (autoplayPlaying) return true;
      if (pricingTransitioning) {
        if (pendingPriorityStage && !stageFramesSettled(pendingPriorityStage)) return false;
        return true;
      }
      return false;
    }

    function backgroundVideosPaused() {
      if (!defaultSequenceFullyReady()) return false;
      if (heroQueueMode() === 'pause') return true;
      return !!(autoplayPlaying || pricingTransitioning);
    }

    function backgroundQueuePaused() {
      return backgroundVideosPaused();
    }

    var scrollLayout = { rootTop: 0, rootH: 0, canvasTop: 0, canvasH: 0, heroTop: 0, heroH: 0, vh: 0, vw: 0, ready: false };
    var weakTouchUntil = 0;

    function cacheScrollLayout() {
      var y = window.scrollY || window.pageYOffset || 0;
      scrollLayout.vh = window.innerHeight || 0;
      scrollLayout.vw = window.innerWidth || 0;
      if (root) {
        var rect = root.getBoundingClientRect();
        scrollLayout.rootTop = y + rect.top;
        scrollLayout.rootH = rect.height || 0;
      }
      if (canvas) {
        var box = canvas.getBoundingClientRect();
        scrollLayout.canvasTop = y + box.top;
        scrollLayout.canvasH = box.height || 0;
      }
      var laser = document.querySelector('.laser-section-wrapper');
      if (laser) {
        var hero = laser.getBoundingClientRect();
        scrollLayout.heroTop = y + hero.top;
        scrollLayout.heroH = hero.height || 0;
      }
      scrollLayout.ready = true;
    }

    function s2bSectionIntersectsViewport() {
      if (!scrollLayout.ready) return false;
      var y = window.scrollY || window.pageYOffset || 0;
      var top = scrollLayout.rootTop - y;
      var bottom = top + scrollLayout.rootH;
      return bottom > 8 && top < scrollLayout.vh - 8;
    }

    function s2bCanvasInView() {
      if (!scrollLayout.ready) return false;
      var y = window.scrollY || window.pageYOffset || 0;
      var top = scrollLayout.canvasTop - y;
      var bottom = top + scrollLayout.canvasH;
      return bottom > 24 && top < scrollLayout.vh - 24;
    }

    function heroSectionRatio() {
      if (!scrollLayout.ready || !(scrollLayout.heroH > 0)) return 0;
      var y = window.scrollY || window.pageYOffset || 0;
      var top = scrollLayout.heroTop - y;
      var bottom = top + scrollLayout.heroH;
      var visH = Math.min(bottom, scrollLayout.vh) - Math.max(top, 0);
      if (visH <= 0) return 0;
      return visH / scrollLayout.heroH;
    }

    function strideForFrameCount(count) {
      var n = count | 0;
      if (n >= 160) return 5;
      if (n >= 80) return 4;
      return Math.max(2, Math.round(n / 16) || 2);
    }

    /* Vlna 1 / 2 / 3 jen uvnitř 0..count-1, ať 92, 93 ani 185 nesáhnou mimo sadu. */
    function frameWave(index, count) {
      var n = count | 0;
      if (index < 0 || index >= n) return 0;
      var stride = strideForFrameCount(n);
      var slot = index % stride;
      if (slot === 0) return 1;
      if (slot === Math.floor(stride / 2)) return 2;
      return 3;
    }

    function enqueueStageWave(stage, wave, priority) {
      enqueueCardSequential(stage, priority);
    }

    function stageFramesSettled(stage) {
      var store = getSequenceStore(stage);
      if (!store || !store.frameUrls || !store.frameUrls.length) return true;
      if (mobileKeepsOneCard() && store.stage !== activeSequenceStage && store.images !== images) {
        return (store.cacheTried || 0) >= store.frameUrls.length;
      }
      var i;
      for (i = 0; i < store.frameUrls.length; i += 1) {
        var im = store.images[i];
        if (!frameReady(im)) return false;
      }
      return true;
    }

    function silentPlanSettled() {
      return stageFramesSettled(1) && stageFramesSettled(3);
    }

    function noteSilentImageProgress() {
      if (!bgQueueStarted || silentPhase !== 'images') return;
      if (!silentPlanSettled()) return;
      silentPhase = 'D';
      pumpSilentVideos();
    }

    function beginSilentImages() {
      silentPhase = 'images';
      if (pendingPriorityStage === 1 || pendingPriorityStage === 3) enqueueCardSequential(pendingPriorityStage, 5000);
      enqueueCardSequential(1, 3000);
      enqueueCardSequential(3, 1000);
      if (silentPlanSettled()) {
        silentPhase = 'D';
        pumpSilentVideos();
        return;
      }
      scheduleSeqLoadPump();
    }

    function finishSilentQueue() {
      if (silentPhase === 'done') return;
      silentPhase = 'done';
      deferredDomMediaReleased = true;
      applyAdaptiveDomImages();
      warmPricingStageImages({ all: true });
      if (root) {
        var hiddenIntros = root.querySelectorAll('[data-s2b-crop-kind="intro"][data-src]');
        var hi;
        for (hi = 0; hi < hiddenIntros.length; hi += 1) {
          var introImg = hiddenIntros[hi];
          var introSet = introImg.getAttribute('data-srcset');
          var introSrc = introImg.getAttribute('data-src');
          if (introSet && introImg.getAttribute('srcset') !== introSet) introImg.setAttribute('srcset', introSet);
          if (introSrc && introImg.getAttribute('src') !== introSrc) introImg.src = introSrc;
        }
      }
      hydrateActiveIntroImages();
    }

    function abortBackgroundVideoLoads() {
      bgVideoToken += 1;
      silentVideoBusy = false;
      var video = bgVideoCurrent;
      bgVideoCurrent = null;
      if (!video) return;
      try { video.pause(); } catch (ePauseBg) {}
    }

    var TF_DEBUG_ORDER = ['2-1', '2-3', '1-2', '1-3', '3-1', '3-2'];

    function mojeNowMs() {
      try { return Math.round(performance.now()); } catch (eNow) { return 0; }
    }

    function mojeMediaBag() {
      if (!window.__mojeMediaDebug) {
        window.__mojeMediaDebug = { dcl: null, load: null, hero: { state: 'loading', at: null }, terraform: {} };
      }
      return window.__mojeMediaDebug;
    }

    function setTerraformDebug(key, state) {
      var bag = mojeMediaBag();
      var prev = bag.terraform[key] || {};
      var rec = { state: state, at: prev.at || null };
      if ((state === 'ready' || state === 'error' || state === 'meta' || state === 'cached') && prev.at == null) rec.at = mojeNowMs();
      if (state === 'loading' || state === 'wait') rec.at = null;
      bag.terraform[key] = rec;
      try { document.dispatchEvent(new CustomEvent('moje:debug-media')); } catch (eTfDbg) {}
    }

    function markTerraformQueueWaiting() {
      var i;
      for (i = 0; i < TF_DEBUG_ORDER.length; i += 1) {
        var key = TF_DEBUG_ORDER[i];
        var video = terraformVideos[key];
        if (video && video.readyState >= 4 && (video.getAttribute('src') || video.querySelector('source'))) {
          setTerraformDebug(key, 'ready');
          continue;
        }
        var rec = mojeMediaBag().terraform[key];
        if (rec && (rec.state === 'loading' || rec.state === 'cached' || rec.state === 'meta' || rec.state === 'ready')) continue;
        setTerraformDebug(key, 'wait');
      }
    }

    function warmVideoCache(url) {
      return new Promise(function (resolve) {
        if (!url) {
          resolve();
          return;
        }
        var done = false;
        function finish() {
          if (done) return;
          done = true;
          resolve();
        }
        var timer = setTimeout(finish, 4000);
        fetch(url, { cache: 'force-cache', credentials: 'omit', mode: 'cors' }).then(function (res) {
          return res.arrayBuffer();
        }).then(function () {
          clearTimeout(timer);
          finish();
        }).catch(function () {
          clearTimeout(timer);
          finish();
        });
      });
    }

    function loadOneBackgroundVideo(key, token) {
      return new Promise(function (resolve) {
        if (token !== bgVideoToken) {
          resolve(false);
          return;
        }
        var entry = terraformEntryForKey(key);
        var url = entry.mp4 || entry.webm || '';
        if (!url) {
          setTerraformDebug(key, 'error');
          resolve(true);
          return;
        }
        if (isIosWebKit() || mobileKeepsOneCard()) {
          setTerraformDebug(key, 'loading');
          if (typeof window.__mojeNoteVideoSrc === 'function') window.__mojeNoteVideoSrc(key, url);
          warmVideoCache(url).then(function () {
            if (token !== bgVideoToken) {
              resolve(false);
              return;
            }
            setTerraformDebug(key, 'cached');
            resolve(true);
          });
          return;
        }
        var video = getOrCreateTerraformVideo(key);
        if (video.getAttribute('data-tf-key') === key && (video.readyState >= 2 || video.getAttribute('data-tf-meta') === '1')) {
          setTerraformDebug(key, video.readyState >= 2 ? 'ready' : 'meta');
          resolve(true);
          return;
        }
        var settled = false;
        var timer = 0;
        function finish(state) {
          if (settled) return;
          settled = true;
          if (timer) clearTimeout(timer);
          if (bgVideoCurrent === video) bgVideoCurrent = null;
          video.removeEventListener('loadeddata', onData);
          video.removeEventListener('loadedmetadata', onMeta);
          video.removeEventListener('error', onFail);
          if (state === 'meta') video.setAttribute('data-tf-meta', '1');
          setTerraformDebug(key, state);
          if (!(pricingTransitioning && video === pricingVideo)) parkTerraformVideo(video);
          resolve(token === bgVideoToken);
        }
        function onData() {
          finish(video.readyState >= 2 ? 'ready' : 'meta');
        }
        function onMeta() {
          if (video.readyState >= 2) finish('ready');
        }
        function onFail() {
          finish('meta');
        }
        setTerraformDebug(key, 'loading');
        if (typeof window.__mojeNoteVideoSrc === 'function') window.__mojeNoteVideoSrc(key, url);
        bgVideoCurrent = video;
        peekTerraformVideo(video);
        bindTerraformSources(video, key);
        video.preload = 'auto';
        video.addEventListener('loadeddata', onData);
        video.addEventListener('loadedmetadata', onMeta);
        video.addEventListener('error', onFail);
        if (video.readyState >= 2) {
          finish('ready');
          return;
        }
        timer = setTimeout(function () {
          finish(video.readyState >= 2 ? 'ready' : 'meta');
        }, 1200);
      });
    }

    function pumpSilentVideos() {
      if (silentVideoBusy) return;
      if (silentPhase !== 'A' && silentPhase !== 'D') return;
      if (backgroundVideosPaused()) {
        setTimeout(pumpSilentVideos, 200);
        return;
      }
      var limit = silentPhase === 'A' ? 2 : videoPlan.length;
      if (videoPlanIndex >= limit || videoPlanIndex >= videoPlan.length) {
        if (silentPhase === 'A') beginSilentImages();
        else finishSilentQueue();
        return;
      }
      var key = videoPlan[videoPlanIndex];
      var token = bgVideoToken;
      silentVideoBusy = true;
      loadOneBackgroundVideo(key, token).then(function () {
        silentVideoBusy = false;
        if (token !== bgVideoToken) return;
        if (silentPhase !== 'A' && silentPhase !== 'D') return;
        videoPlanIndex += 1;
        var videoGap = mobileVideoGapMs();
        setTimeout(pumpSilentVideos, videoGap);
      });
    }

    function requestSilentCardPriority(stage) {
      var id = resolveSequenceStage(stage);
      if (id !== 1 && id !== 2 && id !== 3) return;
      abortBackgroundVideoLoads();
      if (id === 1 || id === 3) pendingPriorityStage = id;
      if (!userEnteredS2b) noteS2bSectionEntered();
      if (!bgQueueStarted) return;
      if ((id === 1 || id === 3 || id === 2) && !stageFramesSettled(id)) {
        enqueueCardSequential(id, 8000);
        if (silentPhase === 'A' || silentPhase === 'D') silentPhase = 'images';
        pumpSeqLoadQueueNow();
      }
    }

    function resumeBackgroundQueue() {
      if (!bgQueueStarted) return;
      if (!backgroundVideosPaused() && (silentPhase === 'A' || silentPhase === 'D')) pumpSilentVideos();
      if (!backgroundImagesPaused() && silentPhase === 'images') scheduleSeqLoadPump();
    }

    function startSilentAssetQueue() {
      if (bgQueueStarted) return;
      if (!defaultSequenceFullyReady()) return;
      bgQueueStarted = true;
      if (seoQuietTimer) {
        clearTimeout(seoQuietTimer);
        seoQuietTimer = 0;
      }
      ensureHiddenTerraformVideos();
      markTerraformQueueWaiting();
      if (pendingPriorityStage && !stageFramesSettled(pendingPriorityStage)) {
        beginSilentImages();
        return;
      }
      silentPhase = 'A';
      videoPlanIndex = 0;
      pumpSilentVideos();
    }

    function armSeoQuietTimer() {
      if (orientSwapActive) return;
      if (bgQueueStarted) return;
      if (!defaultSequenceFullyReady()) return;
      if (seoQuietTimer) return;
      seoQuietTimer = setTimeout(function () {
        seoQuietTimer = 0;
        startSilentAssetQueue();
      }, SEO_QUIET_MS);
    }

    function noteS2bSectionEntered() {
      userEnteredS2b = true;
    }

    function onBackgroundScrollActivity() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var entered = false;
      if (!s2bEntryBaselineSet) {
        s2bEntryBaselineSet = true;
        s2bStartedOutside = !s2bSectionIntersectsViewport();
      } else if (s2bStartedOutside && s2bSectionIntersectsViewport()) {
        entered = true;
      }
      lastBgScrollY = y;
      if (entered) noteS2bSectionEntered();
    }

    function syncIntroPhase() {
      var nodes = root.querySelectorAll('[data-s2b-seq-phase]');
      var i;
      for (i = 0; i < nodes.length; i += 1) {
        nodes[i].classList.toggle(
          'is-active',
          nodes[i].getAttribute('data-s2b-seq-phase') === String(activeSequenceStage)
        );
      }
      if (root) root.setAttribute('data-s2b-seq-phase', String(activeSequenceStage));
      hydrateActiveIntroImages();
    }

    function hydrateActiveIntroImages() {
      if (!root) return;
      var nodes = root.querySelectorAll('[data-s2b-crop-kind="intro"][data-s2b-seq-phase="' + activeSequenceStage + '"]');
      var i;
      for (i = 0; i < nodes.length; i += 1) {
        var img = nodes[i];
        if (!img || img.tagName !== 'IMG') continue;
        var dss = img.getAttribute('data-srcset');
        var ds = img.getAttribute('data-src');
        if (dss && img.getAttribute('srcset') !== dss) img.setAttribute('srcset', dss);
        if (ds && img.getAttribute('src') !== ds) img.src = ds;
      }
    }

    function bindActiveIntroLoad() {
      var hazeImg = introImageEl();
      function onHazeReady() {
        if (sequenceLayoutFrozen || pendingAutoplayFromNav) return;
        pinStartCached = false;
        updateMetrics({ refreshPinStart: true });
        syncIntroFade(currentFrameIndex);
        requestTick();
      }
      if (!hazeImg) return;
      var srcW = Number(hazeImg.getAttribute('data-s2b-haze-w'));
      var srcH = Number(hazeImg.getAttribute('data-s2b-haze-h'));
      if (hazeImg.tagName === 'IMG') {
        if (hazeImg.complete && hazeImg.naturalWidth) onHazeReady();
        else hazeImg.addEventListener('load', onHazeReady);
        return;
      }
      if (srcW > 1 && srcH > 1) onHazeReady();
    }

    function bindSequenceState(stage) {
      var store = getSequenceStore(stage);
      var changed = store.images !== images;
      activeSequenceStage = store.stage;
      frameUrls = store.frameUrls;
      images = store.images;
      loadedCount = store.loadedCount;
      totalFrames = frameUrls.length;
      maxFrameIndex = Math.max(0, totalFrames - 1);
      store.lastUsed = Date.now();
      if (changed) {
        /* Decode okno patří k předchozímu store – nový si ho postaví při prvním paintu. */
        resetDecodeWindow();
        decodeStoreRef = images;
        retainSequenceStores([store]);
      }
    }

    function flushFrozenSequenceLayout() {
      if (!sequenceLayoutFrozen) return;
      sequenceLayoutFrozen = false;
      syncIntroPhase();
      bindActiveIntroLoad();
      syncIntroLayout();
      applySectionHeight({ compensate: true });
      refreshPinStart(true);
    }

    function switchSequenceTo(stage, opts) {
      opts = opts || {};
      var next = resolveSequenceStage(stage);
      var nextUrls = sequenceUrlsFor(next);
      if (next === activeSequenceStage && frameUrls.join('|') === nextUrls.join('|')) {
        if (!sequenceLayoutFrozen) syncIntroPhase();
        return;
      }
      releaseMobileCardsExcept(next);
      bindSequenceState(next);
      lastDrawnIndex = -1;
      if (opts.fromEnd) currentFrameIndex = maxFrameIndex;
      sequenceLoadSilent = !!opts.silent;
      var freezeLayout = !!opts.freezeLayout ||
        journey === 'pricing' ||
        journey === 'buffer' ||
        journey === 'below';
      if (freezeLayout) sequenceLayoutFrozen = true;
      if (!sequenceLayoutFrozen) syncIntroPhase();
      applyAdaptiveDomImages();
      bindActiveIntroLoad();
      loadAllFrames({ fromEnd: !!opts.fromEnd });
      /* Dřív se tu dekódovalo všech 185 snímků najednou (~1,5 GB RGBA) – teď jen okno kolem aktuálního. */
      decodeWindowDir = opts.fromEnd ? -1 : 1;
      syncDecodeWindow(currentFrameIndex, true);
      if (opts.fromEnd && images[maxFrameIndex]) primeDecodedFrame(images[maxFrameIndex]);
      paintFrame(currentFrameIndex);
      if (!sequenceLayoutFrozen) {
        syncIntroLayout();
        applySectionHeight();
      }
      sequenceLoadSilent = false;
    }

    function frameIsSettled(index) {
      return frameReady(images[index]);
    }

    function frameCanPaint(index) {
      return frameReady(images[index]);
    }

    function countReadyRunway(fromIndex) {
      var i;
      var n = 0;
      var start = Math.max(0, fromIndex | 0);
      for (i = start; i <= maxFrameIndex; i += 1) {
        if (frameIsSettled(i)) n += 1;
        else break;
      }
      return n;
    }

    function defaultSequenceFullyReady() {
      if (!phase1StoreKey) {
        var early = sequenceUrlsFor(phase1Stage || 2);
        return !early.length;
      }
      var store = sequenceStore[phase1StoreKey];
      var list = store && store.images ? store.images : null;
      var n = store && store.frameUrls ? store.frameUrls.length : 0;
      if (!n || !list) return !n;
      var i;
      for (i = 0; i < n; i += 1) {
        var im = list[i];
        if (!frameReady(im)) return false;
      }
      return true;
    }

    function framesReadyForAutoplay() {
      if (!totalFrames) return true;
      if (!frameCanPaint(0)) return false;
      return defaultSequenceFullyReady();
    }

    function boostUpcomingAutoplayFrames(fromIndex) {
      var store = getSequenceStore(activeSequenceStage);
      var start = Math.max(0, fromIndex | 0);
      var to = Math.min(maxFrameIndex, start + 24);
      var i;
      for (i = start; i <= to; i += 1) {
        enqueueFrameLoad(store, i, 220 - (i - start));
      }
      pumpSeqLoadQueue();
    }

    /*
     * Ruční scrub narazil na ještě nestažený snímek: přednostně stáhnout okolí ve směru pohybu
     * (streamované načítání už nedrží scroll-lock, takže sekvence může být rozehraná dřív než 100 %).
     */
    var lastScrubBoostAt = 0;
    var lastScrubBoostIdx = -1;
    function boostFramesNearScrub(target) {
      /* Před rozjezdem výchozí sekvence (čeká se na hero) nic nepředbíhat. */
      if (!defaultSequenceLoadStarted) return;
      var now = Date.now();
      if (now - lastScrubBoostAt < 120 && Math.abs(target - lastScrubBoostIdx) < 4) return;
      lastScrubBoostAt = now;
      lastScrubBoostIdx = target;
      var store = getSequenceStore(activeSequenceStage);
      if (!store || store.images !== images) return;
      var dir = decodeWindowDir > 0 ? 1 : -1;
      var i;
      var idx;
      for (i = 0; i <= 24; i += 1) {
        idx = target + dir * i;
        if (idx < 0 || idx > maxFrameIndex) break;
        enqueueFrameLoad(store, idx, 240 - i);
      }
      for (i = 1; i <= 6; i += 1) {
        idx = target - dir * i;
        if (idx < 0 || idx > maxFrameIndex) break;
        enqueueFrameLoad(store, idx, 200 - i);
      }
      pumpSeqLoadQueue();
    }

    /*
     * Po autoplayi je uživatel na ceníku a scrubuje zpátky od konce → zbytek sekvence dočíst
     * od posledního snímku dolů (výchozí pořadí bylo vzestupné, konec by přišel jako poslední).
     */
    function prioritizeRemainingFramesFromEnd() {
      var store = getSequenceStore(activeSequenceStage);
      if (!store || store.images !== images || !totalFrames) return;
      var i;
      var rank = 0;
      for (i = maxFrameIndex; i >= 0; i -= 1) {
        if (store.images[i]) continue;
        enqueueFrameLoad(store, i, 190 - Math.min(80, rank * 0.5));
        rank += 1;
      }
      if (rank) pumpSeqLoadQueue();
    }

    function setFixedPin(active) {
      if (!root || !innerEl) return;
      if (active === mobileFixedPin) return;
      /*
       * Přepínání fixed ↔ sticky mění containing block (viewport vs. sekce).
       * Šířku držíme z předchozího boxu, ať karty i pozadí nezmění ořez.
       */
      ignoreMetricsUntil = Date.now() + 250;
      var prevW = Math.round(innerEl.getBoundingClientRect().width);
      if (typeof window.mojeFreezeViewportLock === 'function') {
        if (active && !mobileFixedPin) window.mojeFreezeViewportLock(true);
        if (!active && mobileFixedPin) window.mojeFreezeViewportLock(false);
      }
      mobileFixedPin = active;
      root.classList.toggle('moje-s2b--mobile-fixed-pin', active);
      innerEl.classList.toggle('moje-s2b__inner--fixed-pin', active);
      if (prevW > 0) {
        innerEl.style.width = prevW + 'px';
        innerEl.style.maxWidth = prevW + 'px';
      }
      if (mobileFixedPin) {
        innerEl.style.top = '0px';
        innerEl.style.left = '0px';
      } else {
        innerEl.style.top = '';
        innerEl.style.left = '';
      }
    }

    function pinForJourney() {
      if (journey === 'autoplay' || journey === 'sequence' || journey === 'buffer') {
        setFixedPin(true);
        return;
      }
      if (journey === 'pricing') {
        setFixedPin(pricingUseFixedPin);
        return;
      }
      setFixedPin(false);
    }

    function mountScrollHint() {
      if (!document.body) return;
      if (scrollHintEl && scrollHintEl.parentNode !== document.body) {
        document.body.appendChild(scrollHintEl);
      }
      if (seqMouseEl && seqMouseEl.parentNode !== document.body) {
        document.body.appendChild(seqMouseEl);
      }
    }

    function dismissScrollHint() {
      if (scrollHintGone) return;
      scrollHintGone = true;
      if (!scrollHintEl) return;
      scrollHintEl.classList.remove('is-visible');
      scrollHintEl.classList.add('is-gone');
    }

    function inManualSequenceScroll() {
      var y;
      var start;
      var end;
      if (!autoplayConsumed || autoplayPlaying) return false;
      if (journey === 'autoplay') return false;
      start = pinStartY;
      end = sequenceEndY();
      if (!(start > 8) || !(end > start + 8)) return false;
      y = visualScrollY();
      return y >= start - 2 && y < end - 4;
    }

    function syncSeqMouseHint() {
      if (!seqMouseEl) return;
      var on = inManualSequenceScroll();
      if (seqMouseEl.__mojeOn === on) return;
      seqMouseEl.__mojeOn = on;
      seqMouseEl.classList.toggle('is-visible', on);
    }

    function syncScrollHint() {
      if (!scrollHintEl) return;
      if (scrollHintGone) return;
      if (
        autoplayPlaying ||
        autoplayConsumed ||
        journey === 'autoplay' ||
        journey === 'sequence' ||
        journey === 'buffer' ||
        journey === 'pricing' ||
        journey === 'below'
      ) {
        dismissScrollHint();
        return;
      }
      var y = window.scrollY || window.pageYOffset || 0;
      if (pinStartY > 0 && y >= pinStartY - 0.5) {
        dismissScrollHint();
        return;
      }
      var top = scrollLayout.ready ? scrollLayout.rootTop - y : 0;
      var bottom = top + (scrollLayout.rootH || 0);
      var inView = scrollLayout.ready && bottom > 28 && top < scrollLayout.vh;
      if (scrollHintEl.__mojeShown === inView) return;
      scrollHintEl.__mojeShown = inView;
      scrollHintEl.classList.toggle('is-visible', inView);
    }

    function applyMistProgress(progress) {
      var p = Number(progress);
      if (!Number.isFinite(p)) p = 0;
      p = Math.max(0, Math.min(1, p));
      if (!root) return;
      var shown = (Math.round(p * 20) / 20).toFixed(2);
      if (root.__mojeMist === shown) return;
      root.__mojeMist = shown;
      root.style.setProperty('--mist-progress', shown);
      var inBuffer = p > 0.001;
      if (root.__mojeInBuffer !== inBuffer) {
        root.__mojeInBuffer = inBuffer;
        root.classList.toggle('moje-s2b--in-buffer', inBuffer);
      }
    }

    function bufferRawFromLocal(local) {
      var seqEnd = Math.max(0, sequencePx);
      var buf = Math.max(1, bufferPx);
      return (seqEnd + buf - local) / buf;
    }

    function mistProgressFromLocal(local) {
      var seqEnd = Math.max(0, sequencePx);
      var buf = Math.max(1, bufferPx);
      if (local >= seqEnd + buf) return 0;
      if (local <= seqEnd) {
        var blend = Math.max(24, seqEnd * 0.05);
        var dist = seqEnd - local;
        if (dist >= blend) return 0;
        return 1 - dist / blend;
      }
      var raw = (seqEnd + buf - local) / buf;
      if (raw <= BUFFER_DEAD_PCT) return 0;
      return Math.min(1, (raw - BUFFER_DEAD_PCT) / (1 - BUFFER_DEAD_PCT));
    }

    function clearDockAnchor() {
      if (dockAnchorTimer) {
        clearTimeout(dockAnchorTimer);
        dockAnchorTimer = 0;
      }
    }

    function snapToPricingDock() {
      if (isProgrammaticNav()) return;
      if (Date.now() < dockSnapLockUntil) return;
      var dock = Math.round(pricingDockY());
      if (Math.abs(getScrollY() - dock) < 1.5) return;
      dockSnapLockUntil = Date.now() + 80;
      setScrollY(dock);
      applyMistProgress(0);
    }

    function queueDockAnchor(local) {
      if (isProgrammaticNav()) {
        clearDockAnchor();
        return;
      }
      if (autoplayPlaying || journey === 'autoplay' || journey === 'sequence') {
        clearDockAnchor();
        return;
      }
      if (pricingTransitioning) {
        clearDockAnchor();
        return;
      }
      var seqEnd = Math.max(0, sequencePx);
      var buf = Math.max(1, bufferPx);
      var dockLocal = seqEnd + buf;
      if (local < seqEnd - 1 || local > dockLocal + 4) {
        clearDockAnchor();
        return;
      }
      var y = getScrollY();
      if (y < lastDockAnchorY - 0.4) dockAnchorDir = -1;
      else if (y > lastDockAnchorY + 0.4) dockAnchorDir = 1;
      lastDockAnchorY = y;
      var raw = (dockLocal - local) / buf;

      if (raw <= BUFFER_DEAD_PCT) {
        if (dockAnchorDir < 0) {
          clearDockAnchor();
          dockAnchorTimer = setTimeout(function () {
            dockAnchorTimer = 0;
            if (autoplayPlaying || journey === 'sequence') return;
            var loc = localScroll();
            var r = bufferRawFromLocal(loc);
            if (r > 0 && r <= BUFFER_DEAD_PCT) snapToPricingDock();
          }, 180);
          return;
        }
        snapToPricingDock();
        return;
      }
      if (dockAnchorDir > 0) {
        clearDockAnchor();
        dockAnchorTimer = setTimeout(function () {
          dockAnchorTimer = 0;
          if (autoplayPlaying || journey === 'sequence') return;
          var loc = localScroll();
          var r = bufferRawFromLocal(loc);
          if (r > BUFFER_DEAD_PCT && r < 1) snapToPricingDock();
        }, 220);
        return;
      }
      clearDockAnchor();
    }

    function clearPricingSeqRestoreTimer() {
      if (pricingSeqRestoreTimer) {
        clearTimeout(pricingSeqRestoreTimer);
        pricingSeqRestoreTimer = 0;
      }
    }

    function clearPricingFadeRetryTimer() {
      if (pricingFadeRetryTimer) {
        clearTimeout(pricingFadeRetryTimer);
        pricingFadeRetryTimer = 0;
      }
    }

    function lastSequenceFrameReady() {
      var img = images[maxFrameIndex];
      return !!(img && img.complete && img.naturalWidth);
    }

    function syncPricingCanvasBg() {
      if (!pricingScene) return false;
      paintFrame(maxFrameIndex);
      return lastSequenceFrameReady();
    }

    function showPricingVisual() {
      if (!pricingScene) return;
      var firstReveal = !pricingVisible;
      cancelPricingCardsExit({ restore: true });
      pricingExiting = false;
      pricingVisible = true;
      if (root) root.classList.add('moje-s2b--pricing-active');
      if (canvas) {
        canvas.style.opacity = '';
        canvas.style.visibility = '';
      }
      pricingScene.classList.remove('moje-s2b__pricing-scene--cards-out');
      pricingScene.classList.add('moje-s2b__pricing-scene--visible');
      pricingScene.classList.add('moje-s2b__pricing-scene--cards-in');
      pricingScene.setAttribute('aria-hidden', 'false');
      syncPricingCanvasBg();
      warmPricingStageImages();
      syncPricingTouchCapture();
      if (firstReveal) scheduleSnapPricingCarouselToActiveCard();
      syncPricingCarouselHintsLayout();
      requestAnimationFrame(function () {
        syncPricingFeaturesOverflow();
        syncPricingCarouselHintsLayout();
      });
    }

    function hidePricingVisual() {
      if (!pricingScene) return;
      cancelPricingCardsExit({ restore: false });
      pricingExiting = false;
      pricingVisible = false;
      if (root) {
        root.classList.remove('moje-s2b--pricing-active');
      }
      pricingScene.classList.remove('moje-s2b__pricing-scene--visible');
      pricingScene.classList.remove('moje-s2b__pricing-scene--cards-in');
      pricingScene.classList.remove('moje-s2b__pricing-scene--cards-out');
      pricingScene.classList.remove('moje-s2b__pricing-scene--seq-restore');
      pricingScene.classList.remove('moje-s2b__pricing-scene--carousel-loose');
      pricingScene.classList.remove('moje-s2b__pricing-scene--touch-capture');
      pricingScene.classList.remove('moje-s2b__pricing-scene--carousel-settling');
      pricingScene.setAttribute('aria-hidden', 'true');
      clearPricingCarouselPreviewClasses();
      resetPricingCarouselBgPan();
      collapseAllPricingFeatures(true);
      if (canvas) {
        canvas.style.opacity = '';
        canvas.style.visibility = '';
      }
    }

    function canLeavePricingDown() {
      return Date.now() >= pricingSettleUntil;
    }

    function enterPricing(opts) {
      opts = opts || {};
      var fromBelow = journey === 'below';
      var fromSequence = journey === 'sequence' || journey === 'autoplay' || journey === 'buffer';
      if (journey === 'pricing' && pricingVisible && !opts.force) {
        if (pricingExiting) showPricingVisual();
        pinForJourney();
        pricingLocked = true;
        return;
      }
      pricingUseFixedPin = !fromBelow && journey !== 'pre';
      journey = 'pricing';
      atPricing = true;
      pricingLocked = true;
      belowArmed = false;
      pricingSettleUntil = Date.now() + 280;
      applySectionHeight({ compensate: fromBelow });
      if (!fromBelow && !fromSequence) refreshPinStart(true);
      pinForJourney();
      paintFrame(maxFrameIndex);
      showPricingVisual();
      /* Karty jsou na obrazovce → warm metadat 2 přechodů z aktuální karty (ne 6 videí naplno). */
      startTerraformPreload(true);
      maybeStartDeferredS2bMedia(true);
      if (opts.snap !== false && !fromBelow) {
        var dock = Math.round(pricingDockY());
        if (Math.abs(getScrollY() - dock) > 2) setScrollY(dock);
        applyMistProgress(0);
      } else if (!fromSequence) {
        applyMistProgress(0);
      }
      lastDockAnchorY = getScrollY();
      dockAnchorDir = 0;
      requestAnimationFrame(function () {
        if (!pricingScene || journey !== 'pricing') return;
        pricingScene.classList.add('moje-s2b__pricing-scene--cards-in');
        if (!fromBelow) {
          scheduleSnapPricingCarouselToActiveCard();
          syncPricingFeaturesOverflow();
          syncPricingCarouselHintsLayout();
        }
        syncPricingTouchCapture();
      });
      persistS2bSession();
    }

    function enterSequence() {
      journey = 'sequence';
      atPricing = false;
      pricingLocked = false;
      dismissScrollHint();
      sequenceEnterUntil = Date.now() + 160;
      flushFrozenSequenceLayout();
      applySectionHeight({ compensate: false });
      pinForJourney();
      if (canvas) {
        canvas.style.opacity = '';
        canvas.style.visibility = '';
      }
    }

    function enterBuffer() {
      journey = 'buffer';
      atPricing = true;
      pricingLocked = true;
      pricingUseFixedPin = true;
      applySectionHeight({ compensate: false });
      pinForJourney();
      paintFrame(maxFrameIndex);
      showPricingVisual();
    }

    function enterBelow() {
      journey = 'below';
      atPricing = false;
      pricingLocked = false;
      belowArmed = false;
      pricingUseFixedPin = false;
      suppressPricingRelockUntil = Date.now() + 700;
      applySectionHeight({ compensate: false });
      setFixedPin(false);
      paintFrame(maxFrameIndex);
      showPricingVisual();
      applyMistProgress(0);
    }

    function autoplayYForFrame(index) {
      var t = maxFrameIndex > 0 ? Math.max(0, Math.min(1, index / maxFrameIndex)) : 1;
      return pinStartY + t * Math.max(0, sequencePx - 4);
    }

    function syncAutoplayScrollToFrame() {
      autoplayLockY = autoplayYForFrame(currentFrameIndex);
      setScrollY(autoplayLockY);
    }

    function autoplayScrollbarGapPx() {
      return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    }

    function lockAutoplayScroll(opts) {
      opts = opts || {};
      var live = getScrollY();
      var html = document.documentElement;
      var ideal = autoplayYForFrame(currentFrameIndex);
      if (opts.keepY || Math.abs(live - ideal) <= 24) {
        autoplayLockY = live;
      } else {
        autoplayLockY = ideal;
      }
      applyS2bScrollFreezePadding();
      if (!html.classList.contains('moje-s2b-autoplay-lock')) {
        html.classList.add('moje-s2b-autoplay-lock');
      }
      lockS2bChrome('autoplay');
      setFixedPin(true);
      if (!opts.keepY && Math.abs(getScrollY() - autoplayLockY) > 2) setScrollY(autoplayLockY);
    }

    function unlockAutoplayScroll() {
      var html = document.documentElement;
      html.classList.remove('moje-s2b-autoplay-lock');
      unlockS2bChrome('autoplay');
      clearS2bScrollFreezePadding();
    }

    function onAutoplayLockScroll() {
      if (!autoplayPlaying) return;
      if (isProgrammaticNav() && !pendingAutoplayFromNav) {
        consumeAutoplayWithoutPlay();
        requestTick();
        return;
      }
      setScrollY(autoplayLockY);
    }

    function onAutoplayLockWheel(event) {
      if (!autoplayPlaying) return;
      if (isProgrammaticNav() && !pendingAutoplayFromNav) {
        consumeAutoplayWithoutPlay();
        return;
      }
      if (event.cancelable) event.preventDefault();
      setScrollY(autoplayLockY);
    }

    function onAutoplayLockTouch(event) {
      if (!autoplayPlaying) return;
      if (isProgrammaticNav() && !pendingAutoplayFromNav) {
        consumeAutoplayWithoutPlay();
        return;
      }
      if (event.cancelable) event.preventDefault();
      setScrollY(autoplayLockY);
    }

    function showPricing() {
      enterPricing({ snap: false });
    }

    function hidePricing() {
      hidePricingVisual();
      pricingLocked = false;
    }

    function cancelPricingCardsExit(opts) {
      opts = opts || {};
      pricingFadeGen += 1;
      if (pricingCardsExitSceneTimer) {
        clearTimeout(pricingCardsExitSceneTimer);
        pricingCardsExitSceneTimer = null;
      }
      clearPricingFadeRetryTimer();
      pricingExiting = false;
      if (!pricingScene) return;
      var wasFading = pricingScene.classList.contains('moje-s2b__pricing-scene--phase2-exit');
      if (opts.restore && wasFading && pricingVisible) {
        pricingScene.classList.add('moje-s2b__pricing-scene--seq-restore');
        pricingScene.classList.remove('moje-s2b__pricing-scene--phase2-exit-active');
        pricingScene.classList.remove('moje-s2b__pricing-scene--phase2-exit');
        clearPricingSeqRestoreTimer();
        var restoreGen = pricingFadeGen;
        pricingSeqRestoreTimer = setTimeout(function () {
          pricingSeqRestoreTimer = 0;
          if (restoreGen !== pricingFadeGen || !pricingScene) return;
          pricingScene.classList.remove('moje-s2b__pricing-scene--seq-restore');
        }, PRICING_CARDS_RESTORE_MS + 40);
        pricingFadeCooldownUntil = Date.now() + 180;
        return;
      }
      clearPricingSeqRestoreTimer();
      pricingScene.classList.remove('moje-s2b__pricing-scene--phase2-exit-active');
      pricingScene.classList.remove('moje-s2b__pricing-scene--phase2-exit');
      if (!opts.restore) {
        pricingScene.classList.remove('moje-s2b__pricing-scene--seq-restore');
      }
    }

    function finishPricingCardsExitSceneHide() {
      if (!pricingExiting) return;
      if (journey !== 'sequence') {
        cancelPricingCardsExit({ restore: true });
        return;
      }
      hidePricingVisual();
    }

    function onPricingSceneTransitionEnd(event) {
      if (!pricingScene || event.target !== pricingScene) return;
      if (event.propertyName !== 'opacity') return;
      if (!pricingExiting) return;
      if (!pricingScene.classList.contains('moje-s2b__pricing-scene--phase2-exit-active')) return;
      finishPricingCardsExitSceneHide();
    }

    function beginPricingCardsExitForSequence() {
      if (!pricingScene) return;
      if (!pricingVisible) return;
      if (!pricingScene.classList.contains('moje-s2b__pricing-scene--visible')) return;
      if (pricingExiting || pricingScene.classList.contains('moje-s2b__pricing-scene--phase2-exit')) return;
      if (Date.now() < pricingFadeCooldownUntil) {
        if (!pricingFadeRetryTimer) {
          pricingFadeRetryTimer = setTimeout(function () {
            pricingFadeRetryTimer = 0;
            if (journey === 'sequence' && pricingVisible) beginPricingCardsExitForSequence();
          }, Math.max(16, pricingFadeCooldownUntil - Date.now() + 12));
        }
        return;
      }
      clearPricingFadeRetryTimer();
      clearPricingSeqRestoreTimer();
      pricingFadeGen += 1;
      var gen = pricingFadeGen;
      pricingExiting = true;
      if (canvas) {
        canvas.style.opacity = '';
        canvas.style.visibility = '';
      }
      pricingScene.classList.remove('moje-s2b__pricing-scene--seq-restore');
      pricingScene.classList.remove('moje-s2b__pricing-scene--cards-in');
      pricingScene.classList.remove('moje-s2b__pricing-scene--cards-out');
      pricingScene.classList.add('moje-s2b__pricing-scene--phase2-exit');
      pricingScene.classList.remove('moje-s2b__pricing-scene--phase2-exit-active');
      syncPricingTouchCapture();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (gen !== pricingFadeGen) return;
          if (!pricingScene || journey !== 'sequence') return;
          if (!pricingScene.classList.contains('moje-s2b__pricing-scene--phase2-exit')) return;
          pricingScene.classList.add('moje-s2b__pricing-scene--phase2-exit-active');
        });
      });
      if (pricingCardsExitSceneTimer) {
        clearTimeout(pricingCardsExitSceneTimer);
        pricingCardsExitSceneTimer = null;
      }
      pricingCardsExitSceneTimer = setTimeout(function () {
        if (gen !== pricingFadeGen) return;
        finishPricingCardsExitSceneHide();
      }, PRICING_CARDS_EXIT_FADE_MS + 80);
    }

    function onPricingWheel(event) {
      if (Number.isFinite(programmaticTargetY)) clearProgrammaticTarget();
      if (pricingTransitioning) {
        if (event.cancelable) event.preventDefault();
        pinTerraformScroll();
        return;
      }
      if (autoplayPlaying || journey === 'autoplay') {
        onAutoplayLockWheel(event);
        return;
      }
      if (pricingTransitioning && journey === 'pricing') {
        if (event.cancelable) event.preventDefault();
      }
    }

    function isCarouselHorizontalTarget(event) {
      var target = event.target;
      if (!target || !target.closest) return false;
      return !!target.closest('.moje-s2b__pricing-carousel, .moje-s2b__pricing-cards, [data-s3-pricing-card]');
    }

    function onPricingTouchStart(event) {
      if (!event.touches || !event.touches.length) return;
      pricingTouchY = event.touches[0].clientY;
      pricingFlingTouchActive = true;
      if (pricingFlingStopActive) releasePricingFlingStop();
    }

    function onPricingTouchMove(event) {
      if (pricingTransitioning) {
        if (event.cancelable) event.preventDefault();
        pinTerraformScroll();
        return;
      }
      if (autoplayPlaying) {
        onAutoplayLockTouch(event);
        return;
      }
      if (pricingTransitioning && journey === 'pricing') {
        if (event.cancelable) event.preventDefault();
      }
    }

    function onPricingTouchEnd() {
      pricingTouchY = null;
      pricingFlingTouchActive = false;
    }

    function finishAutoplay() {
      autoplayPlaying = false;
      autoplayConsumed = true;
      dismissScrollHint();
      if (autoplayRaf) {
        cancelAnimationFrame(autoplayRaf);
        autoplayRaf = 0;
      }
      paintFrame(maxFrameIndex);
      autoplayLockY = pricingDockY();
      setScrollY(autoplayLockY);
      lastScrollYForDir = autoplayLockY;
      pricingScrollVelPxMs = 0;
      pricingFlingArmed = false;
      unlockAutoplayScroll();
      setScrollY(autoplayLockY);
      enterPricing({ snap: true });
      /* Od teď se scrubuje od konce → dočíst zbytek sekvence od posledního snímku dolů. */
      decodeWindowDir = -1;
      syncDecodeWindow(maxFrameIndex, true);
      prioritizeRemainingFramesFromEnd();
      persistS2bSession();
      scheduleContinueAfterAutoplay();
      resumeBackgroundQueue();
    }

    function tickAutoplay(ts) {
      if (!autoplayPlaying) return;
      if (!autoplayLastTs) autoplayLastTs = ts;
      var dt = Math.min(64, ts - autoplayLastTs);
      autoplayLastTs = ts;
      /*
       * Rebuffer: přehrávání dojelo načtená data → držet aktuální snímek, dokud není připraven
       * blok AUTOPLAY_REBUFFER_FRAMES dalších snímků (nebo konec). Pokračuje se po blocích,
       * ne snímek po snímku – vizuálně krátká pauza místo trhání.
       */
      if (autoplayRebufferUntil >= 0) {
        var need = Math.min(maxFrameIndex, autoplayRebufferUntil);
        var from = currentFrameIndex + 1;
        if (from <= need && countReadyRunway(from) < (need - from + 1)) {
          if (!autoplayRebufferSince) autoplayRebufferSince = ts;
          if (ts - autoplayRebufferSince > AUTOPLAY_REBUFFER_GIVEUP_MS) {
            /* Síť stojí: nenechat uživatele zamčeného – dokončit na ceník, snímky se dočtou na pozadí. */
            autoplayRebufferUntil = -1;
            autoplayRebufferSince = 0;
            finishAutoplay();
            return;
          }
          autoplayFrameAcc = 0;
          syncAutoplayScrollToFrame();
          autoplayRaf = requestAnimationFrame(tickAutoplay);
          return;
        }
        autoplayRebufferUntil = -1;
        autoplayRebufferSince = 0;
      }
      autoplayFrameAcc += (activeAutoplayFps() * dt) / 1000;
      while (autoplayFrameAcc >= 1) {
        autoplayFrameAcc -= 1;
        if (currentFrameIndex >= maxFrameIndex) {
          finishAutoplay();
          return;
        }
        var next = currentFrameIndex + 1;
        if (!frameReady(images[next])) {
          autoplayFrameAcc = 0;
          autoplayRebufferUntil = Math.min(maxFrameIndex, next + AUTOPLAY_REBUFFER_FRAMES - 1);
          boostUpcomingAutoplayFrames(next);
          break;
        }
        paintFrame(next);
      }
      syncAutoplayScrollToFrame();
      autoplayRaf = requestAnimationFrame(tickAutoplay);
    }

    function startAutoplay(opts) {
      opts = opts || {};
      if (window.__mojeForceScrollTopUntil && Date.now() < window.__mojeForceScrollTopUntil) return;
      if (isMobileViewport() && window.__mojeContactPostedStay) return;
      if (isMobileViewport() && window.__mojeS2bHoldScrollUntil && Date.now() < window.__mojeS2bHoldScrollUntil) return;
      if (autoplayConsumed || autoplayPlaying) return;
      if (isProgrammaticNav() && !pendingAutoplayFromNav && !opts.fromNav) {
        consumeAutoplayWithoutPlay();
        requestTick();
        return;
      }
      if (!totalFrames) {
        autoplayConsumed = true;
        dismissScrollHint();
        enterPricing({ snap: true });
        scheduleContinueAfterAutoplay();
        return;
      }
      if (!frameReady(images[0])) {
        autoplayWaitingForRunway = true;
        return;
      }
      if (!framesReadyForAutoplay()) {
        autoplayWaitingForRunway = true;
        return;
      }
      autoplayWaitingForRunway = false;
      markDefaultSequenceReady();
      journey = 'autoplay';
      dismissScrollHint();
      if (!opts.fromNav) applySectionHeight({ compensate: false });
      autoplayPlaying = true;
      autoplayLastTs = 0;
      autoplayFrameAcc = 0;
      autoplayRebufferUntil = -1;
      autoplayRebufferSince = 0;
      decodeWindowDir = 1;
      syncDecodeWindow(0, true);
      lockAutoplayScroll({ keepY: !!opts.fromNav });
      if (opts.fromNav) {
        pinStartY = getScrollY();
        pinStartCached = pinStartY > 0;
        autoplayLockY = pinStartY;
      }
      paintFrame(0);
      hideLoader();
      warmPricingStageImages();
      autoplayRaf = requestAnimationFrame(tickAutoplay);
    }

    function localScroll() {
      return getScrollY() - pinStartY;
    }

    function nowMs() {
      return typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
    }

    function isMobilePricingFlingTarget() {
      if (!isMobileViewport()) return false;
      try {
        if (window.Shopify && window.Shopify.designMode) return false;
      } catch (eDesign) {}
      return true;
    }

    function samplePricingFlingVelocity(y) {
      var ts = nowMs();
      var dt = pricingFlingVelInited ? ts - pricingFlingVelTs : 999;
      var stale = !pricingFlingVelInited || dt >= 140 || dt <= 0;
      if (!stale) {
        pricingScrollVelPxMs = (y - lastScrollYForDir) / dt;
      } else {
        pricingScrollVelPxMs = 0;
        pricingFlingVelInited = true;
      }
      pricingFlingVelTs = ts;
      return stale;
    }

    function killPricingFlingMomentum(lockY) {
      var y = Math.max(0, Math.round(lockY));
      pricingScrollVelPxMs = 0;
      setScrollY(y);
      try {
        if (window.scrollTo) window.scrollTo(0, y);
      } catch (eScrollTo) {}
      requestAnimationFrame(function () {
        setScrollY(y);
        try {
          if (window.scrollTo) window.scrollTo(0, y);
        } catch (eScrollTo2) {}
        requestAnimationFrame(function () {
          setScrollY(y);
        });
      });
    }

    function unfreezeDocumentScrollForPricingFling() {
      if (pricingFlingFreezeRaf) {
        cancelAnimationFrame(pricingFlingFreezeRaf);
        pricingFlingFreezeRaf = 0;
      }
      if (pricingFlingSafetyTimer) {
        clearTimeout(pricingFlingSafetyTimer);
        pricingFlingSafetyTimer = 0;
      }
      if (root) root.classList.remove('moje-s2b--checkpoint-stop');
      var html = document.documentElement;
      html.classList.remove('moje-s2b-checkpoint-scroll-freeze');
      if (!pricingFlingFrozen) return;
      pricingFlingFrozen = false;
      html.style.overflow = pricingFlingPrevHtmlOverflow || '';
      html.style.overscrollBehavior = pricingFlingPrevHtmlOverscroll || '';
      if (document.body) {
        document.body.style.overflow = pricingFlingPrevBodyOverflow || '';
        document.body.style.overscrollBehavior = pricingFlingPrevBodyOverscroll || '';
      }
    }

    function freezeDocumentScrollForPricingFling(lockY) {
      var html = document.documentElement;
      var body = document.body;
      var firstFreeze = !pricingFlingFrozen;
      if (firstFreeze) {
        pricingFlingFrozen = true;
        pricingFlingPrevHtmlOverflow = html.style.overflow;
        pricingFlingPrevBodyOverflow = body ? body.style.overflow : '';
        pricingFlingPrevHtmlOverscroll = html.style.overscrollBehavior;
        pricingFlingPrevBodyOverscroll = body ? body.style.overscrollBehavior : '';
        html.style.overflow = 'hidden';
        html.style.overscrollBehavior = 'none';
        if (body) {
          body.style.overflow = 'hidden';
          body.style.overscrollBehavior = 'none';
        }
        html.classList.add('moje-s2b-checkpoint-scroll-freeze');
        if (root) root.classList.add('moje-s2b--checkpoint-stop');
      }
      if (lockY !== null && Number.isFinite(lockY)) {
        if (firstFreeze) killPricingFlingMomentum(lockY);
        else if (Math.abs(getScrollY() - lockY) > 0.5) setScrollY(lockY);
      }
      if (!pricingFlingFreezeRaf) {
        var pinLoop = function () {
          pricingFlingFreezeRaf = 0;
          if (!pricingFlingFrozen || pricingFlingLockY === null || !s2bSectionIntersectsViewport()) return;
          if (Math.abs(getScrollY() - pricingFlingLockY) > 8) {
            setScrollY(pricingFlingLockY);
          }
          if (pricingFlingFreezeRaf) return;
          pricingFlingFreezeRaf = requestAnimationFrame(pinLoop);
        };
        pricingFlingFreezeRaf = requestAnimationFrame(pinLoop);
      }
      if (pricingFlingSafetyTimer) clearTimeout(pricingFlingSafetyTimer);
      pricingFlingSafetyTimer = setTimeout(function () {
        pricingFlingSafetyTimer = 0;
        if (pricingFlingFreezeRaf) {
          cancelAnimationFrame(pricingFlingFreezeRaf);
          pricingFlingFreezeRaf = 0;
        }
        releasePricingFlingStop();
      }, 800);
    }

    function releasePricingFlingStop() {
      if (!pricingFlingStopActive && !pricingFlingFrozen) return;
      if (pricingFlingReleaseTimer) {
        clearTimeout(pricingFlingReleaseTimer);
        pricingFlingReleaseTimer = 0;
      }
      var lockY = pricingFlingLockY;
      pricingFlingStopActive = false;
      pricingFlingHoldUntil = 0;
      pricingFlingLockY = null;
      pricingFlingArmed = false;
      unfreezeDocumentScrollForPricingFling();
      if (lockY !== null && Number.isFinite(lockY)) {
        killPricingFlingMomentum(lockY);
        lastScrollYForDir = lockY;
      } else {
        lastScrollYForDir = getScrollY();
      }
      pricingScrollVelPxMs = 0;
    }

    function enforcePricingFlingLock() {
      if (!pricingFlingStopActive || pricingFlingLockY === null) return false;
      if (!pricingFlingFrozen) {
        freezeDocumentScrollForPricingFling(pricingFlingLockY);
      } else if (Math.abs(getScrollY() - pricingFlingLockY) > 0.5) {
        setScrollY(pricingFlingLockY);
      }
      pricingScrollVelPxMs = 0;
      lastScrollYForDir = pricingFlingLockY;
      return true;
    }

    function updatePricingFlingArming(y, vel) {
      var dock = pricingDockY();
      if (!Number.isFinite(dock)) return;
      var leavePad = Math.max(90, getViewportH() * 0.22);
      var settlePad = Math.max(36, getViewportH() * 0.08);
      if (Math.abs(y - dock) > leavePad) {
        pricingFlingArmed = true;
        return;
      }
      if (Math.abs(y - dock) <= settlePad && Math.abs(vel) < PRICING_FLING_VEL_PX_MS * 0.45) {
        pricingFlingArmed = false;
      }
    }

    function engagePricingFlingStop(dockY, opts) {
      opts = opts || {};
      var dock = Math.max(0, Math.round(dockY));
      var liveY = getScrollY();
      var fromBelow = !!opts.fromBelow || journey === 'below' || liveY > dock + 12;
      pricingFlingStopActive = true;
      pricingFlingLockY = dock;
      pricingFlingHoldUntil = Date.now() + PRICING_FLING_HOLD_MS;
      pricingFlingArmed = false;
      pricingScrollVelPxMs = 0;
      cancelPricingCardsExit({ restore: false });
      if (fromBelow) {
        /*
         * Zespodu nesmí enterPricing sahat na výšku sekce (compensate)
         * ani nechat sticky pin. overflow:hidden jinak na iOS na 1 snímek
         * shodí scroll na 0 a problikne začátek stránky.
         * Nejdřív fixed overlay karet, až potom freeze.
         */
        journey = 'pricing';
        atPricing = true;
        pricingLocked = true;
        belowArmed = false;
        suppressPricingRelockUntil = 0;
        pricingSettleUntil = Date.now() + 280;
        pricingUseFixedPin = true;
        if (!pricingVisible) showPricingVisual();
        else if (root) root.classList.add('moje-s2b--pricing-active');
        if (pricingScene) {
          pricingScene.classList.add('moje-s2b__pricing-scene--visible');
          pricingScene.classList.add('moje-s2b__pricing-scene--cards-in');
        }
        applyMistProgress(0);
        setFixedPin(true);
        if (innerEl) void innerEl.offsetHeight;
      } else if (journey !== 'pricing') {
        enterPricing({ snap: false });
      } else {
        pinForJourney();
        if (!pricingVisible || pricingExiting) showPricingVisual();
      }
      dock = Math.max(0, Math.round(pricingDockY()));
      pricingFlingLockY = dock;
      applyMistProgress(0);
      setScrollY(dock);
      if (innerEl) void innerEl.offsetHeight;
      freezeDocumentScrollForPricingFling(dock);
      lastScrollYForDir = dock;
      if (pricingFlingReleaseTimer) clearTimeout(pricingFlingReleaseTimer);
      pricingFlingReleaseTimer = setTimeout(function () {
        pricingFlingReleaseTimer = 0;
        releasePricingFlingStop();
      }, PRICING_FLING_HOLD_MS);
    }

    function maybeCatchPricingFling(yNow, prevY) {
      if (!isMobilePricingFlingTarget()) return false;
      if (isMobileViewport() && window.__mojeContactPostedStay) return false;
      if (isMobileViewport() && window.__mojeS2bHoldScrollUntil && Date.now() < window.__mojeS2bHoldScrollUntil) return false;
      if (enforcePricingFlingLock()) return true;
      if (isProgrammaticNav()) return false;
      if (pricingTransitioning) return false;
      if (pricingFlingTouchActive) {
        updatePricingFlingArming(yNow, pricingScrollVelPxMs);
        return false;
      }
      if (pricingZoneTouchAxis === 'x') return false;
      if (!pricingFlingArmed) {
        updatePricingFlingArming(yNow, pricingScrollVelPxMs);
        return false;
      }

      var dock = Math.round(pricingDockY());
      if (!Number.isFinite(dock) || dock < 8) return false;
      var dy = yNow - prevY;
      var vel = Math.abs(pricingScrollVelPxMs);
      var fast = vel >= PRICING_FLING_VEL_PX_MS || Math.abs(dy) >= PRICING_FLING_JUMP_PX;
      if (!fast) {
        updatePricingFlingArming(yNow, pricingScrollVelPxMs);
        return false;
      }

      var goingDown = dy > 0.4 || (Math.abs(dy) <= 0.4 && pricingScrollVelPxMs > 0);
      var goingUp = dy < -0.4 || (Math.abs(dy) <= 0.4 && pricingScrollVelPxMs < 0);
      var catchPad = Math.max(56, getViewportH() * 0.16);
      var crossed = (prevY < dock && yNow >= dock) || (prevY > dock && yNow <= dock);
      var near = Math.abs(yNow - dock) <= catchPad;
      var towardDock = (goingDown && prevY < dock) || (goingUp && prevY > dock);
      if (!crossed && !(near && towardDock)) {
        updatePricingFlingArming(yNow, pricingScrollVelPxMs);
        return false;
      }

      engagePricingFlingStop(dock, { fromBelow: goingUp || journey === 'below' });
      return true;
    }

    function updateFromScroll() {
      if (pinTerraformScroll()) return;
      if (autoplayPlaying || journey === 'autoplay') {
        if (isProgrammaticNav() && !pendingAutoplayFromNav) {
          consumeAutoplayWithoutPlay();
        } else {
          setScrollY(autoplayLockY);
          lastScrollYForDir = autoplayLockY;
          pricingFlingVelTs = nowMs();
          pricingScrollVelPxMs = 0;
          return;
        }
      }
      if (pricingFlingStopActive && enforcePricingFlingLock()) return;
      var yNow = visualScrollY();
      var prevY = lastScrollYForDir;
      var staleSample = samplePricingFlingVelocity(yNow);
      if (staleSample) {
        lastScrollYForDir = yNow;
        updatePricingFlingArming(yNow, 0);
      } else if (maybeCatchPricingFling(yNow, prevY)) {
        lastScrollYForDir = pricingFlingLockY !== null ? pricingFlingLockY : getScrollY();
        return;
      } else {
        lastScrollYForDir = yNow;
      }
      var local = yNow - pinStartY;
      var seqEnd = Math.max(0, sequencePx);
      var dockLocal = seqEnd + Math.max(0, bufferPx);

      if (!autoplayConsumed) {
        if (window.__mojeForceScrollTopUntil && Date.now() < window.__mojeForceScrollTopUntil) {
          paintFrame(0);
          return;
        }
        if (isMobileViewport() && (window.__mojeContactPostedStay || (window.__mojeS2bHoldScrollUntil && Date.now() < window.__mojeS2bHoldScrollUntil))) {
          autoplayConsumed = true;
        } else if (local >= 0) {
          if (pendingAutoplayFromNav) {
            tryStartPendingAutoplay();
            return;
          }
          if (isProgrammaticNav()) {
            consumeAutoplayWithoutPlay();
          } else if (totalFrames && framesReadyForAutoplay()) {
            startAutoplay();
            return;
          } else if (!totalFrames) {
            autoplayConsumed = true;
            dismissScrollHint();
            enterPricing({ snap: true });
            return;
          } else {
            /* Runway ještě není – po každém načteném snímku přijde requestTick() a autoplay se rozjede sám. */
            autoplayWaitingForRunway = true;
            beginDefaultSequenceLoad();
            paintFrame(0);
            return;
          }
        } else {
          paintFrame(0);
          return;
        }
      }

      if (local < 0) {
        paintFrame(0);
        setFixedPin(false);
        applyMistProgress(0);
        if (pricingVisible) hidePricingVisual();
        return;
      }

      var mist = mistProgressFromLocal(local);

      if (local < seqEnd) {
        if (journey !== 'sequence') enterSequence();
        setFixedPin(true);
        var t = seqEnd <= 0 ? 1 : Math.max(0, Math.min(1, local / seqEnd));
        paintFrame(frameIndexForProgress(t));
        applyMistProgress(mist);
        if (pricingVisible) {
          if (isProgrammaticNav()) hidePricingVisual();
          else beginPricingCardsExitForSequence();
        }
        return;
      }

      if (local < dockLocal - 0.5) {
        if (journey === 'sequence' || journey === 'buffer') {
          enterPricing({ snap: false });
        } else if (journey !== 'pricing') {
          enterPricing({ snap: false });
        }
        pricingUseFixedPin = true;
        setFixedPin(true);
        paintFrame(maxFrameIndex);
        if (!pricingVisible || pricingExiting) showPricingVisual();
        applyMistProgress(mist);
        queueDockAnchor(local);
        return;
      }

      var dockY = pricingDockY();
      if (yNow <= dockY + 28) {
        if (journey === 'below' && Date.now() < suppressPricingRelockUntil) {
          applyMistProgress(0);
          return;
        }
        if (journey !== 'pricing') enterPricing({ snap: false });
        pinForJourney();
        paintFrame(maxFrameIndex);
        if (!pricingVisible || pricingExiting) showPricingVisual();
        applyMistProgress(0);
        return;
      }

      if (journey !== 'below') enterBelow();
      setFixedPin(false);
      if (!pricingVisible || pricingExiting) showPricingVisual();
      applyMistProgress(0);
    }

    function requestTick() {
      if (rafScheduled) return;
      rafScheduled = true;
      requestAnimationFrame(function () {
        rafScheduled = false;
        updateFromScroll();
        syncScrollHint();
        syncSeqMouseHint();
        if (bgQueueStarted && heroQueueMode() === 'run') resumeBackgroundQueue();
      });
    }

    function noteScrollFps(now) {
      if (!mojeS2bDebugOn()) return;
      var marks = noteScrollFps.marks || (noteScrollFps.marks = []);
      marks.push(now);
      var cut = now - 1000;
      while (marks.length && marks[0] < cut) marks.shift();
      if (marks.length < 2) return;
      perfFps = Math.round(((marks.length - 1) * 1000) / (now - marks[0]));
      perfFpsSampled = true;
      if (!perfFpsMin || perfFps < perfFpsMin) perfFpsMin = perfFps;
    }

    /* —— Pricing cards —— */
    function getVideoMapEntry(entry) {
      if (!entry) return { webm: '', mp4: '' };
      if (typeof entry === 'string') return { webm: '', mp4: entry };
      return sanitizeVideoCatalogEntry({ webm: entry.webm || '', mp4: entry.mp4 || '' });
    }

    function getPricingTransitionKey(fromStage, toStage) {
      return String(fromStage) + '-' + String(toStage);
    }

    function getPricingTransitionEntry(fromStage, toStage, packHint) {
      var key = getPricingTransitionKey(fromStage, toStage);
      var maps = pricingVideoMap || {};
      var desktop = maps.desktop || {};
      var mobile = maps.mobile || {};
      var wantWide = packHint === 'desktop' || packHint === 'd' ||
        ((packHint !== 'mobile' && packHint !== 'm') && useWideMediaAssets());
      /* Bez křížového fallbacku: na výšku se PC video nesmí stáhnout ani když mobilní chybí. */
      var entry = wantWide ? desktop[key] : mobile[key];
      return getVideoMapEntry(entry);
    }

    function assignVideoElementSources(video, entry) {
      if (!video) return false;
      var parsed = getVideoMapEntry(entry);
      var next = parsed.mp4 || parsed.webm || '';
      if (!next) return false;
      var locked = video.getAttribute('data-moje-src-locked') || '';
      if (locked) return false;
      var current = video.currentSrc || video.getAttribute('src') || '';
      if (current === next) {
        video.setAttribute('data-moje-src-locked', next);
        return false;
      }
      video.preload = 'auto';
      video.src = next;
      video.setAttribute('data-moje-src-locked', next);
      if (typeof window.__mojeNoteVideoSrc === 'function') {
        window.__mojeNoteVideoSrc(video.getAttribute('data-tf-key') || 'tf', next);
      }
      return true;
    }

    function terraformEntryForKey(key) {
      var parts = String(key || '').split('-');
      return getPricingTransitionEntry(Number(parts[0]), Number(parts[1]));
    }

    function terraformPreferredUrl(key) {
      var parsed = terraformEntryForKey(key);
      return parsed.mp4 || parsed.webm || '';
    }

    function ensureTerraformDock() {
      if (terraformDock && terraformDock.isConnected) {
        if (root && terraformDock.parentNode !== root) root.appendChild(terraformDock);
        return terraformDock;
      }
      terraformDock = document.getElementById('moje-s2b-terraform-dock-' + sectionId);
      if (!terraformDock) {
        terraformDock = document.createElement('div');
        terraformDock.id = 'moje-s2b-terraform-dock-' + sectionId;
        terraformDock.className = 'moje-s2b__terraform-dock';
        terraformDock.setAttribute('aria-hidden', 'true');
      }
      if (root) root.appendChild(terraformDock);
      else if (document.body) document.body.appendChild(terraformDock);
      return terraformDock;
    }

    function createTerraformVideoEl(key) {
      var v = document.createElement('video');
      v.className = 'moje-s2b__pricing-video';
      v.muted = true;
      v.defaultMuted = true;
      v.playsInline = true;
      v.preload = 'metadata';
      v.controls = false;
      v.tabIndex = -1;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.setAttribute('data-tf-key', key);
      return v;
    }

    function parkTerraformVideo(video) {
      if (!video) return;
      video.classList.remove('moje-s2b__tf-peek');
      video.classList.remove('moje-s2b__tf-live');
      video.style.setProperty('display', 'none', 'important');
      video.style.visibility = 'hidden';
      video.style.width = '';
      video.style.height = '';
    }

    function peekTerraformVideo(video) {
      if (!video) return;
      video.classList.remove('moje-s2b__tf-live');
      video.classList.add('moje-s2b__tf-peek');
      video.style.display = 'block';
      video.style.visibility = 'hidden';
      video.style.position = 'absolute';
      video.style.width = '1px';
      video.style.height = '1px';
    }

    function showTerraformVideoEl(video) {
      if (!video) return;
      video.classList.remove('moje-s2b__tf-peek');
      video.classList.add('moje-s2b__tf-live');
      video.style.display = 'block';
      video.style.visibility = 'visible';
      video.style.opacity = '1';
      video.style.pointerEvents = 'none';
      video.style.position = 'absolute';
      video.style.zIndex = '2';
      video.style.width = '';
      video.style.height = '';
    }

    function getOrCreateTerraformVideo(key) {
      var pack = useWideMediaAssets() ? 'desktop' : 'mobile';
      var domId = pack + ':' + key;
      var live = terraformVideos[domId];
      if (live && live.isConnected) {
        terraformVideos[key] = live;
        return live;
      }
      var dock = ensureTerraformDock();
      var existing = dock.querySelector('video[data-tf-dom="' + domId + '"]');
      if (!existing && pricingVideoLayer) {
        existing = pricingVideoLayer.querySelector('video[data-tf-dom="' + domId + '"]');
      }
      if (!existing) {
        existing = createTerraformVideoEl(key);
        existing.setAttribute('data-tf-dom', domId);
        existing.setAttribute('data-tf-pack', pack);
      }
      if (existing.parentNode !== dock && existing !== pricingVideo) dock.appendChild(existing);
      terraformVideos[domId] = existing;
      terraformVideos[key] = existing;
      if (existing !== pricingVideo) parkTerraformVideo(existing);
      return existing;
    }

    function terraformVideoIsReady(video) {
      return !!(video && video.readyState >= 3);
    }

    function terraformFileId(key) {
      return (useWideMediaAssets() ? 'd' : 'm') + ':' + key;
    }

    function terraformBlobUrlForKey(key) {
      var rec = terraformFileCache[terraformFileId(key)];
      if (!rec || rec.status !== 'ready' || !rec.blobUrl) return '';
      var live = terraformPreferredUrl(key);
      if (!live || rec.url !== live) return '';
      return rec.blobUrl;
    }

    function terraformPlaybackEntry(key) {
      return terraformEntryForKey(key);
    }

    function bindTerraformSources(video, key) {
      if (!video) return;
      var entry = terraformEntryForKey(key);
      var url = entry.mp4 || entry.webm || '';
      if (!url) return;
      video.setAttribute('data-tf-key', key);
      video.setAttribute('data-tf-pack', useWideMediaAssets() ? 'desktop' : 'mobile');
      var locked = video.getAttribute('data-moje-src-locked') || '';
      if (locked && locked !== url) return;
      if (!locked) assignVideoElementSources(video, entry);
    }

    /* Klíče přechodů z aktuální karty (max 2). */
    function terraformKeysFromCurrentStage() {
      var from = String(currentPricingStage || 2);
      return TERRAFORM_KEYS.filter(function (key) {
        return key.indexOf(from + '-') === 0;
      });
    }

    function trimTerraformDock() {}

    /*
     * Dvě videa, která jdou z aktuální karty spustit, se stáhnou celá přes fetch
     * (mobilní prohlížeč by u <video preload> zůstal na metadatech). Po přechodu
     * se zásoba vymění za novou dvojici. Klik dál pouští video hned.
     */
    function releaseTerraformFile(id) {
      var rec = terraformFileCache[id];
      if (!rec) return;
      var key = id.indexOf(':') >= 0 ? id.slice(id.indexOf(':') + 1) : '';
      var video = key ? terraformVideos[key] : null;
      if (
        video &&
        video === pricingVideo &&
        pricingTransitioning &&
        rec.blobUrl &&
        video.getAttribute('data-tf-blob') === rec.blobUrl
      ) {
        return;
      }
      delete terraformFileCache[id];
      if (rec.controller) {
        try { rec.controller.abort(); } catch (eAbortTf) {}
        rec.controller = null;
      }
      if (video && rec.blobUrl && video.getAttribute('data-tf-blob') === rec.blobUrl) {
        try { video.pause(); } catch (ePauseRel) {}
      }
      if (rec.blobUrl) {
        try { URL.revokeObjectURL(rec.blobUrl); } catch (eRevokeTf) {}
        rec.blobUrl = '';
      }
    }

    function primeTerraformElement(key) {
      if (pricingTransitioning && pricingVideo && pricingVideo.getAttribute('data-tf-key') === key) return;
      var video = getOrCreateTerraformVideo(key);
      if (!video) return;
      bindTerraformSources(video, key, true);
    }

    function fetchTerraformFile() {}

    function terraformKeysForStage(stage) {
      var from = String(stage || currentPricingStage || 2);
      return TERRAFORM_KEYS.filter(function (key) {
        return key.indexOf(from + '-') === 0;
      });
    }

    /* Šest skrytých přechodů existuje hned, ale bez src — prohlížeč nestahuje nic, dokud se karta neaktivuje. */
    function ensureHiddenTerraformVideos() {
      var i;
      ensureTerraformDock();
      for (i = 0; i < TERRAFORM_KEYS.length; i += 1) {
        var video = getOrCreateTerraformVideo(TERRAFORM_KEYS[i]);
        if (!video.getAttribute('src') && !video.querySelector('source')) {
          video.preload = (isIosWebKit() || mobileKeepsOneCard()) ? 'none' : 'metadata';
        }
      }
    }

    function releaseTerraformBuffer(video) {
      if (!video) return;
      if (video === pricingVideo && pricingTransitioning) return;
      try { video.pause(); } catch (ePauseBuf) {}
    }

    /* Skrytá přechodová videa stahuje tichá fronta přímo do <video> (loadeddata / metadata). */
    function bufferTerraformPairForStage() {
      ensureHiddenTerraformVideos();
    }

    function pumpTerraformFilePreload() {
      bufferTerraformPairForStage(currentPricingStage);
    }

    function queueTerraformFilePreload() {}

    function startTerraformPreload() {
      if (!pricingCardsInView || pricingTransitioning) return;
      terraformPreloadStarted = true;
      ensureTerraformDock();
      var placeholder = document.getElementById('moje-s2b-pricing-video-' + sectionId);
      if (placeholder && !placeholder.getAttribute('data-tf-key')) {
        placeholder.preload = 'none';
        parkTerraformVideo(placeholder);
      }
      bufferTerraformPairForStage(currentPricingStage);
    }

    /* Karusel už o zásobě nerozhoduje – vždy se drží dvojice z aktuální karty. */
    var terraformIntentKey = '';
    function warmTerraformForIntent() {}

    function bindTerraformIntent() {
      if (!pricingScene) return;
      function stageFromEvent(event) {
        var card = event.target && event.target.closest
          ? event.target.closest('[data-s3-pricing-card], [data-s3-card-trigger]')
          : null;
        if (!card) return NaN;
        return Number(card.getAttribute('data-s3-pricing-card') || card.getAttribute('data-s3-card-trigger'));
      }
      /* Desktop: hover / klávesnicový fokus. */
      pricingScene.addEventListener('pointerover', function (event) {
        if (event.pointerType === 'touch') return;
        var stage = stageFromEvent(event);
        if (Number.isFinite(stage)) warmTerraformForIntent(stage);
      }, { passive: true });
      pricingScene.addEventListener('focusin', function (event) {
        var stage = stageFromEvent(event);
        if (Number.isFinite(stage)) warmTerraformForIntent(stage);
      });
      /* Mobil: dotyk na kartu (v karuselu se centruje, klik následuje až po centrování). */
      pricingScene.addEventListener('touchstart', function (event) {
        var stage = stageFromEvent(event);
        if (Number.isFinite(stage)) warmTerraformForIntent(stage);
      }, { passive: true });
    }

    /* Buffer dvojice z aktivní karty až ve chvíli, kdy ceník opravdu vjede do viewportu. */
    function armTerraformProximityWarm() {
      if (terraformNudgeArmed) return;
      terraformNudgeArmed = true;
      ensureHiddenTerraformVideos();
      function arm() {
        pricingCardsInView = true;
        bufferTerraformPairForStage(currentPricingStage);
      }
      if (!pricingScene || typeof IntersectionObserver !== 'function') {
        arm();
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        var hit = false;
        var i;
        for (i = 0; i < entries.length; i += 1) if (entries[i].isIntersecting) hit = true;
        if (!hit) return;
        io.disconnect();
        arm();
      }, { root: null, rootMargin: '0px 0px 80px 0px', threshold: 0.01 });
      io.observe(pricingScene);
    }

    function releaseMobileVideoBuffer(video) {
      if (!video || (!isIosWebKit() && !mobileKeepsOneCard())) return;
      try { video.pause(); } catch (eRelVid) {}
      video.removeAttribute('src');
      video.removeAttribute('data-moje-src-locked');
      try { video.load(); } catch (eRelLoad) {}
      video.style.setProperty('display', 'none', 'important');
    }

    function adoptTerraformVideo(key) {
      var video = getOrCreateTerraformVideo(key);
      var layer = pricingVideoLayer;
      if (layer && video.parentNode !== layer) layer.appendChild(video);
      if (layer) {
        var vids = layer.querySelectorAll('video[data-tf-key]');
        var i;
        for (i = 0; i < vids.length; i += 1) {
          var on = vids[i] === video;
          if (on) showTerraformVideoEl(vids[i]);
          else parkTerraformVideo(vids[i]);
          if (!on) {
            try { vids[i].pause(); } catch (ePauseHide) {}
            releaseMobileVideoBuffer(vids[i]);
          }
        }
      }
      video.setAttribute('data-active-key', key);
      pricingVideo = video;
      return video;
    }

    function releaseTerraformVideo() {
      if (!pricingVideo) return;
      stopPricingVideoEndWatch();
      try { pricingVideo.pause(); } catch (eP) {}
      parkTerraformVideo(pricingVideo);
      releaseMobileVideoBuffer(pricingVideo);
      var dock = ensureTerraformDock();
      if (pricingVideo.parentNode !== dock) dock.appendChild(pricingVideo);
    }

    function getMistColorForStage(stage) {
      if (stage === 1) return 'orange';
      if (stage === 3) return 'cyan';
      return 'purple';
    }

    function dispatchChangeMistColor(stage) {
      document.dispatchEvent(new CustomEvent('changeMistColor', {
        detail: { color: getMistColorForStage(stage) }
      }));
    }

    function dispatchPricingPlanChanged(stage) {
      document.dispatchEvent(new CustomEvent('pricingPlanChanged', {
        detail: { plan: stage }
      }));
    }

    function setPricingStage(stage, opts) {
      opts = opts || {};
      currentPricingStage = stage;
      if (!pricingScene) return;
      var bgLayers = pricingScene.querySelectorAll('[data-s3-stage-bg]');
      var pricingCards = pricingScene.querySelectorAll('[data-s3-pricing-card]');
      var stageRgb = { 1: '255, 122, 31', 2: '217, 70, 239', 3: '6, 182, 212' };
      var rgb = stageRgb[stage] || stageRgb[2];
      var i;
      if (root) root.style.setProperty('--s3-current-rgb', rgb);
      pricingScene.style.setProperty('--s3-current-rgb', rgb);
      for (i = 0; i < bgLayers.length; i += 1) {
        bgLayers[i].classList.toggle(
          'moje-s2b__pricing-stage-bg--active',
          bgLayers[i].getAttribute('data-s3-stage-bg') === String(stage)
        );
      }
      for (i = 0; i < pricingCards.length; i += 1) {
        pricingCards[i].classList.toggle(
          'moje-s2b__pricing-card--active',
          pricingCards[i].getAttribute('data-s3-pricing-card') === String(stage)
        );
      }
      collapseAllPricingFeatures(true);
      snapPricingCarouselToStage(stage);
      syncPricingFeaturesOverflow();
      if (!opts.skipSequence && sequenceSwitchReady) {
        switchSequenceTo(stage, { fromEnd: true, silent: true });
      }
      startTerraformPreload();
      persistS2bSession();
    }

    function captureMojeS2bSessionState() {
      return {
        autoplayConsumed: !!autoplayConsumed,
        autoplayPlaying: !!autoplayPlaying,
        pricingLocked: !!pricingLocked,
        pricingVisible: !!pricingVisible,
        journey: journey || 'pre',
        pricingStage: currentPricingStage || 2,
        frameIndex: currentFrameIndex || 0,
        atPricing: !!atPricing
      };
    }

    window.__mojeS2bCaptureSessionState = captureMojeS2bSessionState;

    function persistS2bSession() {
      if (!(window.mojeSessionResume && typeof window.mojeSessionResume.save === 'function')) return;
      if (window.mojeSessionResume.restoring) return;
      var payload = {
        scrollY: window.pageYOffset || document.documentElement.scrollTop || 0,
        s2b: captureMojeS2bSessionState()
      };
      if (autoplayConsumed || pricingLocked || journey === 'pricing' || journey === 'below' || journey === 'buffer') {
        payload.introDone = true;
      }
      window.mojeSessionResume.save(payload);
    }

    function applyS2bSessionResume() {
      var api = window.mojeSessionResume;
      var live = api && typeof api.getS2b === 'function' ? api.getS2b() : null;
      var s = live || sessionResumeS2b || null;
      if (!s || typeof s !== 'object') return;
      consumeAutoplayWithoutPlay({ skipContinue: true });
      var stage = s.pricingStage >= 1 && s.pricingStage <= 3 ? s.pricingStage : currentPricingStage || 2;
      setPricingStage(stage, { skipSequence: false });
      if (s.journey === 'below') {
        enterBelow();
      } else if (
        s.pricingLocked ||
        s.journey === 'pricing' ||
        s.journey === 'buffer' ||
        s.atPricing
      ) {
        enterPricing({ snap: true, force: true });
        dispatchChangeMistColor(stage);
        dispatchPricingPlanChanged(stage);
      } else if (s.journey === 'sequence' || s.journey === 'autoplay') {
        var idx = Number(s.frameIndex);
        if (!Number.isFinite(idx)) idx = currentFrameIndex;
        enterSequence();
        paintFrame(Math.max(0, Math.min(maxFrameIndex, idx)));
      }
    }

    function maybeApplyS2bSessionResume() {
      var api = window.mojeSessionResume;
      if (!(api && api.active && sessionResumeS2b)) return;
      applyS2bSessionResume();
    }

    function isPricingMobileCarousel() {
      if (useWideMediaAssets()) return false;
      return !!(pricingCarousel && window.matchMedia && window.matchMedia('(max-width: 989px)').matches);
    }

    function isPricingCarouselInteractable() {
      return !!(
        isPricingMobileCarousel() &&
        pricingCarousel &&
        pricingScene &&
        pricingScene.classList.contains('moje-s2b__pricing-scene--visible') &&
        pricingScene.classList.contains('moje-s2b__pricing-scene--cards-in') &&
        !pricingScene.classList.contains('moje-s2b__pricing-scene--phase2-exit') &&
        !pricingTransitioning
      );
    }

    function syncPricingTouchCapture() {
      if (!pricingScene) return;
      var interactable = isPricingCarouselInteractable();
      pricingScene.classList.remove('moje-s2b__pricing-scene--touch-capture');
      pricingScene.classList.toggle('moje-s2b__pricing-scene--carousel-loose', interactable);
    }

    function invalidatePricingCarouselCentersCache() {
      pricingCarouselCentersCache = null;
      pricingCarouselCentersCacheW = 0;
    }

    function getPricingCarouselCardCenters() {
      if (!pricingCarousel) return { centers: [], stages: [] };
      var w = pricingCarousel.clientWidth || 0;
      if (
        pricingCarouselCentersCache &&
        pricingCarouselCentersCacheW === w &&
        pricingCarouselCentersCache.centers.length
      ) {
        return pricingCarouselCentersCache;
      }
      var cards = pricingCarousel.querySelectorAll('[data-s3-pricing-card]');
      var centers = [];
      var stages = [];
      var i;
      var stage;
      for (i = 0; i < cards.length; i += 1) {
        stage = parseInt(cards[i].getAttribute('data-s3-pricing-card'), 10);
        if (!stage) continue;
        centers.push(cards[i].offsetLeft + cards[i].offsetWidth / 2);
        stages.push(stage);
      }
      pricingCarouselCentersCache = { centers: centers, stages: stages };
      pricingCarouselCentersCacheW = w;
      return pricingCarouselCentersCache;
    }

    function getPricingCarouselCenteredStage() {
      if (!pricingCarousel || !isPricingMobileCarousel()) return currentPricingStage;
      var pack = getPricingCarouselCardCenters();
      var centers = pack.centers;
      var stages = pack.stages;
      if (!centers.length) return currentPricingStage;
      var center = pricingCarousel.scrollLeft + pricingCarousel.clientWidth / 2;
      var best = currentPricingStage;
      var bestDist = Infinity;
      var i;
      var d;
      for (i = 0; i < centers.length; i += 1) {
        d = Math.abs(center - centers[i]);
        if (d < bestDist) {
          bestDist = d;
          best = stages[i];
        }
      }
      return best;
    }

    function setPricingCarouselSettling(active) {
      if (!pricingScene) return;
      pricingScene.classList.toggle('moje-s2b__pricing-scene--carousel-settling', !!active);
    }

    function flushPricingCarouselDrag() {
      if (pricingCarouselDragRaf) {
        cancelAnimationFrame(pricingCarouselDragRaf);
        pricingCarouselDragRaf = 0;
      }
      if (!pricingCarousel || !pricingCarouselDragPendingDx) {
        pricingCarouselDragPendingDx = 0;
        return;
      }
      pricingCarousel.scrollLeft += pricingCarouselDragPendingDx;
      pricingCarouselDragPendingDx = 0;
    }

    function stopPricingCarouselScrollAnim() {
      if (pricingCarouselScrollAnimRaf) {
        cancelAnimationFrame(pricingCarouselScrollAnimRaf);
        pricingCarouselScrollAnimRaf = null;
      }
      if (pricingCarouselSnapSettleTimer) {
        clearTimeout(pricingCarouselSnapSettleTimer);
        pricingCarouselSnapSettleTimer = null;
      }
    }

    function easeOutCarousel(t) {
      if (t >= 1) return 1;
      if (t <= 0) return 0;
      return 1 - Math.pow(2, -10 * t);
    }

    function animatePricingCarouselScrollTo(target, onComplete) {
      if (!pricingCarousel) return;
      stopPricingCarouselScrollAnim();
      flushPricingCarouselDrag();

      var startPos = pricingCarousel.scrollLeft;
      var delta = target - startPos;
      var absDelta = Math.abs(delta);
      if (absDelta < 1) {
        pricingCarousel.scrollLeft = target;
        pricingCarouselProgrammaticScroll = false;
        syncPricingCarouselMobilePreview();
        syncPricingCarouselHintsEdgeState();
        requestAnimationFrame(function () {
          setPricingCarouselSettling(false);
          if (onComplete) onComplete();
        });
        return;
      }

      pricingCarouselProgrammaticScroll = true;
      setPricingCarouselSettling(true);
      pricingCarouselTouchVelocityPxMs = 0;

      var duration = Math.min(2400, Math.max(1600, 1500 + absDelta * 1.15));
      var startTime = 0;

      function finishAnim() {
        pricingCarousel.scrollLeft = target;
        pricingCarouselProgrammaticScroll = false;
        pricingCarouselScrollAnimRaf = null;
        setPricingCarouselSettling(false);
        requestAnimationFrame(function () {
          syncPricingCarouselMobilePreview();
          syncPricingCarouselHintsEdgeState();
          if (onComplete) onComplete();
        });
      }

      function step(now) {
        if (!pricingCarousel || !s2bSectionIntersectsViewport()) {
          pricingCarouselScrollAnimRaf = null;
          pricingCarouselProgrammaticScroll = false;
          return;
        }
        if (!startTime) startTime = now;
        var t = Math.min(1, (now - startTime) / duration);
        var eased = easeOutCarousel(t);
        pricingCarousel.scrollLeft = startPos + delta * eased;
        if (t < 1) {
          pricingCarouselScrollAnimRaf = requestAnimationFrame(step);
          return;
        }
        finishAnim();
      }

      pricingCarouselScrollAnimRaf = requestAnimationFrame(step);
    }

    function snapPricingCarouselToStage(stage) {
      if (!pricingCarousel || !isPricingMobileCarousel()) return;
      var card = pricingCarousel.querySelector('[data-s3-pricing-card="' + stage + '"]');
      if (!card) return;
      var target = Math.max(0, Math.round(card.offsetLeft + card.offsetWidth / 2 - pricingCarousel.clientWidth / 2));
      if (Math.abs(target - pricingCarousel.scrollLeft) < 1) {
        syncPricingCarouselHintsEdgeState();
        syncPricingCarouselMobilePreview();
        return;
      }
      animatePricingCarouselScrollTo(target);
    }

    function jumpPricingCarouselToStage(stage) {
      if (!pricingCarousel || !isPricingMobileCarousel()) return;
      var card = pricingCarousel.querySelector('[data-s3-pricing-card="' + String(stage) + '"]');
      if (!card) return;
      var target = Math.max(0, Math.round(card.offsetLeft + card.offsetWidth / 2 - pricingCarousel.clientWidth / 2));
      pricingCarouselProgrammaticScroll = true;
      pricingCarousel.scrollLeft = target;
      requestAnimationFrame(function () {
        pricingCarouselProgrammaticScroll = false;
        syncPricingCarouselHintsEdgeState();
        syncPricingCarouselMobilePreview();
      });
    }

    function snapPricingCarouselToActiveCard() {
      if (!pricingCarousel || !isPricingMobileCarousel()) return;
      var active = pricingScene ? pricingScene.querySelector('.moje-s2b__pricing-card--active') : null;
      if (!active) return;
      jumpPricingCarouselToStage(active.getAttribute('data-s3-pricing-card'));
    }

    function scheduleSnapPricingCarouselToActiveCard() {
      if (!isPricingMobileCarousel()) return;
      invalidatePricingCarouselCentersCache();
      snapPricingCarouselToActiveCard();
      requestAnimationFrame(function () {
        snapPricingCarouselToActiveCard();
        requestAnimationFrame(function () {
          snapPricingCarouselToActiveCard();
        });
      });
      setTimeout(function () {
        snapPricingCarouselToActiveCard();
        syncPricingCarouselHintsLayout();
        syncPricingFeaturesOverflow();
      }, 60);
      setTimeout(function () {
        snapPricingCarouselToActiveCard();
        syncPricingFeaturesOverflow();
      }, 220);
    }

    function snapPricingCarouselAfterDrag(totalDx) {
      if (!pricingCarousel) return;
      var cards = pricingCarousel.querySelectorAll('[data-s3-pricing-card]');
      if (!cards.length) return;
      var maxStage = cards.length;
      var startStage = pricingZoneDragStartStage || getPricingCarouselCenteredStage();
      var width = pricingCarousel.clientWidth || 1;
      var threshold = width * PRICING_CAROUSEL_SWIPE_ADVANCE_RATIO;
      var flickDist = width * PRICING_CAROUSEL_FLICK_RATIO;
      var vel = pricingCarouselTouchVelocityPxMs;
      var targetStage;
      if (totalDx <= -threshold || (vel > PRICING_CAROUSEL_FLICK_VEL && totalDx < -flickDist * 0.4)) {
        targetStage = Math.min(maxStage, startStage + 1);
      } else if (totalDx >= threshold || (vel < -PRICING_CAROUSEL_FLICK_VEL && totalDx > flickDist * 0.4)) {
        targetStage = Math.max(1, startStage - 1);
      } else if (Math.abs(vel) > PRICING_CAROUSEL_FLICK_VEL * 1.35) {
        targetStage = vel > 0
          ? Math.min(maxStage, startStage + 1)
          : Math.max(1, startStage - 1);
      } else {
        targetStage = getPricingCarouselCenteredStage();
      }
      snapPricingCarouselToStage(targetStage);
    }

    function drivePricingCarouselByTouch(touchX, event) {
      if (!pricingCarousel || pricingZoneTouchLastX === null) return;
      stopPricingCarouselScrollAnim();
      if (event && event.cancelable) event.preventDefault();
      var now = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
      var dx = pricingZoneTouchLastX - touchX;
      var dt = Math.max(1, now - (pricingCarouselTouchLastTs || now));
      var instantVel = dx / dt;
      pricingCarouselTouchVelocityPxMs = pricingCarouselTouchVelocityPxMs * 0.8 + instantVel * 0.2;
      pricingCarouselTouchLastTs = now;
      pricingZoneTouchLastX = touchX;
      pricingCarouselDragPendingDx += dx * PRICING_CAROUSEL_DRAG_GAIN;
      setPricingCarouselSettling(true);
      if (!pricingCarouselDragRaf) {
        pricingCarouselDragRaf = requestAnimationFrame(function () {
          pricingCarouselDragRaf = 0;
          if (!pricingCarousel || !pricingCarouselDragPendingDx) {
            pricingCarouselDragPendingDx = 0;
            return;
          }
          pricingCarousel.scrollLeft += pricingCarouselDragPendingDx;
          pricingCarouselDragPendingDx = 0;
          scheduleSyncPricingCarouselMobilePreview({ bgOnly: true });
        });
      }
    }

    function clearPricingCarouselPreviewClasses() {
      if (!pricingScene) return;
      var nodes = pricingScene.querySelectorAll('.moje-s2b__pricing-card--carousel-preview');
      var i;
      for (i = 0; i < nodes.length; i += 1) {
        nodes[i].classList.remove('moje-s2b__pricing-card--carousel-preview');
      }
      lastPricingCarouselPreviewStage = null;
    }

    function getPricingCarouselPreviewStage() {
      var centered = getPricingCarouselCenteredStage();
      if (centered === currentPricingStage) return null;
      return centered;
    }

    function notePricingMediaAspect(width, height) {
      if (!width || !height) return;
      pricingMediaAspect = width / height;
    }

    function getPricingCoverExcessPx() {
      var cw = viewportW || window.innerWidth || 390;
      var vh = viewportH || getViewportH() || 844;
      var aspect = pricingMediaAspect;
      var seqImg = sequenceRefImage();
      if (seqImg && seqImg.naturalWidth > seqImg.naturalHeight) {
        aspect = seqImg.naturalWidth / seqImg.naturalHeight;
      }
      var renderedWidth = vh * aspect;
      return Math.max(0, renderedWidth - cw);
    }

    function getPricingCoverObjectPositionX(panX) {
      var excess = getPricingCoverExcessPx();
      if (excess <= 0.5) return '50%';
      var pct = 50 + (panX / excess) * 50;
      pct = Math.max(0, Math.min(100, pct));
      return pct.toFixed(2) + '%';
    }

    function applyPricingBgPanX(panX) {
      if (!pricingScene) return;
      if (isMobileViewport()) {
        if (pricingScene.__mojePanMode === 'mobile') return;
        pricingScene.__mojePanMode = 'mobile';
        pricingScene.style.removeProperty('--moje-s2b-bg-pan-x');
        pricingScene.style.setProperty('--moje-s2b-bg-pan-object-x', '50%');
        return;
      }
      var next = panX.toFixed(2) + 'px';
      if (pricingScene.__mojePanMode === 'desk' && pricingScene.__mojePanX === next) return;
      pricingScene.__mojePanMode = 'desk';
      pricingScene.__mojePanX = next;
      pricingScene.style.setProperty('--moje-s2b-bg-pan-x', next);
      pricingScene.style.removeProperty('--moje-s2b-bg-pan-object-x');
    }

    function stopPricingBgPanAnimation() {
      if (pricingBgPanAnimRaf) {
        cancelAnimationFrame(pricingBgPanAnimRaf);
        pricingBgPanAnimRaf = null;
      }
    }

    function tickPricingBgPan() {
      pricingBgPanAnimRaf = null;
      var diff = pricingBgPanTarget - pricingBgPanCurrent;
      if (Math.abs(diff) < 0.35) {
        pricingBgPanCurrent = pricingBgPanTarget;
        applyPricingBgPanX(pricingBgPanCurrent);
        return;
      }
      pricingBgPanCurrent += diff * PRICING_BG_PAN_LERP;
      applyPricingBgPanX(pricingBgPanCurrent);
      pricingBgPanAnimRaf = requestAnimationFrame(tickPricingBgPan);
    }

    function queuePricingBgPanTarget(panX) {
      pricingBgPanTarget = panX;
      if (!pricingBgPanAnimRaf) {
        pricingBgPanAnimRaf = requestAnimationFrame(tickPricingBgPan);
      }
    }

    function getPricingBgPanRangePx() {
      return getPricingCoverExcessPx() * 0.5 * PRICING_BG_PAN_FRACTION;
    }

    function getPricingCarouselStageBlend() {
      if (!pricingCarousel) return 2;
      var pack = getPricingCarouselCardCenters();
      var centers = pack.centers;
      var stages = pack.stages;
      if (centers.length < 2) return stages[0] || 2;
      var center = pricingCarousel.scrollLeft + pricingCarousel.clientWidth / 2;
      if (center <= centers[0]) return stages[0];
      if (center >= centers[centers.length - 1]) return stages[stages.length - 1];
      var i;
      for (i = 0; i < centers.length - 1; i += 1) {
        if (center >= centers[i] && center <= centers[i + 1]) {
          var span = centers[i + 1] - centers[i];
          if (span <= 0) return stages[i];
          var t = (center - centers[i]) / span;
          return stages[i] + (stages[i + 1] - stages[i]) * t;
        }
      }
      return 2;
    }

    function syncPricingCarouselBgPan() {
      if (isMobileViewport()) return;
      if (!pricingScene || !isPricingMobileCarousel()) return;
      if (!pricingScene.classList.contains('moje-s2b__pricing-scene--visible')) return;
      if (pricingBgPanLocked) {
        applyPricingBgPanX(pricingBgPanLockedValue);
        return;
      }
      var blend = getPricingCarouselStageBlend();
      var panRange = getPricingBgPanRangePx();
      var normalized = (blend - 2) / 1;
      var panX = normalized * panRange;
      if (pricingTransitioning) {
        applyPricingBgPanX(pricingBgPanCurrent);
        return;
      }
      queuePricingBgPanTarget(panX);
    }

    function resetPricingCarouselBgPan() {
      stopPricingBgPanAnimation();
      pricingBgPanLocked = false;
      pricingBgPanLockedValue = 0;
      pricingBgPanCurrent = 0;
      pricingBgPanTarget = 0;
      if (!pricingScene) return;
      pricingScene.style.removeProperty('--moje-s2b-bg-pan-x');
      pricingScene.style.removeProperty('--moje-s2b-bg-pan-object-x');
      lastDrawnIndex = -1;
      paintFrame(currentFrameIndex);
    }

    function lockPricingBgPanForTransition() {
      if (isMobileViewport() || !isPricingMobileCarousel()) return;
      pricingBgPanLocked = true;
      pricingBgPanLockedValue = pricingBgPanCurrent;
      pricingBgPanTarget = pricingBgPanLockedValue;
      stopPricingBgPanAnimation();
      applyPricingBgPanX(pricingBgPanLockedValue);
    }

    function unlockPricingBgPanForTransition() {
      pricingBgPanLocked = false;
    }

    function syncPricingCarouselMobilePreview(opts) {
      if (!pricingScene || !pricingCarousel) return;
      if (!isPricingMobileCarousel()) {
        clearPricingCarouselPreviewClasses();
        resetPricingCarouselBgPan();
        return;
      }
      if (!pricingScene.classList.contains('moje-s2b__pricing-scene--visible') || pricingTransitioning) {
        clearPricingCarouselPreviewClasses();
        return;
      }
      syncPricingCarouselBgPan();
      var stuckActive = pricingScene.querySelectorAll(
        '.moje-s2b__pricing-card--active.moje-s2b__pricing-card--carousel-preview'
      );
      var si;
      for (si = 0; si < stuckActive.length; si += 1) {
        stuckActive[si].classList.remove('moje-s2b__pricing-card--carousel-preview');
      }
      if (opts && opts.bgOnly) return;
      var previewStage = getPricingCarouselPreviewStage();
      if (previewStage === lastPricingCarouselPreviewStage) return;

      if (lastPricingCarouselPreviewStage) {
        var prevEl = pricingScene.querySelector('[data-s3-pricing-card="' + lastPricingCarouselPreviewStage + '"]');
        if (prevEl) prevEl.classList.remove('moje-s2b__pricing-card--carousel-preview');
      }

      lastPricingCarouselPreviewStage = previewStage;
      if (!previewStage) return;
      var previewEl = pricingScene.querySelector('[data-s3-pricing-card="' + previewStage + '"]');
      if (previewEl && !previewEl.classList.contains('moje-s2b__pricing-card--active')) {
        previewEl.classList.add('moje-s2b__pricing-card--carousel-preview');
      } else {
        lastPricingCarouselPreviewStage = null;
      }
    }

    function scheduleSyncPricingCarouselMobilePreview(opts) {
      if (pricingCarouselPreviewRaf) return;
      var bgOnly = !!(opts && opts.bgOnly);
      pricingCarouselPreviewRaf = requestAnimationFrame(function () {
        pricingCarouselPreviewRaf = null;
        syncPricingCarouselMobilePreview(bgOnly ? { bgOnly: true } : null);
        if (!bgOnly) syncPricingCarouselHintsEdgeState();
      });
    }

    var CAROUSEL_HINT_FIT_MIN_PX = 68;
    var CAROUSEL_HINT_FIT_MAX_PX = 104;
    var CAROUSEL_HINT_SIZE_SCALE = 0.93;

    function sizeForCarouselHintGap(gapPx) {
      if (!Number.isFinite(gapPx) || gapPx <= 0) return CAROUSEL_HINT_FIT_MIN_PX;
      var fitted = gapPx * 0.78 * CAROUSEL_HINT_SIZE_SCALE;
      return Math.min(CAROUSEL_HINT_FIT_MAX_PX, Math.max(CAROUSEL_HINT_FIT_MIN_PX, fitted));
    }

    function getCarouselHintViewportSpan() {
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 390;
      var left = 0;
      var right = viewportWidth;
      if (window.visualViewport) {
        left = window.visualViewport.offsetLeft || 0;
        right = left + window.visualViewport.width;
      }
      return { left: left, right: right, width: right - left };
    }

    function getCarouselHintFixedSideGap(viewportWidth) {
      var cardWidth = Math.min(viewportWidth * 0.78, 340);
      return Math.max(0, (viewportWidth - cardWidth) * 0.5);
    }

    function syncPricingCarouselHintsLayout() {
      if (!isPricingMobileCarousel() || !pricingCarouselWrap) return;
      if (!pricingScene || !pricingScene.classList.contains('moje-s2b__pricing-scene--visible')) return;
      invalidatePricingCarouselCentersCache();

      var hintLeft = pricingCarouselWrap.querySelector('.moje-s2b__carousel-hint--left');
      var hintRight = pricingCarouselWrap.querySelector('.moje-s2b__carousel-hint--right');
      if (!hintLeft || !hintRight) return;

      var viewport = getCarouselHintViewportSpan();
      var wrapRect = pricingCarouselWrap.getBoundingClientRect();
      var sideGap = getCarouselHintFixedSideGap(viewport.width);
      var hintSize = sizeForCarouselHintGap(sideGap);
      var gapCenterBias = 0.51;
      var leftCenterViewport = viewport.left + sideGap * gapCenterBias;
      var rightCenterViewport = viewport.right - sideGap * gapCenterBias;
      var leftCenter = leftCenterViewport - wrapRect.left - hintSize * 0.03;
      var rightCenter = rightCenterViewport - wrapRect.left + hintSize * 0.03;
      var cardLeftViewport = viewport.left + sideGap;
      var cardRightViewport = viewport.right - sideGap;
      var leftMin = viewport.left - wrapRect.left + hintSize * 0.36;
      var leftMax = cardLeftViewport - wrapRect.left - hintSize * 0.36;
      var rightMin = cardRightViewport - wrapRect.left + hintSize * 0.36;
      var rightMax = viewport.right - wrapRect.left - hintSize * 0.36;

      if (leftMax > leftMin) leftCenter = Math.min(leftMax, Math.max(leftMin, leftCenter));
      if (rightMax > rightMin) rightCenter = Math.min(rightMax, Math.max(rightMin, rightCenter));

      hintLeft.style.setProperty('--moje-s2b-carousel-hint-left-x', leftCenter.toFixed(2) + 'px');
      hintLeft.style.setProperty('--moje-s2b-carousel-hint-left-size', hintSize.toFixed(2) + 'px');
      hintRight.style.setProperty('--moje-s2b-carousel-hint-right-x', rightCenter.toFixed(2) + 'px');
      hintRight.style.setProperty('--moje-s2b-carousel-hint-right-size', hintSize.toFixed(2) + 'px');
      syncPricingCarouselHintsEdgeState();
    }

    function syncPricingCarouselHintsEdgeState() {
      if (!isPricingMobileCarousel() || !pricingCarouselWrap) return;
      if (!pricingScene || !pricingScene.classList.contains('moje-s2b__pricing-scene--visible')) return;
      var hintLeft = pricingCarouselWrap.querySelector('.moje-s2b__carousel-hint--left');
      var hintRight = pricingCarouselWrap.querySelector('.moje-s2b__carousel-hint--right');
      if (!hintLeft || !hintRight) return;
      var stage = getPricingCarouselCenteredStage();
      hintLeft.classList.toggle('moje-s2b__carousel-hint--edge-hidden', stage === 1);
      hintRight.classList.toggle('moje-s2b__carousel-hint--edge-hidden', stage === 3);
    }

    function getPricingCardStageAtPoint(clientX, clientY) {
      if (!pricingCarousel) return null;
      var cards = pricingCarousel.querySelectorAll('[data-s3-pricing-card]');
      var i;
      for (i = 0; i < cards.length; i += 1) {
        var rect = cards[i].getBoundingClientRect();
        if (clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom) {
          return parseInt(cards[i].getAttribute('data-s3-pricing-card'), 10) || null;
        }
      }
      return null;
    }

    function getPricingFeaturesExpandAtPoint(clientX, clientY) {
      if (!pricingScene || !Number.isFinite(clientX) || !Number.isFinite(clientY)) return null;
      var buttons = pricingScene.querySelectorAll(
        '.moje-s2b__pricing-card--active .moje-s2b__pricing-features-wrap--overflow .moje-s2b__pricing-features-expand'
      );
      var i;
      for (i = 0; i < buttons.length; i += 1) {
        var btn = buttons[i];
        if (btn.hasAttribute('hidden')) continue;
        var r = btn.getBoundingClientRect();
        if (
          clientX >= r.left - 10 &&
          clientX <= r.right + 10 &&
          clientY >= r.top - 10 &&
          clientY <= r.bottom + 10
        ) {
          return btn;
        }
      }
      return null;
    }

    function getPricingCarouselHintAtPoint(clientX, clientY) {
      if (!pricingCarouselWrap || !Number.isFinite(clientX) || !Number.isFinite(clientY)) return null;
      var hintLeft = pricingCarouselWrap.querySelector('.moje-s2b__carousel-hint--left');
      var hintRight = pricingCarouselWrap.querySelector('.moje-s2b__carousel-hint--right');
      function hit(el) {
        if (!el || el.classList.contains('moje-s2b__carousel-hint--edge-hidden')) return false;
        var r = el.getBoundingClientRect();
        var pad = 12;
        return (
          clientX >= r.left - pad &&
          clientX <= r.right + pad &&
          clientY >= r.top - pad &&
          clientY <= r.bottom + pad
        );
      }
      if (hit(hintLeft)) return 'left';
      if (hit(hintRight)) return 'right';
      return null;
    }

    function resetPricingZoneTouchState() {
      pricingZoneTouchStartX = null;
      pricingZoneTouchStartY = null;
      pricingZoneTouchLastX = null;
      pricingZoneTouchLastY = null;
      pricingZoneTouchAxis = null;
      pricingZoneTapCardStage = null;
      pricingZoneTapExpandBtn = null;
      pricingZoneTapHintDir = null;
      pricingZoneDragStartStage = null;
    }

    function onPricingOverlayTouchStart(event) {
      if (!isPricingCarouselInteractable()) return;
      if (!event.touches || !event.touches.length) return;
      var touch = event.touches[0];
      pricingZoneTouchStartX = touch.clientX;
      pricingZoneTouchStartY = touch.clientY;
      pricingZoneTouchLastX = touch.clientX;
      pricingZoneTouchLastY = touch.clientY;
      pricingZoneTouchAxis = null;
      pricingZoneTapExpandBtn = getPricingFeaturesExpandAtPoint(touch.clientX, touch.clientY);
      pricingZoneTapHintDir = pricingZoneTapExpandBtn
        ? null
        : getPricingCarouselHintAtPoint(touch.clientX, touch.clientY);
      pricingZoneTapCardStage = (pricingZoneTapExpandBtn || pricingZoneTapHintDir)
        ? null
        : getPricingCardStageAtPoint(touch.clientX, touch.clientY);
      pricingZoneDragStartStage = getPricingCarouselCenteredStage();
      pricingCarouselTouchVelocityPxMs = 0;
      pricingCarouselTouchLastTs =
        typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
    }

    function onPricingOverlayTouchMove(event) {
      if (pricingZoneTouchStartX === null) return;
      if (!event.touches || !event.touches.length) return;
      if (!isPricingCarouselInteractable() && pricingZoneTouchAxis !== 'x') {
        resetPricingZoneTouchState();
        return;
      }
      var touch = event.touches[0];
      var touchX = touch.clientX;
      var touchY = touch.clientY;
      var dx = touchX - pricingZoneTouchStartX;
      var dy = touchY - pricingZoneTouchStartY;

      if (!pricingZoneTouchAxis) {
        if (Math.abs(dx) < PRICING_ZONE_TOUCH_THRESHOLD && Math.abs(dy) < PRICING_ZONE_TOUCH_THRESHOLD) {
          return;
        }
        pricingZoneTouchAxis = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
        pricingZoneTapCardStage = null;
        pricingZoneTapExpandBtn = null;
        pricingZoneTapHintDir = null;
      }

      if (pricingZoneTouchAxis === 'x') {
        drivePricingCarouselByTouch(touchX, event);
      }
    }

    function onPricingOverlayTouchEnd(event) {
      if (pricingZoneTouchAxis === 'x') {
        flushPricingCarouselDrag();
        scheduleSyncPricingCarouselMobilePreview();
        syncPricingCarouselHintsEdgeState();
        var totalDx = 0;
        if (event && event.changedTouches && event.changedTouches.length && pricingZoneTouchStartX !== null) {
          totalDx = event.changedTouches[0].clientX - pricingZoneTouchStartX;
        }
        snapPricingCarouselAfterDrag(totalDx);
        resetPricingZoneTouchState();
        return;
      }

      setPricingCarouselSettling(false);

      if (
        pricingZoneTouchAxis === null &&
        pricingZoneTouchStartX !== null &&
        event &&
        event.changedTouches &&
        event.changedTouches.length
      ) {
        var endX = event.changedTouches[0].clientX;
        var endY = event.changedTouches[0].clientY;
        var tapped =
          Math.abs(endX - pricingZoneTouchStartX) <= PRICING_ZONE_TAP_SLOP &&
          Math.abs(endY - pricingZoneTouchStartY) <= PRICING_ZONE_TAP_SLOP;
        if (tapped) {
          if (pricingZoneTapExpandBtn) {
            var expandWrap = pricingZoneTapExpandBtn.closest('.moje-s2b__pricing-features-wrap');
            togglePricingFeaturesExpand(expandWrap);
            resetPricingZoneTouchState();
            return;
          }
          if (pricingZoneTapHintDir) {
            var centered = getPricingCarouselCenteredStage();
            var nextStage = pricingZoneTapHintDir === 'left'
              ? Math.max(1, centered - 1)
              : Math.min(3, centered + 1);
            snapPricingCarouselToStage(nextStage);
            resetPricingZoneTouchState();
            return;
          }
          if (pricingZoneTapCardStage) {
            var centeredTap = getPricingCarouselCenteredStage();
            if (pricingZoneTapCardStage !== centeredTap) {
              snapPricingCarouselToStage(pricingZoneTapCardStage);
            } else if (pricingZoneTapCardStage !== currentPricingStage) {
              syncPlayPricingVideo(pricingZoneTapCardStage);
              playPricingTransition(pricingZoneTapCardStage);
            } else {
              clearPricingCarouselPreviewClasses();
              syncPricingCarouselMobilePreview();
            }
          }
        }
      }

      resetPricingZoneTouchState();
    }

    function stageBgImage(stage) {
      if (!pricingScene) return null;
      var wrap = pricingScene.querySelector('[data-s3-stage-bg="' + stage + '"]');
      if (!wrap) return null;
      if (useMobileMediaAssets()) {
        return wrap.querySelector('.moje-s2b__pricing-stage-img--mobile') || wrap.querySelector('img');
      }
      return wrap.querySelector('.moje-s2b__pricing-stage-img--desktop') || wrap.querySelector('img');
    }

    function stageBgImageSrc(stage) {
      var img = stageBgImage(stage);
      if (!img) return '';
      return img.currentSrc || img.getAttribute('src') || '';
    }

    function warmPricingStageImages(opts) {
      if (!pricingScene) return;
      opts = opts || {};
      hydrateStageImagesForViewport();
      var imgs = pricingScene.querySelectorAll('[data-s3-stage-bg] img');
      var defaultOnly = !opts.all && (!defaultSequenceFullyReady() || pendingAutoplayFromNav || autoplayPlaying);
      var i;
      for (i = 0; i < imgs.length; i += 1) {
        var img = imgs[i];
        if (useMobileMediaAssets() && img.classList.contains('moje-s2b__pricing-stage-img--desktop') && stageWrapHasMobileImage(img.closest('[data-s3-stage-bg]'))) continue;
        if (useWideMediaAssets() && img.classList.contains('moje-s2b__pricing-stage-img--mobile')) continue;
        if (!img.getAttribute('src')) continue;
        var isActive = !!(img.closest && img.closest('.moje-s2b__pricing-stage-bg--active'));
        if (defaultOnly && !isActive) continue;
        try { img.loading = 'eager'; } catch (eEager) {}
        try { img.decoding = isActive ? 'sync' : 'async'; } catch (eDec) {}
        if (isActive) {
          try { img.fetchPriority = 'high'; } catch (ePri) {}
        }
        if (typeof img.decode === 'function') {
          img.decode().catch(function () {});
        }
        if (img.naturalWidth && img.naturalHeight) {
          notePricingMediaAspect(img.naturalWidth, img.naturalHeight);
        }
      }
    }

    function whenStageBgReady(stage, cb) {
      var img = stageBgImage(stage);
      assignLazyImageSrc(img);
      hydrateStageImagesForViewport();
      var done = false;
      function once() {
        if (done) return;
        done = true;
        cb();
      }
      if (!img || (img.complete && img.naturalWidth)) {
        once();
        return;
      }
      img.addEventListener('load', once, { once: true });
      img.addEventListener('error', once, { once: true });
      try { img.loading = 'eager'; } catch (eReady) {}
      if (typeof img.decode === 'function') {
        img.decode().then(once).catch(once);
      }
      setTimeout(once, 500);
    }

    function stopPricingVideoEndWatch() {
      if (pricingVideoEndWatchRaf) {
        cancelAnimationFrame(pricingVideoEndWatchRaf);
        pricingVideoEndWatchRaf = 0;
      }
      if (pricingVideo) {
        pricingVideo.onended = null;
        pricingVideo.onerror = null;
      }
    }

    function hidePricingVideoLayerInstant() {
      if (!pricingVideoLayer) return;
      pricingVideoLayer.classList.add('moje-s2b__pricing-video-layer--handoff');
      pricingVideoLayer.classList.remove('moje-s2b__pricing-video-layer--active');
      pricingVideoLayer.setAttribute('aria-hidden', 'true');
    }

    function teardownPricingVideoElement() {
      releaseTerraformVideo();
    }

    function freezePricingVideoLastFrame() {
      if (!pricingVideo) return;
      try {
        var d = pricingVideo.duration;
        if (d && isFinite(d) && d > 0) {
          var freezeAt = Math.max(0, d - PRICING_VIDEO_FREEZE_TAIL_S);
          if (pricingVideo.currentTime < freezeAt) pricingVideo.currentTime = freezeAt;
        }
        pricingVideo.pause();
      } catch (eFreeze) {}
    }

    function armPricingVideoEndWatch(targetStage) {
      stopPricingVideoEndWatch();
      if (!pricingVideo) return;
      function handoff() {
        finishPricingTransition(targetStage, { seamless: true });
      }
      pricingVideo.onended = function () {
        pricingVideo.onended = null;
        parkTerraformVideo(pricingVideo);
        releaseMobileVideoBuffer(pricingVideo);
        handoff();
      };
      pricingVideo.onerror = function () {
        pricingVideo.onerror = null;
        finishPricingTransition(targetStage);
      };
      function tick() {
        pricingVideoEndWatchRaf = 0;
        if (pricingTransitionFinishLock || !pricingTransitioning) return;
        var d = pricingVideo.duration;
        var t = pricingVideo.currentTime;
        if (d && isFinite(d) && t >= d - PRICING_VIDEO_FREEZE_TAIL_S) {
          handoff();
          return;
        }
        pricingVideoEndWatchRaf = requestAnimationFrame(tick);
      }
      pricingVideoEndWatchRaf = requestAnimationFrame(tick);
    }

    function armDestBgUnderVideo(targetStage) {
      if (pricingTransitionFinishLock || !pricingTransitioning) return;
      if (pricingScene) pricingScene.classList.add('moje-s2b__pricing-scene--instant-bg');
      if (currentPricingStage !== targetStage) {
        setPricingStage(targetStage, { skipSequence: true });
      }
    }

    function clearPricingDestCoverTimer() {
      if (pricingDestCoverTimer) {
        clearTimeout(pricingDestCoverTimer);
        pricingDestCoverTimer = 0;
      }
    }

    function finishPricingTransition(targetStage, opts) {
      opts = opts || {};
      if (pricingTransitionFinishLock) return;
      pricingTransitionFinishLock = true;
      detachPricingVideoReadyListeners();
      stopPricingVideoEndWatch();
      clearPricingDestCoverTimer();
      if (pricingTransitionFailTimer) {
        clearTimeout(pricingTransitionFailTimer);
        pricingTransitionFailTimer = null;
      }

      var seamless = !!opts.seamless && !!pricingVideo;
      if (pricingScene) pricingScene.classList.add('moje-s2b__pricing-scene--instant-bg');

      function ensureDestStage() {
        if (currentPricingStage !== targetStage) setPricingStage(targetStage, { skipSequence: true });
      }

      function revealCards() {
        hidePricingVideoLayerInstant();
        if (pricingScene) {
          pricingScene.classList.remove('moje-s2b__pricing-scene--transitioning');
          pricingScene.classList.remove('moje-s2b__pricing-scene--cards-out');
          pricingScene.classList.add('moje-s2b__pricing-scene--cards-in');
        }
        if (root) root.classList.remove('moje-s2b--video-playing');
        pricingTransitioning = false;
        resumeBackgroundQueue();
        unlockS2bChrome('terraform');
        unlockPricingBgPanForTransition();
        dispatchChangeMistColor(targetStage);
        dispatchPricingPlanChanged(targetStage);
        clearPricingCarouselPreviewClasses();
        try {
          if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
        } catch (eBlur) {}
        syncPricingTouchCapture();
        scheduleSnapPricingCarouselToActiveCard();
        requestAnimationFrame(function () {
          teardownPricingVideoElement();
          pricingCardsInView = true;
          if (!pricingTransitioning) startTerraformPreload();
          if (pricingVideoLayer) {
            pricingVideoLayer.classList.remove('moje-s2b__pricing-video-layer--handoff');
          }
          if (sequenceSwitchReady) {
            switchSequenceTo(targetStage, { fromEnd: true, silent: true, freezeLayout: true });
          }
          syncPricingCanvasBg();
          var destLast = images[maxFrameIndex];
          if (destLast && !(destLast.complete && destLast.naturalWidth)) {
            destLast.addEventListener('load', function onDestLast() {
              if (currentPricingStage === targetStage && pricingVisible) syncPricingCanvasBg();
            }, { once: true });
          }
          requestAnimationFrame(function () {
            if (pricingScene) pricingScene.classList.remove('moje-s2b__pricing-scene--instant-bg');
            syncPricingCanvasBg();
            syncPricingFeaturesOverflow();
            syncPricingCarouselHintsLayout();
          });
        });
      }

      if (seamless) {
        freezePricingVideoLastFrame();
        ensureDestStage();
        var videoAlreadyEnded = !!(pricingVideo && pricingVideo.ended);
        whenStageBgReady(targetStage, function () {
          if (videoAlreadyEnded) {
            revealCards();
            return;
          }
          requestAnimationFrame(function () {
            requestAnimationFrame(revealCards);
          });
        });
        return;
      }

      ensureDestStage();
      teardownPricingVideoElement();
      revealCards();
    }

    function syncPlayPricingVideo(targetStage, opts) {
      opts = opts || {};
      if (!Number.isFinite(targetStage) || targetStage === currentPricingStage) return null;
      var key = getPricingTransitionKey(currentPricingStage, targetStage);
      var parsed = getPricingTransitionEntry(currentPricingStage, targetStage);
      var videoUrl = parsed.mp4 || parsed.webm || '';
      if (!videoUrl) return null;
      var video = adoptTerraformVideo(key);
      if (!video) return null;
      bindTerraformSources(video, key);
      video.style.display = 'block';
      video.style.visibility = 'visible';
      try { video.play(); } catch (eSyncPlay) {}
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.preload = 'auto';
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      showTerraformVideoEl(video);
      if (pricingVideoLayer) {
        pricingVideoLayer.classList.remove('moje-s2b__pricing-video-layer--handoff');
        pricingVideoLayer.classList.add('moje-s2b__pricing-video-layer--active');
        pricingVideoLayer.setAttribute('aria-hidden', 'false');
      }
      if (root) root.classList.add('moje-s2b--video-playing');
      if (!opts.keepTime) {
        try { video.currentTime = 0; } catch (eSeek0) {}
      }
      return video;
    }

    function playPricingTransition(targetStage) {
      if (!pricingScene || pricingTransitioning || targetStage === currentPricingStage) return;
      if (journey !== 'pricing' && journey !== 'buffer' && journey !== 'below') return;
      syncWideMediaClass();
      var playedVideo = syncPlayPricingVideo(targetStage);
      pricingCardsInView = true;
      pricingTransitioning = true;
      pricingTransitionFinishLock = false;
      pinPricingForTerraform();
      lockS2bChrome('terraform');
      var key = getPricingTransitionKey(currentPricingStage, targetStage);
      var parsed = getPricingTransitionEntry(currentPricingStage, targetStage);
      var videoUrl = parsed.mp4 || parsed.webm || '';
      maybeStartDeferredS2bMedia(true);
      preloadSequenceStage(targetStage, { fromEnd: true, boost: 120 });

      if (root) root.classList.add('moje-s2b--video-playing');
      pricingScene.classList.add('moje-s2b__pricing-scene--transitioning');
      pricingScene.classList.remove('moje-s2b__pricing-scene--cards-in');
      pricingScene.classList.add('moje-s2b__pricing-scene--cards-out');
      lockPricingBgPanForTransition();
      collapseAllPricingFeatures(true);
      syncPricingTouchCapture();
      warmPricingStageImages();
      if (!isMobileViewport()) {
        dispatchChangeMistColor(targetStage);
        dispatchPricingPlanChanged(targetStage);
      }

      if (!videoUrl || !playedVideo || !pricingVideo || !pricingVideoLayer) {
        setTimeout(function () { finishPricingTransition(targetStage); }, 650);
        return;
      }

      var destBgArmed = false;
      function armDestWhenCovered() {
        if (destBgArmed || pricingTransitionFinishLock) return;
        destBgArmed = true;
        armDestBgUnderVideo(targetStage);
      }

      pricingVideo.setAttribute('data-active-key', key);
      armPricingVideoEndWatch(targetStage);
      clearPricingDestCoverTimer();
      pricingDestCoverTimer = setTimeout(function () {
        pricingDestCoverTimer = 0;
        armDestWhenCovered();
      }, 320);

      function skipIfVideoBlocked() {
        pricingTransitionFailTimer = null;
        if (pricingTransitionFinishLock || !pricingTransitioning) return;
        var live = pricingVideo;
        if (!live || live.error) {
          finishPricingTransition(targetStage);
          return;
        }
        var loading = live.networkState === 1 || live.networkState === 2 || live.readyState > 0 || !live.paused;
        if (loading) {
          pricingTransitionFailTimer = setTimeout(skipIfVideoBlocked, 5000);
          return;
        }
        finishPricingTransition(targetStage);
      }
      if (pricingTransitionFailTimer) clearTimeout(pricingTransitionFailTimer);
      pricingTransitionFailTimer = setTimeout(skipIfVideoBlocked, 14000);
    }

    function syncPricingFeaturesWrapOverflow(wrap) {
      if (!wrap) return;
      var list = wrap.querySelector('.moje-s2b__pricing-features');
      var btn = wrap.querySelector('.moje-s2b__pricing-features-expand');
      if (!list) return;
      var expanded = wrap.classList.contains('moje-s2b__pricing-features-wrap--expanded');
      var overflow;
      if (expanded) {
        var collapsedH = Number(wrap.getAttribute('data-collapsed-h') || 0);
        overflow = collapsedH > 0
          ? list.scrollHeight > collapsedH + 2
          : true;
      } else {
        overflow = list.scrollHeight > list.clientHeight + 2;
      }
      wrap.classList.toggle('moje-s2b__pricing-features-wrap--overflow', overflow);
      if (btn) {
        if (overflow) btn.removeAttribute('hidden');
        else btn.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.setAttribute(
          'aria-label',
          expanded ? 'Skrýt seznam výhod' : 'Zobrazit celý seznam výhod'
        );
      }
      if (!overflow && expanded) {
        setPricingFeaturesExpanded(wrap, false);
      }
    }

    function syncPricingFeaturesOverflow() {
      if (!pricingScene) return;
      var wraps = pricingScene.querySelectorAll('.moje-s2b__pricing-features-wrap');
      var i;
      for (i = 0; i < wraps.length; i += 1) {
        syncPricingFeaturesWrapOverflow(wraps[i]);
      }
    }

    function resetPricingFeaturesCardLayout(card, wrap) {
      if (card) {
        card.classList.remove('moje-s2b__pricing-card--features-expanded');
        card.style.removeProperty('--moje-s2b-card-base-h');
        card.style.removeProperty('--moje-s2b-card-expand-extra');
        card.removeAttribute('data-features-base-h');
        card.removeAttribute('data-features-extra');
      }
      if (wrap) {
        wrap.classList.remove('moje-s2b__pricing-features-wrap--expanded');
        wrap.removeAttribute('data-collapsed-h');
        var list = wrap.querySelector('.moje-s2b__pricing-features');
        if (list) {
          list.style.maxHeight = '';
          list.style.overflow = '';
        }
      }
    }

    function setPricingFeaturesExpanded(wrap, expand) {
      if (!wrap) return;
      var list = wrap.querySelector('.moje-s2b__pricing-features');
      var btn = wrap.querySelector('.moje-s2b__pricing-features-expand');
      var card = wrap.closest('.moje-s2b__pricing-card');
      if (!list || !card) return;

      if (expand) {
        if (wrap.classList.contains('moje-s2b__pricing-features-wrap--expanded')) return;

        var baseH = Math.round(card.getBoundingClientRect().height);
        var collapsedListH = list.clientHeight;
        var fullListH = list.scrollHeight;
        var extra = Math.max(0, Math.ceil(fullListH - collapsedListH));
        if (extra < 2) {
          syncPricingFeaturesWrapOverflow(wrap);
          return;
        }

        list.style.maxHeight = '';
        list.style.overflow = 'visible';
        card.setAttribute('data-features-base-h', String(baseH));
        card.setAttribute('data-features-extra', String(extra));
        wrap.setAttribute('data-collapsed-h', String(collapsedListH));
        card.style.setProperty('--moje-s2b-card-base-h', baseH + 'px');
        card.style.setProperty('--moje-s2b-card-expand-extra', extra + 'px');
        wrap.classList.add('moje-s2b__pricing-features-wrap--expanded');
        card.classList.add('moje-s2b__pricing-card--features-expanded');
        if (btn) {
          btn.setAttribute('aria-expanded', 'true');
          btn.setAttribute('aria-label', 'Skrýt seznam výhod');
        }
        return;
      }

      resetPricingFeaturesCardLayout(card, wrap);
      if (btn) {
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-label', 'Zobrazit celý seznam výhod');
      }
    }

    function togglePricingFeaturesExpand(wrap) {
      if (!wrap) return;
      setPricingFeaturesExpanded(
        wrap,
        !wrap.classList.contains('moje-s2b__pricing-features-wrap--expanded')
      );
    }

    function isFeaturesListInternallyScrolling(list, deltaY) {
      if (!list) return false;
      var wrap = list.closest('.moje-s2b__pricing-features-wrap');
      if (!wrap || !wrap.classList.contains('moje-s2b__pricing-features-wrap--expanded')) return false;
      if (list.scrollHeight <= list.clientHeight + 1) return false;
      if (deltaY < 0 && list.scrollTop <= 0) return false;
      if (deltaY > 0 && list.scrollTop + list.clientHeight >= list.scrollHeight - 1) return false;
      return true;
    }

    function bindPricingFeaturesWheelPassThrough() {
      if (!pricingScene) return;
      pricingScene.addEventListener('wheel', function (event) {
        var list = event.target && event.target.closest
          ? event.target.closest('.moje-s2b__pricing-features')
          : null;
        if (!list) return;
        if (isFeaturesListInternallyScrolling(list, event.deltaY)) {
          event.stopPropagation();
        }
      }, { capture: true, passive: true });
    }

    function collapseAllPricingFeatures(instant) {
      if (!pricingScene) return;
      var wraps = pricingScene.querySelectorAll('.moje-s2b__pricing-features-wrap--expanded');
      var i;
      for (i = 0; i < wraps.length; i += 1) setPricingFeaturesExpanded(wraps[i], false);
      if (instant) syncPricingFeaturesOverflow();
    }

    function bindPricingFeaturesExpand() {
      if (!pricingScene || pricingFeaturesExpandBound) return;
      pricingFeaturesExpandBound = true;
      pricingScene.addEventListener('click', function (event) {
        var btn = event.target && event.target.closest
          ? event.target.closest('.moje-s2b__pricing-features-expand')
          : null;
        if (!btn || !pricingScene.contains(btn)) return;
        event.preventDefault();
        event.stopPropagation();
        var wrap = btn.closest('.moje-s2b__pricing-features-wrap');
        togglePricingFeaturesExpand(wrap);
      });
    }

    function bindPricingCardClicks() {
      if (!pricingScene) return;
      pricingScene.addEventListener('click', function (event) {
        if (event.target && event.target.closest && event.target.closest('.moje-s2b__pricing-features-expand')) {
          return;
        }
        if (event.target && event.target.closest && event.target.closest('.moje-s2b__carousel-hint')) {
          return;
        }
        var trigger = event.target && event.target.closest
          ? event.target.closest('[data-s3-card-trigger], [data-s3-pricing-card]')
          : null;
        if (!trigger || !pricingScene.contains(trigger)) return;
        var targetStage = Number(
          trigger.getAttribute('data-s3-card-trigger') || trigger.getAttribute('data-s3-pricing-card')
        );
        if (!Number.isFinite(targetStage)) return;
        if (isPricingMobileCarousel() && getPricingCarouselCenteredStage() !== targetStage) {
          event.preventDefault();
          snapPricingCarouselToStage(targetStage);
          return;
        }
        event.preventDefault();
        syncPlayPricingVideo(targetStage, { keepTime: pricingTransitioning });
        playPricingTransition(targetStage);
      });
    }

    function bindPricingCarouselTouch() {
      if (!pricingScene || pricingCarouselScrollBound) return;
      pricingCarouselScrollBound = true;

      if (pricingTouchOverlay) {
        var overlayPointerId = null;
        function pointerAsTouchEvent(event) {
          var point = { clientX: event.clientX, clientY: event.clientY };
          return {
            touches: [point],
            changedTouches: [point],
            cancelable: event.cancelable,
            preventDefault: function () {
              if (event.cancelable) event.preventDefault();
            }
          };
        }
        pricingTouchOverlay.addEventListener('touchstart', function (event) {
          if (overlayPointerId !== null) return;
          onPricingOverlayTouchStart(event);
        }, { passive: true });
        pricingTouchOverlay.addEventListener('touchmove', function (event) {
          if (overlayPointerId !== null) return;
          onPricingOverlayTouchMove(event);
        }, { passive: true });
        pricingTouchOverlay.addEventListener('touchend', function (event) {
          if (overlayPointerId !== null) return;
          onPricingOverlayTouchEnd(event);
        }, { passive: true });
        pricingTouchOverlay.addEventListener('touchcancel', function (event) {
          if (overlayPointerId !== null) return;
          onPricingOverlayTouchEnd(event);
        }, { passive: true });

        pricingTouchOverlay.addEventListener('pointerdown', function (event) {
          if (event.pointerType === 'touch') return;
          if (overlayPointerId !== null) return;
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          overlayPointerId = event.pointerId;
          try { pricingTouchOverlay.setPointerCapture(event.pointerId); } catch (eCap) {}
          onPricingOverlayTouchStart(pointerAsTouchEvent(event));
        });
        pricingTouchOverlay.addEventListener('pointermove', function (event) {
          if (event.pointerType === 'touch') return;
          if (overlayPointerId !== event.pointerId) return;
          onPricingOverlayTouchMove(pointerAsTouchEvent(event));
        });
        function onOverlayPointerUp(event) {
          if (event.pointerType === 'touch') return;
          if (overlayPointerId !== event.pointerId) return;
          overlayPointerId = null;
          onPricingOverlayTouchEnd(pointerAsTouchEvent(event));
        }
        pricingTouchOverlay.addEventListener('pointerup', onOverlayPointerUp);
        pricingTouchOverlay.addEventListener('pointercancel', onOverlayPointerUp);
      }

      bindPricingFeaturesExpand();

      if (pricingCarousel) {
        pricingCarousel.addEventListener(
          'scroll',
          function () {
            if (pricingCarouselProgrammaticScroll) return;
            scheduleSyncPricingCarouselMobilePreview();
          },
          { passive: true }
        );
      }

      function onPricingCarouselViewportChange() {
        if (pricingZoneTouchAxis === 'x') {
          invalidatePricingCarouselCentersCache();
          return;
        }
        var keepPeekStage = null;
        if (isPricingMobileCarousel() && pricingVisible) {
          keepPeekStage = getPricingCarouselCenteredStage();
        }
        invalidatePricingCarouselCentersCache();
        syncPricingTouchCapture();
        if (isPricingMobileCarousel() && pricingVisible) {
          syncPricingCarouselHintsLayout();
          jumpPricingCarouselToStage(keepPeekStage || currentPricingStage);
          syncPricingFeaturesOverflow();
        } else {
          clearPricingCarouselPreviewClasses();
          resetPricingCarouselBgPan();
          if (pricingVisible) {
            requestAnimationFrame(function () {
              syncPricingFeaturesOverflow();
            });
          }
        }
      }

      window.addEventListener('resize', onPricingCarouselViewportChange, { passive: true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', onPricingCarouselViewportChange, { passive: true });
      }

      syncPricingTouchCapture();
    }

    if (pricingScene) {
      pricingScene.addEventListener('transitionend', onPricingSceneTransitionEnd);
    }

    bindPricingFeaturesExpand();
    bindPricingFeaturesWheelPassThrough();
    bindPricingCardClicks();
    bindPricingCarouselTouch();
    var bootStage =
      sessionResumeS2b && sessionResumeS2b.pricingStage >= 1 && sessionResumeS2b.pricingStage <= 3
        ? sessionResumeS2b.pricingStage
        : 2;
    setPricingStage(bootStage, { skipSequence: true });
    maybeApplyS2bSessionResume();
    if (bootStage !== 2 && window.mojeSessionResume && (window.mojeSessionResume.active || window.mojeSessionResume.restoring)) {
      dispatchChangeMistColor(bootStage);
      dispatchPricingPlanChanged(bootStage);
    }

    window.addEventListener('scroll', onBackgroundScrollActivity, { passive: true });
    window.addEventListener('scroll', function () {
      if (pricingTransitioning) {
        pinTerraformScroll();
        return;
      }
      if (pendingAutoplayFromNav) {
        tryStartPendingAutoplay();
        if (autoplayPlaying) return;
      }
      if (autoplayPlaying) {
        onAutoplayLockScroll();
        return;
      }
      if (pricingFlingStopActive) {
        enforcePricingFlingLock();
        return;
      }
      requestTick();
      queueDockAnchor(localScroll());
      window.__mojePerf = window.__mojePerf || {};
      window.__mojePerf.canvas = true;
      clearTimeout(window.__mojePerf._canvasOff);
      window.__mojePerf._canvasOff = setTimeout(function () { window.__mojePerf.canvas = false; }, 150);
    }, { passive: true });
    function markWeakFinger() {
      if (!IS_WEAK_MOBILE || !defaultSequenceFullyReady()) return;
      if (!s2bCanvasInView()) return;
      weakTouchUntil = Date.now() + 200;
    }
    window.addEventListener('touchstart', markWeakFinger, { passive: true });
    window.addEventListener('touchmove', markWeakFinger, { passive: true });
    window.addEventListener('touchend', function () {
      if (!IS_WEAK_MOBILE) return;
      weakTouchUntil = Date.now() + 200;
      setTimeout(function () {
        scheduleSeqLoadPump();
        pumpWeakShrink();
      }, 200);
    }, { passive: true });
    window.addEventListener('touchcancel', function () {
      if (!IS_WEAK_MOBILE) return;
      weakTouchUntil = Date.now() + 200;
      setTimeout(function () {
        scheduleSeqLoadPump();
        pumpWeakShrink();
      }, 200);
    }, { passive: true });
    window.addEventListener('scrollend', function () {
      if (!pendingAutoplayFromNav) return;
      pendingAutoplayScrollEnded = true;
      tryStartPendingAutoplay();
    }, { passive: true });
    if (typeof IntersectionObserver === 'function' && root) {
      new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].isIntersecting) return;
        if (pricingFlingFreezeRaf) {
          cancelAnimationFrame(pricingFlingFreezeRaf);
          pricingFlingFreezeRaf = 0;
        }
        if (pricingCarouselScrollAnimRaf) {
          cancelAnimationFrame(pricingCarouselScrollAnimRaf);
          pricingCarouselScrollAnimRaf = null;
          pricingCarouselProgrammaticScroll = false;
        }
        unfreezeDocumentScrollForPricingFling();
      }, { root: null, rootMargin: '0px', threshold: 0 }).observe(root);
    }

    window.addEventListener('wheel', onPricingWheel, { passive: true });
    window.addEventListener('touchstart', onPricingTouchStart, { passive: true });
    window.addEventListener('touchmove', onPricingTouchMove, { passive: true });
    window.addEventListener('touchend', onPricingTouchEnd, { passive: true });
    window.addEventListener('touchcancel', onPricingTouchEnd, { passive: true });

    function dropSequenceStore(store) {
      if (!store) return;
      var w;
      for (w = seqLoadQueue.length - 1; w >= 0; w -= 1) {
        if (seqLoadQueue[w].store === store) seqLoadQueue.splice(w, 1);
      }
      var list = store.images || [];
      var i;
      for (i = 0; i < list.length; i += 1) {
        var im = list[i];
        if (!im || im === orientHandoffImg) continue;
        if (!im.complete && im.__s2bFinish) seqLoadInFlight = Math.max(0, seqLoadInFlight - 1);
        im.__s2bFinish = null;
        im.__s2bEpoch = -1;
        im.onload = null;
        im.onerror = null;
        try { im.removeAttribute('src'); } catch (eDrop) {}
        list[i] = undefined;
      }
      store.loadedCount = 0;
      store.images = [];
    }

    function releaseInactiveOrientation(keepWide) {
      abortBackgroundVideoLoads();
      silentVideoBusy = false;
      if (silentPhase === 'A' || silentPhase === 'D' || silentPhase === 'images') silentPhase = '';
      videoPlanIndex = 0;
      var keys = Object.keys(sequenceStore);
      var k;
      for (k = 0; k < keys.length; k += 1) {
        var st = sequenceStore[keys[k]];
        if (!st) continue;
        var mobilePack = st.packHint === 'm' || st.packHint === 'mobile' || String(st.key).slice(-2) === ':m';
        if (keepWide === !mobilePack) continue;
        dropSequenceStore(st);
        delete sequenceStore[keys[k]];
      }
      if (phase1StoreKey && !sequenceStore[phase1StoreKey]) phase1StoreKey = '';
      var dock = terraformDock || document.getElementById('moje-s2b-terraform-dock-' + sectionId);
      var vids = dock ? dock.querySelectorAll('video') : [];
      var vi;
      for (vi = 0; vi < vids.length; vi += 1) {
        if (pricingTransitioning && vids[vi] === pricingVideo) continue;
        releaseTerraformBuffer(vids[vi]);
      }
      markTerraformQueueWaiting();
    }

    function paintOrientationHandoff() {
      if (!orientHandoffImg || !orientHandoffImg.naturalWidth) return;
      resizeCanvas();
      drawCover(orientHandoffImg, null);
      if (canvas) {
        canvas.classList.remove('moje-s2b__canvas--awaiting-first');
        canvas.classList.add('moje-s2b__canvas--visible');
      }
    }

    function signalOrientActiveDone() {
      if (typeof window.mojeOrientActiveDone === 'function') window.mojeOrientActiveDone('s2b');
    }

    function watchOrientActiveCard(stage, epoch) {
      if (epoch !== orientEpoch) return;
      if (stageFramesSettled(stage)) {
        signalOrientActiveDone();
        return;
      }
      setTimeout(function () { watchOrientActiveCard(stage, epoch); }, 180);
    }

    /* Širokoúhlý (nebo zpět portrait) pack jen pro zvolenou kartu. Zbytek až po orient-queue. */
    function beginOrientationActiveLoad(epoch) {
      if (epoch !== orientEpoch) return;
      var stage = resolveSequenceStage(currentPricingStage || activeSequenceStage || 2);
      activeSequenceStage = stage;
      phase1Stage = stage;
      activeSequenceBackgroundArmed = true;
      sequenceFramesUnlocked = true;
      var progress = maxFrameIndex > 0 ? currentFrameIndex / maxFrameIndex : 0;
      var store = getSequenceStore(stage);
      if (store && store.key) phase1StoreKey = store.key;
      bindSequenceState(stage);
      var center = frameIndexForProgress(progress);
      currentFrameIndex = center;
      paintTargetIndex = center;
      enqueueFrameLoad(store, center, 340);
      var i;
      for (i = 1; i <= 6; i += 1) {
        enqueueFrameLoad(store, center - i, 320 - i);
        enqueueFrameLoad(store, center + i, 300 - i);
      }
      enqueueStageWave(stage, 1, 140);
      enqueueStageWave(stage, 2, 110);
      enqueueStageWave(stage, 3, 90);
      orientHydrateActiveOnly = true;
      hydrateStageImagesForViewport();
      pumpSeqLoadQueueNow();
      paintOrientationHandoff();
      if (!frameCanPaint(center) && orientHandoffImg) paintOrientationHandoff();
      watchOrientActiveCard(stage, epoch);
    }

    function onMojeOrientStop() {
      orientSwapActive = true;
      if (seoQuietTimer) {
        clearTimeout(seoQuietTimer);
        seoQuietTimer = 0;
      }
      orientHandoffImg = null;
      var hi;
      for (hi = currentFrameIndex; hi >= 0; hi -= 1) {
        if (images[hi] && images[hi].naturalWidth) {
          orientHandoffImg = images[hi];
          break;
        }
      }
      orientEpoch += 1;
      orientHydrateActiveOnly = true;
      syncWideMediaClass();
      releaseInactiveOrientation(useWideMediaAssets());
      lastMediaPackId = useWideMediaAssets() ? 'd' : 'm';
      paintOrientationHandoff();
    }

    function onMojeOrientActive(event) {
      var ids = event && event.detail && event.detail.ids;
      var listed = !ids || !ids.length;
      var i;
      var mine = listed;
      if (!mine && ids) {
        for (i = 0; i < ids.length; i += 1) if (ids[i] === 's2b') mine = true;
      }
      if (!mine || !s2bSectionIntersectsViewport()) {
        signalOrientActiveDone();
        return;
      }
      beginOrientationActiveLoad(orientEpoch);
    }

    function onMojeOrientQueue() {
      orientSwapActive = false;
      orientHydrateActiveOnly = false;
      hydrateStageImagesForViewport();
      var stage = resolveSequenceStage(currentPricingStage || activeSequenceStage || 2);
      if (!stageFramesSettled(stage)) {
        sequenceFramesUnlocked = true;
        enqueueStageWave(stage, 1, 100);
        enqueueStageWave(stage, 2, 80);
        enqueueStageWave(stage, 3, 60);
      }
      if (!bgQueueStarted) {
        bgQueueStarted = true;
        if (seoQuietTimer) {
          clearTimeout(seoQuietTimer);
          seoQuietTimer = 0;
        }
      }
      beginSilentImages();
    }

    /*
     * Reálná rotace (mobil ↔ šířka): druhý pack se stahuje až po ustálení orientace.
     * Než dorazí nový snímek, na plátně zůstane jeden handoff snímek starého packu.
     */
    function reloadSequencePackIfNeeded() {
      var nextStore = getSequenceStore(activeSequenceStage);
      if (nextStore.images === images) return false;
      var progress = maxFrameIndex > 0 ? currentFrameIndex / maxFrameIndex : 0;
      var prevImg = null;
      var k;
      for (k = Math.min(maxFrameIndex, currentFrameIndex); k >= 0; k -= 1) {
        if (images[k] && images[k].complete && images[k].naturalWidth) {
          prevImg = images[k];
          break;
        }
      }
      bindSequenceState(activeSequenceStage);
      lastDrawnIndex = -1;
      currentFrameIndex = Math.max(0, Math.min(maxFrameIndex, Math.round(progress * maxFrameIndex)));
      var fromEnd = currentFrameIndex > (maxFrameIndex * 0.5);
      loadAllFrames({ fromEnd: fromEnd });
      /* Nejdřív okolí aktuálního snímku, pak zbytek v pořadí od začátku / od konce. */
      var st = getSequenceStore(activeSequenceStage);
      var lo = Math.max(0, currentFrameIndex - 6);
      var hi = Math.min(maxFrameIndex, currentFrameIndex + 24);
      for (k = lo; k <= hi; k += 1) enqueueFrameLoad(st, k, 260 - Math.abs(k - currentFrameIndex));
      pumpSeqLoadQueue();
      if (prevImg && !frameCanPaint(currentFrameIndex)) {
        resizeCanvas();
        drawCover(prevImg, null);
      }
      return true;
    }

    function applyMediaPackForViewport() {
      var wasWide = !!(root && root.classList.contains('moje-s2b--wide-media'));
      syncWideMediaClass();
      var isWide = !!(root && root.classList.contains('moje-s2b--wide-media'));
      pricingMediaAspect = useWideMediaAssets() ? 16 / 9 : 9 / 16;
      var packId = useWideMediaAssets() ? 'd' : 'm';
      if (packId !== lastMediaPackId) {
        lastMediaPackId = packId;
        DECODE_AHEAD = isMobileViewport() ? 12 : 24;
        /* Samotné stažení nového packu řídí moje:orient-* až po 500 ms. */
      }
      applyAdaptiveDomImages();
      warmPricingStageImages();
      if (typeof syncPricingTouchCapture === 'function') syncPricingTouchCapture();
      if (typeof clearPricingCarouselPreviewClasses === 'function') clearPricingCarouselPreviewClasses();
      if (!isPricingMobileCarousel() && typeof resetPricingCarouselBgPan === 'function') {
        resetPricingCarouselBgPan();
      }
      if (pricingVisible) {
        requestAnimationFrame(function () {
          if (wasWide !== isWide) collapseAllPricingFeatures(true);
          else syncPricingFeaturesOverflow();
        });
      }
    }

    function onViewportChange() {
      syncWideMediaClass();
      updateMetrics({
        refreshPinStart: true,
        force: Date.now() >= ignoreMetricsUntil
      });
      resizeCanvas();
      pricingMediaAspect = useWideMediaAssets() ? 16 / 9 : 9 / 16;
      applyAdaptiveDomImages();
      warmPricingStageImages();
      lastDrawnIndex = -1;
      paintFrame(currentFrameIndex);
      syncIntroLayout();
      applySectionHeight();
      cacheScrollLayout();
      requestTick();
      if (mediaPackSyncTimer) clearTimeout(mediaPackSyncTimer);
      mediaPackSyncTimer = setTimeout(function () {
        mediaPackSyncTimer = 0;
        applyMediaPackForViewport();
        lastDrawnIndex = -1;
        paintFrame(currentFrameIndex);
        syncIntroLayout();
        applySectionHeight();
        requestTick();
      }, 120);
    }

    window.addEventListener('resize', onViewportChange, { passive: true });
    window.addEventListener('orientationchange', function () {
      syncWideMediaClass();
      setTimeout(onViewportChange, 280);
    }, { passive: true });
    document.addEventListener('moje:orient-stop', onMojeOrientStop);
    document.addEventListener('moje:orient-active', onMojeOrientActive);
    document.addEventListener('moje:orient-queue', onMojeOrientQueue);
    try {
      var oriMq = window.matchMedia('(orientation: landscape)');
      var onOriMq = function () {
        syncWideMediaClass();
        onViewportChange();
      };
      if (oriMq && typeof oriMq.addEventListener === 'function') oriMq.addEventListener('change', onOriMq);
      else if (oriMq && typeof oriMq.addListener === 'function') oriMq.addListener(onOriMq);
    } catch (eOriMq) {}

    document.addEventListener('shopify:section:load', function (evt) {
      if (!evt.detail || evt.detail.sectionId !== sectionId) return;
      updateMetrics({ refreshPinStart: true });
      requestTick();
    });

    document.addEventListener('shopify:section:unload', function (evt) {
      if (!evt.detail || evt.detail.sectionId !== sectionId) return;
      unlockAutoplayScroll();
      if (scrollHintEl && scrollHintEl.parentNode) {
        scrollHintEl.parentNode.removeChild(scrollHintEl);
      }
      if (seqMouseEl && seqMouseEl.parentNode) {
        seqMouseEl.parentNode.removeChild(seqMouseEl);
      }
    });

    updateMetrics({ refreshPinStart: true });
    resizeCanvas();
    cacheScrollLayout();
    bindSequenceState(currentPricingStage || 2);
    syncIntroPhase();
    syncWideMediaClass();
    applyAdaptiveDomImages();
    syncIntroLayout();
    holdPipelineForDefaultSequence();
    s2bEntryBaselineSet = true;
    s2bStartedOutside = !s2bSectionIntersectsViewport();
    lastBgScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    armTerraformProximityWarm();
    bindTerraformIntent();
    sequenceSwitchReady = true;
    function startDefaultSequenceAfterHero() {
      window.__mojeLaserHeroReady = true;
      beginDefaultSequenceLoad();
    }
    document.addEventListener('skyweb:loaded', function () {
      window.__mojeS2bAutoplayAllowed = true;
      if (!defaultSequenceFullyReady()) pumpSeqLoadQueueNow();
      requestTick();
    });
    beginDefaultSequenceLoad();
    requestTick();

    bindActiveIntroLoad();
    requestAnimationFrame(function () {
      syncIntroLayout();
      applySectionHeight();
    });
    mountScrollHint();
    syncScrollHint();
    syncSeqMouseHint();

    /* Návrat na tab: cache prohlížeče mohla dekódy uvolnit → znovu nahřát okno kolem aktuálního snímku. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden || document.visibilityState === 'hidden') {
        resetDecodeWindow();
        return;
      }
      syncDecodeWindow(currentFrameIndex, true);
    });

    if (typeof IntersectionObserver === 'function') {
      var vis = new IntersectionObserver(function (entries) {
        var i;
        for (i = 0; i < entries.length; i += 1) {
          if (entries[i].isIntersecting) {
            holdPipelineForDefaultSequence();
            beginDefaultSequenceLoad();
            requestTick();
          }
        }
        syncScrollHint();
        syncSeqMouseHint();
      }, { rootMargin: '240px 0px 240px 0px' });
      vis.observe(root);
    }

    window.__mojeS2bWantsIntroAutoplay = function () {
      return !autoplayConsumed && !autoplayPlaying;
    };

    window.__mojeS2bIntroAutoplayActive = function () {
      return !autoplayConsumed;
    };

    window.__mojeS2bQueueAfterAutoplay = function (y) {
      var next = Number(y);
      if (autoplayConsumed || !Number.isFinite(next) || next <= 8) return false;
      pendingContinueAfterAutoplayY = next;
      return true;
    };

    window.__mojeS2bPauseRangeY = function () {
      try {
        refreshPinStart(true);
        return {
          start: bufferStartY(),
          end: pricingDockY()
        };
      } catch (ePauseY) {
        return { start: 0, end: 0 };
      }
    };

    window.__mojeS2bSequenceRangeY = function () {
      try {
        refreshPinStart(true);
        return {
          start: pinStartY,
          end: sequenceEndY()
        };
      } catch (eSeqY) {
        return { start: 0, end: 0 };
      }
    };

    window.__mojeS2bPricingScrollY = function () {
      try {
        refreshPinStart(true);
        return pricingDockY();
      } catch (ePriceY) {
        return 0;
      }
    };

    function getScrollYForCheckpointTarget(target) {
      refreshPinStart(true);
      if (!(pinStartY > 8)) return null;
      if (target === 'start' || target === 'sequence') return pinStartY;
      return pricingDockY();
    }

    function beginExternalScroll(durationMs) {
      var ms = Math.max(5200, Number(durationMs) || 5200);
      consumeAutoplayWithoutPlay({ skipContinue: true });
      markProgrammaticNav(ms + 400);
      hideLoader();
      return ms;
    }

    function finishExternalCheckpoint(target) {
      consumeAutoplayWithoutPlay({ skipContinue: true });
      refreshPinStart(true);
      var y = getScrollYForCheckpointTarget(target || 'pricing');
      if (Number.isFinite(y) && y > 8) {
        setScrollY(y);
        lastScrollYForDir = y;
      }
      if (journey === 'pricing' && pricingVisible) {
        applyMistProgress(0);
        markProgrammaticNav(480);
        return;
      }
      enterPricing({ snap: true });
      markProgrammaticNav(480);
    }

    function handleExternalCheckpointNavigation(detail) {
      var target = (detail && detail.target) || 'pricing';
      var endY = getScrollYForCheckpointTarget(target);
      var duration = Math.max(5200, Number(detail && detail.duration) || 5200);
      consumeAutoplayWithoutPlay({ skipContinue: true });
      markProgrammaticNav(duration + 400);
      if (!Number.isFinite(endY) || endY <= 8) return;
      skipAutoplayForProgrammaticScroll(endY, { smooth: false, duration: duration });
    }

    function markS2bNavReady() {
      if (root) root.setAttribute('data-s2b-nav-ready', '1');
      window.__mojeS2bScrollApi = {
        sectionId: sectionId,
        getScrollYForCheckpoint: getScrollYForCheckpointTarget,
        beginExternalScroll: beginExternalScroll,
        finishCheckpoint: finishExternalCheckpoint,
        consumeAutoplay: consumeAutoplayWithoutPlay,
        wantsIntroAutoplay: function () {
          return !autoplayConsumed && !autoplayPlaying;
        },
        introAutoplayActive: function () {
          return !autoplayConsumed;
        },
        queueAfterAutoplay: function (y) {
          var next = Number(y);
          if (autoplayConsumed || !Number.isFinite(next) || next <= 8) return false;
          pendingContinueAfterAutoplayY = next;
          return true;
        },
        navigate: handleExternalCheckpointNavigation
      };
      try {
        document.dispatchEvent(new CustomEvent('moje:s2b-nav-ready', { detail: { sectionId: sectionId } }));
      } catch (eNavReady) {}
    }

    markS2bNavReady();

    document.addEventListener('visibilitychange', function () {
      if (document.hidden || document.visibilityState === 'hidden') {
        persistS2bSession();
        return;
      }
      lastDrawnIndex = -1;
      requestTick();
      if (pricingLocked || journey === 'pricing') {
        showPricingVisual();
        scheduleSnapPricingCarouselToActiveCard();
      }
    });
    document.addEventListener('moje:session-soft-resume', function () {
      lastDrawnIndex = -1;
      requestTick();
      if (pricingLocked || journey === 'pricing') {
        showPricingVisual();
        scheduleSnapPricingCarouselToActiveCard();
      }
    });
    document.addEventListener('moje:session-resume-scrolled', function () {
      setTimeout(maybeApplyS2bSessionResume, 40);
      setTimeout(maybeApplyS2bSessionResume, 350);
    });
    if (window.mojeSessionResume && window.mojeSessionResume.active) {
      setTimeout(maybeApplyS2bSessionResume, 60);
      setTimeout(maybeApplyS2bSessionResume, 400);
      setTimeout(maybeApplyS2bSessionResume, 1000);
    }

    document.addEventListener('moje:programmatic-scroll', function (evt) {
      var y = evt && evt.detail ? evt.detail.y : NaN;
      var smooth = !(evt && evt.detail && evt.detail.smooth === false);
      var duration = evt && evt.detail ? evt.detail.duration : undefined;
      var playAutoplay = !!(evt && evt.detail && evt.detail.playAutoplay);
      skipAutoplayForProgrammaticScroll(y, {
        smooth: smooth,
        duration: duration,
        playAutoplay: playAutoplay,
        continueAfterAutoplayY: evt && evt.detail ? evt.detail.continueAfterAutoplayY : undefined
      });
    });

    function mojeS2bDebugOn() {
      try {
        return /(?:\?|&)debug=1(?:&|$)/.test(window.location.search || '');
      } catch (eDebug) {
        return false;
      }
    }

    var debugHudEl = null;
    var debugHudRenderAt = 0;
    var debugHudTimer = 0;
    var perfFps = 60;
    var perfFpsMin = 60;
    var perfFpsSampled = false;
    var perfLastLag = 0;
    var perfMaxLag = 0;
    var perfStalls = [];
    var perfGpuNotes = [];
    var perfArmed = false;

    function perfSectionName() {
      var vh = window.innerHeight || 0;
      var laser = document.querySelector('.laser-section-wrapper');
      if (laser) {
        var laserRect = laser.getBoundingClientRect();
        if (laserRect.bottom > 0 && laserRect.top < vh) return 'Moje-laser-video';
      }
      if (s2bSectionIntersectsViewport()) return 'Moje-s2b';
      var info = document.querySelector('[id^="info-section-"]');
      if (info) {
        var infoRect = info.getBoundingClientRect();
        if (infoRect.bottom > 0 && infoRect.top < vh) return 'Moje-info';
      }
      return 'stránka';
    }

    function perfWhy() {
      var bits = [];
      var perf = window.__mojePerf || {};
      if (perf.boot) bits.push('Start/Hydratace stránky');
      if (perf.fetchVideo) bits.push('fetch() videa do cache');
      if (perf.decoding) bits.push('img.decode()');
      if (seqLoadInFlight > 0 || seqLoadQueue.length > 0) bits.push('Stahování ve frontě');
      if (perf.canvas) bits.push('Scroll Canvasu');
      if (perf.dom) bits.push('Překreslování DOMu');
      var playing = !!pricingTransitioning;
      if (!playing) {
        var vids = document.querySelectorAll('video');
        var vi;
        for (vi = 0; vi < vids.length; vi += 1) {
          if (!vids[vi].paused && vids[vi].readyState >= 2) {
            playing = true;
            break;
          }
        }
      }
      if (playing) bits.push('Přehrávání videa');
      return bits.length ? bits.join(' + ') : 'neznámé';
    }

    function pushPerfStall(ms) {
      var n = Math.round(ms);
      if (n < 80) return;
      perfStalls.push({ ms: n, section: perfSectionName(), why: perfWhy() });
      perfStalls.sort(function (a, b) { return b.ms - a.ms; });
      if (perfStalls.length > 3) perfStalls.length = 3;
    }

    function clearBootFromStalls() {
      window.__mojePerf = window.__mojePerf || {};
      window.__mojePerf.boot = false;
      var i;
      for (i = 0; i < perfStalls.length; i += 1) {
        var why = String(perfStalls[i].why || '');
        why = why.replace(/\s*\+\s*Start\/Hydratace stránky/g, '').replace(/Start\/Hydratace stránky\s*\+\s*/g, '').replace(/Start\/Hydratace stránky/g, '');
        perfStalls[i].why = why.trim() || 'neznámé';
      }
    }
    document.addEventListener('moje:loading-done', clearBootFromStalls);
    document.addEventListener('skyweb:loaded', clearBootFromStalls);

    function noteInputLag(event) {
      if (!mojeS2bDebugOn() || !event) return;
      var lag = performance.now() - event.timeStamp;
      if (!isFinite(lag) || lag < 0 || lag > 4000) return;
      perfLastLag = Math.round(lag);
      if (perfLastLag > perfMaxLag) perfMaxLag = perfLastLag;
    }

    function fpsColor(value) {
      if (value >= 50) return '#7dffb3';
      if (value >= 25) return '#ffd56a';
      return '#ff5c5c';
    }

    function nodeLabel(el) {
      if (!el) return 'prvek';
      var id = el.id ? '#' + el.id : '';
      var cls = '';
      if (el.className && typeof el.className === 'string') {
        cls = '.' + el.className.trim().split(/\s+/).slice(0, 2).join('.');
      }
      return (el.tagName || 'el').toLowerCase() + id + cls;
    }

    function scanGpuBrakes() {
      perfGpuNotes = [];
      var nodes = document.body ? document.body.querySelectorAll('*') : [];
      var blurNames = [];
      var backNames = [];
      var vh = window.innerHeight || 0;
      var limit = nodes.length;
      var i;
      function fxOn(style) {
        if (!style) return { back: false, blur: false };
        var back = style.backdropFilter || style.webkitBackdropFilter || 'none';
        var filter = style.filter || 'none';
        return { back: back !== 'none', blur: filter.indexOf('blur') !== -1 };
      }
      for (i = 0; i < limit; i += 1) {
        var el = nodes[i];
        if (el.closest && el.closest('[data-moje-s2b-debug]')) continue;
        var rect;
        try { rect = el.getBoundingClientRect(); } catch (eRect) { continue; }
        if (!(rect.bottom > 0 && rect.top < vh)) continue;
        var hit = { back: false, blur: false };
        var pseudo;
        var style;
        for (pseudo = 0; pseudo < 3; pseudo += 1) {
          try { style = window.getComputedStyle(el, pseudo === 0 ? null : (pseudo === 1 ? '::before' : '::after')); } catch (eStyle) { continue; }
          var part = fxOn(style);
          if (part.back) hit.back = true;
          if (part.blur) hit.blur = true;
        }
        var label = nodeLabel(el);
        if (hit.back && backNames.length < 8) backNames.push(label);
        if (hit.blur && blurNames.length < 8) blurNames.push(label);
      }
      if (backNames.length) perfGpuNotes.push('backdrop-filter (' + backNames.length + '): ' + backNames.join(', '));
      if (blurNames.length) perfGpuNotes.push('filter: blur (' + blurNames.length + '): ' + blurNames.join(', '));
      if ((window.innerWidth || 0) < 768 && canvas && (canvas.width > 1000 || canvas.height > 1000)) {
        perfGpuNotes.push('Canvas ' + canvas.width + '×' + canvas.height + ' px (> 1000)');
      }
      refreshRafNote();
      if (!backNames.length && !blurNames.length) perfGpuNotes.unshift('bez blur / backdrop-filter');
    }

    function armPerfProfiler() {
      if (perfArmed || window.__mojeDebugHudTimer) return;
      perfArmed = true;
      window.addEventListener('touchstart', noteInputLag, { passive: true });
      window.addEventListener('touchmove', noteInputLag, { passive: true });
      window.addEventListener('scroll', noteInputLag, { passive: true });
      if (typeof window.PerformanceObserver === 'function') {
        try {
          var longTasks = new PerformanceObserver(function (list) {
            list.getEntries().forEach(function (entry) {
              if (entry && entry.duration >= 50) pushPerfStall(entry.duration);
            });
          });
          longTasks.observe({ type: 'longtask', buffered: true });
        } catch (eLong) {}
      }
      window.__mojeDebugHudTimer = setInterval(function () {
        try { syncDebugHud(); } catch (eHudTimer) {}
      }, 300);
      if (!window.__mojeGpuScanTimer) {
        window.__mojeGpuScanTimer = setInterval(function () {
          try { scanGpuBrakes(); } catch (eGpuScan) {}
        }, 1000);
        setTimeout(function () {
          try { scanGpuBrakes(); } catch (eGpuNow) {}
        }, 400);
      }
    }

    function ensureDebugHud() {
      if (!mojeS2bDebugOn()) return;
      var existing = document.querySelectorAll('[data-moje-s2b-debug]');
      if (existing.length) {
        debugHudEl = existing[0];
        var extra;
        for (extra = 1; extra < existing.length; extra += 1) {
          if (existing[extra].parentNode) existing[extra].parentNode.removeChild(existing[extra]);
        }
        if (!window.__mojeDebugHudTimer) armPerfProfiler();
        return;
      }
      debugHudEl = document.createElement('div');
      debugHudEl.setAttribute('data-moje-s2b-debug', '1');
      debugHudEl.style.cssText = 'position:fixed;left:8px;bottom:8px;z-index:2147483000;max-width:min(92vw,420px);padding:8px 10px;background:rgba(12,12,28,0.92);color:#d7ffe8;font:10px/1.35 ui-monospace,Consolas,monospace;pointer-events:none;white-space:pre-wrap;word-break:break-word;border:1px solid rgba(0,255,170,0.35);';
      (document.body || document.documentElement).appendChild(debugHudEl);
      armPerfProfiler();
    }

    function loadedFramesForCard(stage) {
      var id = stage === 1 || stage === 3 ? stage : 2;
      var total = expectedFrameCount(id);
      var loaded = 0;
      var store = null;
      try { store = sequenceStore[sequenceAssetKey(id)]; } catch (eStore) { store = null; }
      if (store && store.frameUrls && store.frameUrls.length) {
        total = store.frameUrls.length;
        var i;
        for (i = 0; i < total; i += 1) {
          if (frameReady(store.images[i])) loaded += 1;
        }
        var cacheN = store.cacheCount || 0;
        if (mobileKeepsOneCard() && loaded === 0 && cacheN > 0) {
          return cacheN + ' / ' + total + ' (v cache)';
        }
      }
      return loaded + ' / ' + total;
    }

    function fmtBoot(ms) {
      if (ms == null || !isFinite(ms)) return 'čeká se…';
      var n = Math.max(0, Math.round(ms));
      if (n < 1000) return n + ' ms';
      return n + ' ms / ' + (n / 1000).toFixed(n < 10000 ? 2 : 1) + ' s';
    }

    function terraformDebugLine(key) {
      var label = key.replace('-', '->');
      var rec = (mojeMediaBag().terraform || {})[key] || { state: 'wait' };
      if (rec.state === 'loading') return label + '  ⏳ Stahuje se...';
      if (rec.state === 'ready') return label + '  ✅ Staženo (připraveno v bufferu) ' + fmtBoot(rec.at);
      if (rec.state === 'cached') return label + '  ✅ Staženo v cache ' + fmtBoot(rec.at);
      if (rec.state === 'meta') return label + '  ✅ Připraveno (metadata) ' + fmtBoot(rec.at);
      if (rec.state === 'error') return label + '  ❌ Chyba / Zablokováno';
      return label + '  ⏸️ Čeká ve frontě';
    }

    function fmtBytes(n) {
      var bytes = n || 0;
      if (bytes <= 0) return '';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(bytes < 10240 ? 1 : 0) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(bytes < 10 * 1024 * 1024 ? 2 : 1) + ' MB';
    }

    function netInfo(id) {
      var watch = (mojeMediaBag().watch || {})[id] || {};
      var hits = watch.hits || 0;
      var text = 'Síť: ' + hits + 'x' + (hits >= 2 ? ' ⚠️' : '');
      var size = fmtBytes(watch.bytes || 0);
      if (size) text += ' (' + size + ')';
      if (watch.cacheHits) text += ' (z cache ✅)';
      return { text: text, warn: hits >= 2 };
    }

    function appendDebugRow(text, warn, color) {
      var row = document.createElement('div');
      row.textContent = text;
      if (color) row.style.color = color;
      else if (warn) row.style.color = '#ff5c5c';
      debugHudEl.appendChild(row);
    }

    function refreshRafNote() {
      if (!perfGpuNotes) perfGpuNotes = [];
      var kept = [];
      var i;
      for (i = 0; i < perfGpuNotes.length; i += 1) {
        if (perfGpuNotes[i].indexOf('Běžící rAF') === 0 || perfGpuNotes[i].indexOf('rAF: ') === 0) continue;
        if (perfGpuNotes[i].indexOf('rAF smyčky') !== -1 || perfGpuNotes[i].indexOf('requestAnimationFrame') !== -1) continue;
        kept.push(perfGpuNotes[i]);
      }
      perfGpuNotes = kept;
      var names = window.__mojeRafNames || {};
      var keys = [];
      var key;
      for (key in names) {
        if (names[key] > 0) keys.push(key);
      }
      perfGpuNotes.push('Běžící rAF smyčky: ' + (window.__mojeRafLive || 0));
      for (i = 0; i < keys.length; i += 1) {
        perfGpuNotes.push('rAF: ' + keys[i] + ' (' + names[keys[i]] + 'x)');
      }
    }

    function debugHudToggle(label, next) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = label;
      btn.style.cssText = 'pointer-events:auto;background:transparent;border:0;color:#7dffb3;font:inherit;cursor:pointer;padding:0 4px;';
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        if (!debugHudEl) return;
        debugHudEl.dataset.mojeMin = next;
        debugHudRenderAt = 0;
        syncDebugHud();
      });
      return btn;
    }

    function syncDebugHud() {
      if (!mojeS2bDebugOn()) return;
      try {
      var nowHud = performance.now();
      if (debugHudRenderAt && nowHud - debugHudRenderAt < 300) {
        if (!debugHudTimer) {
          debugHudTimer = setTimeout(function () {
            debugHudTimer = 0;
            try { syncDebugHud(); } catch (eHudLater) {}
          }, Math.max(0, 300 - (nowHud - debugHudRenderAt)));
        }
        return;
      }
      debugHudRenderAt = nowHud;
      ensureDebugHud();
      if (!debugHudEl) return;
      if (!perfStalls) perfStalls = [];
      if (!perfGpuNotes) perfGpuNotes = [];
      var liveFps = Number(window.__mojeLiveFps);
      if (liveFps > 0) {
        perfFps = liveFps;
        perfFpsSampled = true;
        var liveMin = Number(window.__mojeLiveFpsMin);
        if (liveMin > 0) perfFpsMin = liveMin;
      }
      refreshRafNote();
      var bag = mojeMediaBag();
      var hero = bag.hero || {};
      var heroLine = '⏳ Načítá se…';
      if (hero.state === 'ready') heroLine = '✅ Připraveno k přehrání (' + fmtBoot(hero.at) + ')';
      else if (hero.state === 'error') heroLine = '❌ Chyba / Zablokováno';
      var heroNet = netInfo('hero');
      debugHudEl.textContent = '';
      if (debugHudEl.dataset.mojeMin === '1') {
        debugHudEl.style.maxHeight = '28px';
        debugHudEl.style.overflow = 'hidden';
        var mini = document.createElement('div');
        mini.style.whiteSpace = 'nowrap';
        mini.textContent = 'FPS: ' + (perfFpsSampled ? (Number(perfFps) || 0) : 60) + ' | Smyčky: ' + (window.__mojeRafLive || 0) + ' | ';
        mini.appendChild(debugHudToggle('[ + Rozbalit ]', '0'));
        debugHudEl.appendChild(mini);
        return;
      }
      debugHudEl.style.maxHeight = '';
      debugHudEl.style.overflow = '';
      var minRow = document.createElement('div');
      minRow.appendChild(debugHudToggle('[ – Minimalizovat ]', '1'));
      debugHudEl.appendChild(minRow);
      appendDebugRow(IS_WEAK_MOBILE ? 'PROFIL: Slabý mobil (Úsporný)' : (IS_STRONG_MOBILE || (window.innerWidth || 0) > 768 ? 'PROFIL: Silný mobil / PC (Plná kvalita)' : 'PROFIL: Běžný mobil (DPR 1.25)'), false);
      appendDebugRow(cardFramePlan(1).label + ': ' + loadedFramesForCard(1), false);
      appendDebugRow(cardFramePlan(2).label + ': ' + loadedFramesForCard(2), false);
      appendDebugRow(cardFramePlan(3).label + ': ' + loadedFramesForCard(3), false);
      appendDebugRow('', false);
      appendDebugRow('DEFAULT WEB', false);
      appendDebugRow('DOMContentLoaded: ' + fmtBoot(bag.dcl), false);
      appendDebugRow('window.onload: ' + fmtBoot(bag.load), false);
      appendDebugRow('', false);
      appendDebugRow('HERO VIDEO', heroNet.warn);
      appendDebugRow(heroLine, heroNet.warn);
      appendDebugRow(heroNet.text, heroNet.warn);
      appendDebugRow('', false);
      appendDebugRow('TERRAFORM', false);
      var i;
      for (i = 0; i < TF_DEBUG_ORDER.length; i += 1) {
        var key = TF_DEBUG_ORDER[i];
        var net = netInfo(key);
        appendDebugRow(terraformDebugLine(key) + '  ' + net.text, net.warn);
      }
      appendDebugRow('', false);
      var fpsShown = perfFpsSampled ? (Number(perfFps) || 0) : 60;
      var fpsMinShown = perfFpsSampled ? (Number(perfFpsMin) || fpsShown) : 60;
      var lagLast = Number(perfLastLag) || 0;
      var lagMax = Number(perfMaxLag) || 0;
      appendDebugRow('VÝKON ZAŘÍZENÍ (PROFILER)', false);
      appendDebugRow('FPS: ' + fpsShown + '  min ' + fpsMinShown, false, fpsColor(fpsShown));
      appendDebugRow(
        'ODEZVA DOTYKU: poslední ' + lagLast + ' ms  max ' + lagMax + ' ms',
        lagMax > 150,
        lagLast > 150 || lagMax > 150 ? '#ff5c5c' : ''
      );
      appendDebugRow('POSLEDNÍ ZÁSEKY CPU', false);
      if (!perfStalls.length) appendDebugRow('žádný zásek nad 80 ms', false);
      for (i = 0; i < perfStalls.length; i += 1) {
        var stall = perfStalls[i] || {};
        appendDebugRow('🔴 Zásek ' + (Number(stall.ms) || 0) + ' ms | Sekce: ' + (stall.section || 'stránka') + ' | Běželo: ' + (stall.why || 'neznámé'), true);
      }
      appendDebugRow('GPU BRZDY', false);
      if (!perfGpuNotes.length) appendDebugRow('sken probíhá…', false);
      for (i = 0; i < perfGpuNotes.length; i += 1) {
        var gpuNote = String(perfGpuNotes[i] || '');
        appendDebugRow(gpuNote, gpuNote.indexOf('bez ') !== 0 && gpuNote.indexOf('běžící ') !== 0);
      }
      } catch (eHud) {}
    }

    document.addEventListener('moje:debug-media', syncDebugHud);
    syncDebugHud();
  }

  function bootMojeS2bSections() {
    var nodes = document.querySelectorAll('script[type="application/json"][id^="moje-s2b-config-"]');
    var i;
    for (i = 0; i < nodes.length; i += 1) {
      initMojeS2bSection(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootMojeS2bSections);
  } else {
    bootMojeS2bSections();
  }
})();
